const tests =
[
{
    "id": "3",
    "topics_id": "1",
    "code": "1.1",
    "questions": "Аль сумаар замын өргөнийг үзүүлсэн бэ?",
    "images": "/images/b/8a5e6bdbf6a382e0e463df2cb04855b9.jpg",
    "tdate": "2019-03-14 10:57:37",
    "desc": "'Зам' гэдэгт Замын хөдөлгөөний аюулгүй байдлын тухай хуулийн 3.1.4-т заасан, хөдөлгөөнд нээлттэй хучилттай буюу шороон зурвас газрыг ойлгоно (ЗХД1-ийн 1.2.15). Зорчих хэсэг, явган хүний зам, унадаг дугуйн зам, тусгаарлах зурвас, хөвөө, таримал зүлэг зэрэг замын дагуух бүх хэсгүүд 'Зам'-д хамаарна."
},
{
    "id": "4",
    "topics_id": "1",
    "code": "1.2",
    "questions": "'Зорчих хэсэг' гэж юу вэ?",
    "images": "",
    "tdate": "2019-03-14 11:08:21",
    "desc": ""
},
{
    "id": "8",
    "topics_id": "1",
    "code": "1.6",
    "questions": "Аль зурагт уулзварыг үзүүлсэн бэ?",
    "images": "/images/b/0e03bee9ea7f8caf67aa9b9670042527.jpg",
    "tdate": "2019-03-14 12:15:44",
    "desc": "А зурагт хучилттай замтай шороон зам нийлсэн гол ба туслах замын уулзварыг, Б зурагт гарцыг үзүүлжээ."
},
{
    "id": "9",
    "topics_id": "1",
    "code": "1.7",
    "questions": "Аль нь механикжсан тээврийн хэрэгсэл вэ?",
    "images": "",
    "tdate": "2019-03-14 12:18:04",
    "desc": ""
},
{
    "id": "10",
    "topics_id": "1",
    "code": "1.8",
    "questions": "'Чиглэлийн тээврийн хэрэгсэл' гэж юу вэ?",
    "images": "",
    "tdate": "2019-03-14 12:30:02",
    "desc": ""
},
{
    "id": "11",
    "topics_id": "1",
    "code": "1.9",
    "questions": "'Бүх жин' гэж юу вэ?",
    "images": "",
    "tdate": "2019-03-14 12:34:17",
    "desc": ""
},
{
    "id": "12",
    "topics_id": "1",
    "code": "1.10",
    "questions": "'Бодит жин' гэж юу вэ?",
    "images": "",
    "tdate": "2019-03-14 12:37:04",
    "desc": ""
},
{
    "id": "5",
    "topics_id": "1",
    "code": "1.3",
    "questions": "Хоёр зорчих хэсэгтэй замыг заана уу?",
    "images": "/images/b/705c17f9408aa029dc21b35af591fbf1.jpg",
    "tdate": "2019-03-14 11:15:41",
    "desc": ""
},
{
    "id": "7",
    "topics_id": "1",
    "code": "1.5",
    "questions": "Аль зурагт гол замыг үзүүлсэн бэ?",
    "images": "/images/b/1be4fecdea2733bfb8efe1b2a8ad60a4.jpg",
    "tdate": "2019-03-14 12:13:10",
    "desc": ""
},
{
    "id": "13",
    "topics_id": "1",
    "code": "1.11",
    "questions": "Аль нь замын хөдөлгөөнд оролцогч вэ?",
    "images": "/images/b/699ce982fa28962b41d8bfef44a484ae.jpg",
    "tdate": "2019-03-14 12:44:26",
    "desc": "Зам дээр ажил үүрэг гүйцэтгэж байгаа хүн (В)-ийг 'Явган зорчигч'-д тооцохгүй (ЗХД-ийн 1.2.52)."
},
{
    "id": "14",
    "topics_id": "1",
    "code": "1.12",
    "questions": "Хэнийг 'Жолооч'-д хамааруулж ойлгох вэ?",
    "images": "",
    "tdate": "2019-03-14 12:46:04",
    "desc": ""
},
{
    "id": "6",
    "topics_id": "1",
    "code": "1.4",
    "questions": "Зурагт хэдэн эгнээтэй замыг үзүүлсэн бэ?",
    "images": "/images/b/9a4eebe5707fcc41b1ba516bb9d91bf3.jpg",
    "tdate": "2019-03-14 11:17:44",
    "desc": ""
},
{
    "id": "15",
    "topics_id": "1",
    "code": "1.13",
    "questions": "Аль нь 'Үзэгдэлт хангалтгүй нөхцөл' вэ?",
    "images": "",
    "tdate": "2019-03-14 12:47:35",
    "desc": ""
},
{
    "id": "16",
    "topics_id": "1",
    "code": "1.14",
    "questions": "'Байр эзлэх' гэж юу вэ?",
    "images": "",
    "tdate": "2019-03-14 13:07:01",
    "desc": ""
},
{
    "id": "17",
    "topics_id": "1",
    "code": "1.15",
    "questions": "Аль зурагт 'Гүйцэж түрүүлэх' үйлдлийг үзүүлсэн бэ?",
    "images": "/images/b/694bbaa58d0fc13324c98d631f3c71b9.jpg",
    "tdate": "2019-03-14 13:26:15",
    "desc": "'Гүйцэж түрүүлэх' гэдэгт зөвхөн урсгал сөрж гүйцэх үйлдлийг ойлгоно (ЗХД-ийн 1.2.9)."
},
{
    "id": "18",
    "topics_id": "1",
    "code": "1.16",
    "questions": "Зурагт аль үйлдлийг үзүүлсэн бэ?",
    "images": "/images/b/f5f88d44e520f57bb62fc3cb5347eaee.jpg",
    "tdate": "2019-03-14 13:29:47",
    "desc": ""
},
{
    "id": "23",
    "topics_id": "1",
    "code": "1.19",
    "questions": "Ачаа буулгаж 15 минут зогссон бол ямар үйлдэл хийсэнд тооцогдох вэ?",
    "images": "/images/b/ffe89903f3f87d29cf0e412093b58c1f.jpg",
    "tdate": "2019-03-14 13:54:11",
    "desc": ""
},
{
    "id": "20",
    "topics_id": "1",
    "code": "1.17",
    "questions": "Аль нь 'Саадыг тойрон гарах' үйлдэл вэ?",
    "images": "",
    "tdate": "2019-03-14 13:41:02",
    "desc": ""
},
{
    "id": "24",
    "topics_id": "1",
    "code": "1.20",
    "questions": "Дараах үйлдлүүдийн аль нь 'Зайлшгүй зогсолт'-д хамаарагдах вэ?",
    "images": "",
    "tdate": "2019-03-14 14:01:34",
    "desc": ""
},
{
    "id": "22",
    "topics_id": "1",
    "code": "1.18",
    "questions": "Суудлын автомашины жолооч 'Зам тавьж өгөх' үйлдлийг зөв гүйцэтгэсэн үү?",
    "images": "/images/b/6d39557d8fa752441aeb6fe2361836b2.jpg",
    "tdate": "2019-03-14 13:42:46",
    "desc": ""
},
{
    "id": "25",
    "topics_id": "2",
    "code": "2.1",
    "questions": "'А' ангилалд аль тээврийн хэрэгсэл хамаарагдах вэ?",
    "images": "",
    "tdate": "2019-03-14 14:13:20",
    "desc": ""
},
{
    "id": "26",
    "topics_id": "2",
    "code": "2.2",
    "questions": "Мотоциклыг жолоодох эрх авч болох насны доод хязгаар хэд вэ?",
    "images": "",
    "tdate": "2019-03-14 14:16:18",
    "desc": ""
},
{
    "id": "27",
    "topics_id": "2",
    "code": "2.3",
    "questions": "'В' ангилалд чиргүүлтэй суудлын автомашин хамаарагдах уу?",
    "images": "",
    "tdate": "2019-03-14 14:19:40",
    "desc": ""
},
{
    "id": "28",
    "topics_id": "2",
    "code": "2.4",
    "questions": "'В' ангилалд ачааны автомашин хамаарагдах уу?",
    "images": "",
    "tdate": "2019-03-14 14:23:11",
    "desc": ""
},
{
    "id": "29",
    "topics_id": "2",
    "code": "2.5",
    "questions": "Бүх жин нь 3.5 тонноос бага ачааны автомашин аль ангилалд хамаарагдах вэ?",
    "images": "",
    "tdate": "2019-03-14 14:26:13",
    "desc": ""
},
{
    "id": "30",
    "topics_id": "2",
    "code": "2.6",
    "questions": "'В' ангиллын тээврийн хэрэгсэл жолоодох эрхтэй хүн бүх жин нь 3.5 тонноос бага ачааны автомашинаар чиргүүл чирч хөдөлгөөнд оролцохыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-14 14:38:21",
    "desc": "Бүх жин нь 3.5 тонноос илүүгүй ачааны автомашин нь 'В' ангилалд хамаарагдахаас гадна мөн бүх жин нь 750 кг-аас ихгүй чиргүүл чирсэн тохиолдолд ч хамаарагдсан хэвээр байна.Харин үүнээс илүү бүх жинтэй чиргүүл чирэх тохиолдолд 'ВЕ' ангиллын эрх шаардлагатай (ЗХД-ийн 2.1)."
},
{
    "id": "31",
    "topics_id": "2",
    "code": "2.7",
    "questions": "1 тонн даацын чиргүүлтэй бүх жин нь 3.5 тонноос бага ачааны автомашин аль ангилалд хамаарагдах вэ?",
    "images": "",
    "tdate": "2019-03-14 14:41:07",
    "desc": ""
},
{
    "id": "32",
    "topics_id": "2",
    "code": "2.8",
    "questions": "'ВЕ' ангилалд аль тээврийн хэрэгсэл хамаарагдах вэ?",
    "images": "",
    "tdate": "2019-03-14 14:45:52",
    "desc": ""
},
{
    "id": "33",
    "topics_id": "2",
    "code": "2.9",
    "questions": "'В' ангилалд автобус хамаарагдах уу?",
    "images": "",
    "tdate": "2019-03-14 14:53:52",
    "desc": ""
},
{
    "id": "34",
    "topics_id": "20",
    "code": "20.1",
    "questions": "Механикжсан тээврийн хэрэгслийг хатуу холбоогоор чирэх үед чирэх,чирүүлэх тээврийн хэрэгслүүдийн хоорондын зай хэдэн метр байх шаардлагатай вэ?",
    "images": "",
    "tdate": "2019-03-14 14:54:40",
    "desc": ""
},
{
    "id": "35",
    "topics_id": "2",
    "code": "2.10",
    "questions": "'В' ангиллын тээврийн хэрэгсэл жолоодох эрхтэй хүн автобус жолоодохыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-14 14:56:25",
    "desc": ""
},
{
    "id": "36",
    "topics_id": "19",
    "code": "19.1",
    "questions": "Тууш замд аль тээврийн хэрэгслийн хөдөлгөөнийг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-14 15:00:47",
    "desc": ""
},
{
    "id": "37",
    "topics_id": "19",
    "code": "19.2",
    "questions": "Тууш замд аль тээврийн хэрэгслийн хөдөлгөөнийг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-14 15:04:41",
    "desc": ""
},
{
    "id": "38",
    "topics_id": "19",
    "code": "19.3",
    "questions": "Техникийн дээд хурд нь цагт 40км-ээс илүүгүй тээврийн хэрэгслээр тууш замын хөдөлгөөнд оролцохыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-14 15:07:43",
    "desc": ""
},
{
    "id": "39",
    "topics_id": "20",
    "code": "20.2",
    "questions": "Механикжсан тээврийн хэрэгслийг зөөлөн холбоогоор чирэх үед чирэх,чирүүлэх тээврийн хэрэгслүүдийн хоорондын зай хэдэн метр байх шаардлагатай вэ?",
    "images": "",
    "tdate": "2019-03-14 15:08:19",
    "desc": ""
},
{
    "id": "40",
    "topics_id": "19",
    "code": "19.4",
    "questions": "Тууш замын энэ хэсэгт зорчих хэсгийг чөлөөлж хөвөөн дээр ухрахыг зөвшөөрөх үү?",
    "images": "/images/b/a572c0c8922261d64e6a001b4d4090aa.jpg",
    "tdate": "2019-03-14 15:10:30",
    "desc": ""
},
{
    "id": "41",
    "topics_id": "19",
    "code": "19.5",
    "questions": "Тууш замд жолоочийн аль үйлдлийг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-14 15:11:46",
    "desc": ""
},
{
    "id": "42",
    "topics_id": "19",
    "code": "19.6",
    "questions": "Тууш замд аль автомашины буцаж эргэх үйлдлийг хориглох вэ?",
    "images": "/images/b/9ee19aaf2e76c2bdc95a4b86c44ca222.jpg",
    "tdate": "2019-03-14 15:13:34",
    "desc": "Тууш замын тусгаарлах зурвасын тасархай нь замын засвар, арчлалт зэрэг технологийн зориулалтаар ашиглагдах бөгөөд шар өнгийн гэрлэн дохио ажиллуулж яваа автомашины жолооч ЗХД-ийн 20.1.г заалтыг мөрдөхгүй байж болох (ЗХД-ийн 4.3) тул зурагт үзүүлсэнээр буцаж эргэхийг зөвшөөрнө. "
},
{
    "id": "43",
    "topics_id": "19",
    "code": "19.7",
    "questions": "Суудлын автомашин жолоодож яваа тохиолдолд энэ эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/63a9c3d9443013e21fbe843c323a8f8b.jpg",
    "tdate": "2019-03-14 15:16:02",
    "desc": ""
},
{
    "id": "44",
    "topics_id": "20",
    "code": "20.3",
    "questions": "Тоормосны систем нь ажиллагаагүй болсон автомашиныг чирэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-14 15:16:31",
    "desc": ""
},
{
    "id": "45",
    "topics_id": "19",
    "code": "19.8",
    "questions": "Бусад эгнээ чөлөөгүй үед ачааны автомашин зурагт үзүүлсэн эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/ad6bac11dec736024adf7250ecfce212.jpg",
    "tdate": "2019-03-14 15:18:08",
    "desc": ""
},
{
    "id": "46",
    "topics_id": "2",
    "code": "2.11",
    "questions": "'С' ангилалд аль тээврийн хэрэгсэл хамаарагдах вэ?",
    "images": "",
    "tdate": "2019-03-14 15:19:14",
    "desc": ""
},
{
    "id": "47",
    "topics_id": "19",
    "code": "19.9",
    "questions": "Тууш замаар яваа энэ үед түр зогсох шаардлага гарвал хаана зогсохыг зөвшөөрөх вэ?",
    "images": "/images/b/a08b86487bb94d41ba52f191da2782e8.jpg",
    "tdate": "2019-03-14 15:20:25",
    "desc": ""
},
{
    "id": "48",
    "topics_id": "19",
    "code": "19.10",
    "questions": "Энд зайлшгүй зогсолт хийсэн тохиолдолд ослын дохионы гэрлээ асаах шаардлагатай юу?",
    "images": "/images/b/8bd679a9902763a8105874e14a398a29.jpg",
    "tdate": "2019-03-14 15:22:11",
    "desc": ""
},
{
    "id": "49",
    "topics_id": "2",
    "code": "2.12",
    "questions": "'В' ангиллын тээврийн хэрэгсэл жолоодох эрхтэй хүн бүх жин нь 5 тонн ачааны автомашин жолоодохыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-14 15:22:24",
    "desc": ""
},
{
    "id": "50",
    "topics_id": "2",
    "code": "2.13",
    "questions": "Зурагт үзүүлсэн автомашин аль ангилалд хамаарагдах вэ?",
    "images": "/images/b/190b55f5f2cc491c763dcc268cf4dd42.jpg",
    "tdate": "2019-03-14 15:26:45",
    "desc": ""
},
{
    "id": "51",
    "topics_id": "2",
    "code": "2.14",
    "questions": "'С1' дэд ангилалд аль автомашин хамаарагдах вэ?",
    "images": "",
    "tdate": "2019-03-14 15:29:42",
    "desc": ""
},
{
    "id": "52",
    "topics_id": "20",
    "code": "20.4",
    "questions": "Жолооны механизм нь ажиллагаагүй болсон автомашиныг чирэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-14 15:31:40",
    "desc": ""
},
{
    "id": "53",
    "topics_id": "2",
    "code": "2.15",
    "questions": "'D' ангилалд аль тээврийн хэрэгсэл хамаарагдах вэ?",
    "images": "",
    "tdate": "2019-03-14 15:32:35",
    "desc": ""
},
{
    "id": "54",
    "topics_id": "7",
    "code": "7.1",
    "questions": "Гэрлэн дохиогоор хөдөлгөөн зохицуулагдаж байгаа уулзварт жолооч аль тэмдгийн заалтыг мөрдөхгүй вэ?",
    "images": "",
    "tdate": "2019-03-14 15:34:12",
    "desc": ""
},
{
    "id": "55",
    "topics_id": "2",
    "code": "2.16",
    "questions": "Зурагт үзүүлсэн автобус аль ангилалд хамаарагдах вэ?",
    "images": "/images/b/467391fa38d2ab4b2ee0fe74e5540478.jpg",
    "tdate": "2019-03-14 15:36:16",
    "desc": ""
},
{
    "id": "56",
    "topics_id": "20",
    "code": "20.5",
    "questions": "Хатуу холбоогоор чирүүлэх автомашины аль эд анги бүрэн ажиллагаатай байх шаардлагатай вэ?",
    "images": "",
    "tdate": "2019-03-14 15:37:05",
    "desc": ""
},
{
    "id": "57",
    "topics_id": "20",
    "code": "20.6",
    "questions": "Ямар гэмтэлтэй  тээврийн хэрэгслийг зөөлөн холбоогоор чирэхийг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-14 15:42:21",
    "desc": ""
},
{
    "id": "58",
    "topics_id": "2",
    "code": "2.17",
    "questions": "'D1' дэд ангилалд аль автомашин хамаарагдах вэ?",
    "images": "",
    "tdate": "2019-03-14 15:43:53",
    "desc": ""
},
{
    "id": "59",
    "topics_id": "2",
    "code": "2.18",
    "questions": "Зурагт үзүүлсэн автомашин жолоочоос гадна 14 хүний суудалтай бол аль ангилалд хамаарагдах вэ?",
    "images": "/images/b/4774d55ff5a3e7140a5b62774c31e341.jpg",
    "tdate": "2019-03-14 15:47:20",
    "desc": "Жолоочоос гадна 8-аас илүү хүний суудалтай, хүн тээвэрлэхэд зориулсан бүх автомашин (автобус болон троллейбус) 'D' ангилалд хамаарагдана (ЗХД-ийн 2.1). Иймд зурагт үзүүлсэн 'D1' дэд ангиллын автомашин болох 14 хүний суудалтай автобус нь 'D' ангилалд мөн хамаарагдана (ЗХД-ийн 2.2)."
},
{
    "id": "60",
    "topics_id": "2",
    "code": "2.19",
    "questions": "Трактор аль ангилалд хамаарагдах вэ?",
    "images": "",
    "tdate": "2019-03-14 15:52:37",
    "desc": ""
},
{
    "id": "61",
    "topics_id": "2",
    "code": "2.20",
    "questions": "Тракторыг жолоодох эрх авч болох насны доод хязгаар хэд вэ?",
    "images": "",
    "tdate": "2019-03-14 15:54:24",
    "desc": ""
},
{
    "id": "62",
    "topics_id": "7",
    "code": "7.2",
    "questions": "Зохицуулагчийн дохиогоор хөдөлгөөний дараалал тогтоогдож байгаа уулзварт жолооч:",
    "images": "",
    "tdate": "2019-03-14 15:54:28",
    "desc": ""
},
{
    "id": "63",
    "topics_id": "7",
    "code": "7.3",
    "questions": "Уулзварыг хэрхэн нэвтрэх вэ?",
    "images": "/images/b/eb6d94219ffd423381a459bd36f82a53.jpg",
    "tdate": "2019-03-14 16:00:29",
    "desc": ""
},
{
    "id": "64",
    "topics_id": "7",
    "code": "7.4",
    "questions": "Суудлын автомашины жолооч уулзвар нэвтрэхдээ:",
    "images": "/images/b/caa1085bda14271c853b2443f0937e3c.jpg",
    "tdate": "2019-03-14 16:05:28",
    "desc": ""
},
{
    "id": "67",
    "topics_id": "7",
    "code": "7.6",
    "questions": "Хориглосон дохиогоор та хаана зогсох үүрэгтэй вэ?",
    "images": "/images/b/f25eb61dc0e50312665a232f60f66691.jpg",
    "tdate": "2019-03-14 16:17:53",
    "desc": ""
},
{
    "id": "68",
    "topics_id": "3",
    "code": "3.1",
    "questions": "Механикжсан тээврийн хэрэгслийн жолооч ямар бичиг баримттай байх үүрэгтэй вэ?",
    "images": "",
    "tdate": "2019-03-14 16:22:13",
    "desc": ""
},
{
    "id": "66",
    "topics_id": "7",
    "code": "7.5",
    "questions": "Хориглосон дохиогоор зогсох үйлдлийг аль тээврийн хэрэгслийн жолооч зөв гүйцэтгэсэн вэ?",
    "images": "/images/b/49059aea71f63cf4cb6360cef11359a7.jpg",
    "tdate": "2019-03-14 16:13:48",
    "desc": ""
},
{
    "id": "69",
    "topics_id": "7",
    "code": "7.7",
    "questions": "Аль зурагт нэмэгдэл гэрэл дохио ассан байна вэ?",
    "images": "/images/b/362d039eaa675428b441a777a0f8b00a.jpg",
    "tdate": "2019-03-14 16:28:23",
    "desc": "Нэмэгдэл гэрэл дохио нь хар дэвсгэр дээр ногоон өнгөөр гэрэлтдэг сумтай байна (А зураг). Харин  ногоон дэвсгэр дээр хар өнгийн сумтай гэрэл (Б зураг) нь үндсэн ногоон гэрэл дохио юм."
},
{
    "id": "70",
    "topics_id": "3",
    "code": "3.2",
    "questions": "Жолооч хэнд бичиг баримтаа шалгуулах үүрэгтэй вэ?",
    "images": "",
    "tdate": "2019-03-14 16:29:23",
    "desc": ""
},
{
    "id": "71",
    "topics_id": "3",
    "code": "3.3",
    "questions": "Хөдөлгөөнд оролцож явах үед ажлын тоормосны систем ажиллахгүй болсон бол хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/43e9e2929a4f473d263ac6bbaaeb64f4.jpg",
    "tdate": "2019-03-14 16:33:09",
    "desc": ""
},
{
    "id": "72",
    "topics_id": "7",
    "code": "7.8",
    "questions": "Ногоон гэрэл дээрх сум юуг илэрхийлж  байна вэ?",
    "images": "/images/b/33e6c599f703a839f576387ad8c9cc2f.jpg",
    "tdate": "2019-03-14 16:34:59",
    "desc": ""
},
{
    "id": "73",
    "topics_id": "3",
    "code": "3.4",
    "questions": "Үзэгдэлт хангалтгүй нөхцөлд автомашины ойрын гэрэл асахгүй болсон бол хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-14 16:37:06",
    "desc": ""
},
{
    "id": "74",
    "topics_id": "7",
    "code": "7.9",
    "questions": "Улаан гэрэл дохио ассан үед уулзвар нэвтрэхийг зөвшөөрөх үү?",
    "images": "/images/b/5bcf96a91a5303b0212419f11caed3f1.jpg",
    "tdate": "2019-03-14 16:37:26",
    "desc": ""
},
{
    "id": "75",
    "topics_id": "7",
    "code": "7.10",
    "questions": "Гэрэл дохио ямар утгатай вэ?",
    "images": "/images/b/77015065f7b16616e36ef043dc393d47.jpg",
    "tdate": "2019-03-14 16:39:33",
    "desc": ""
},
{
    "id": "76",
    "topics_id": "7",
    "code": "7.11",
    "questions": "Зурагт үзүүлсэн сумны дагуу хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/b1847e20eea85a065910923bce043266.jpg",
    "tdate": "2019-03-14 16:41:52",
    "desc": "Зурагт үзүүлснээр зүүн гар тийш нэмэгдэл гэрэл дохиогоор уулзварыг чигээрээ нэвтрэхийг хориглоно."
},
{
    "id": "148",
    "topics_id": "3",
    "code": "3.30",
    "questions": "Зурагт үзүүлснээр хашлага давж буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/f239e7b858e9ea4892a73be72f4e35a7.jpg",
    "tdate": "2019-03-15 12:59:04",
    "desc": ""
},
{
    "id": "78",
    "topics_id": "3",
    "code": "3.5",
    "questions": "Харанхуй үед тээврийн хэрэгслийн ар талын оврын гэрлүүд асахгүй болсон бол хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-14 16:48:47",
    "desc": ""
},
{
    "id": "79",
    "topics_id": "7",
    "code": "7.12",
    "questions": "Зурагт үзүүлсэн сумны дагуу хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/49b2cbf9f9221bdb3bef399fe278eec9.jpg",
    "tdate": "2019-03-14 16:49:04",
    "desc": ""
},
{
    "id": "80",
    "topics_id": "7",
    "code": "7.13",
    "questions": "Баруун гар талын эгнээнээс аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/36f21c6456103cc5a651038988be71be.jpg",
    "tdate": "2019-03-14 16:51:36",
    "desc": ""
},
{
    "id": "81",
    "topics_id": "3",
    "code": "3.6",
    "questions": "Цас орж байгаа үед аль талын шил арчуур ажиллахгүй бол хөдөлгөөнөө үргэлжлүүлэхийг хориглох вэ?",
    "images": "/images/b/7ab9b9e266d77ed0c85c71cb8d5033f7.jpg",
    "tdate": "2019-03-14 16:54:46",
    "desc": ""
},
{
    "id": "82",
    "topics_id": "3",
    "code": "3.7",
    "questions": "Хөдөлгөөнд оролцож явах үед тээврийн хэрэгсэлд ямар гэмтэл тохиолдвол зөвхөн зогсоол буюу засварын газарт очих хүртэл хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх вэ?",
    "images": "",
    "tdate": "2019-03-14 17:00:37",
    "desc": "Хөдөлгөөнд оролцож явах үед жолооны механизм ажиллахгүй болсон бол хөдөлгөөнөө үргэлжлүүлэхийг хориглоно.Харин хурд хэмжүүр ажиллахгүй болсон тохиолдолд зөвхөн зогсоол (гарааш) буюу засварын газарт очих хүртэл хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрнө (ЗХД-ийн 3.4.а, 4-р хавсралтын 6.1). Хөдөлгүүрийн ажиллагаа доголдсон тохиолдолд хөдөлгөөнөө цааш үргэлжлүүлэхийг дүрмээр хориглохгүй тул хөдөлгөөнөө үргэлжлүүлэх боломж нь зөвхөн зогсоол буюу засварын газарт очих нөхцөлөөр хязгаарлагдахгүй."
},
{
    "id": "83",
    "topics_id": "7",
    "code": "7.14",
    "questions": "Та чигээрээ явах зорилгоор дунд эгнээнд байр эзэлсэн бол ямар арга хэмжээ авах вэ?",
    "images": "/images/b/ba5932d96a4ae4e79c3793b1947c81e9.jpg",
    "tdate": "2019-03-14 17:07:08",
    "desc": ""
},
{
    "id": "84",
    "topics_id": "20",
    "code": "20.7",
    "questions": "Зурагт үзүүлснээр хөдөлгөөнд оролцохдоо зорчигч тээвэрлэхийг зөвшөөрөх үү?",
    "images": "/images/b/5e5a96a3c9a12761344120c66e87da68.jpg",
    "tdate": "2019-03-14 17:09:24",
    "desc": ""
},
{
    "id": "85",
    "topics_id": "7",
    "code": "7.15",
    "questions": "Шар гэрэл дохио асах үед уулзвар руу орохыг зөвшөөрөх үү?",
    "images": "/images/b/cc629713bd04355f58a33cbc64d8a374.jpg",
    "tdate": "2019-03-15 08:43:55",
    "desc": ""
},
{
    "id": "86",
    "topics_id": "7",
    "code": "7.16",
    "questions": "Суудлын автомашины жолооч нар шар гэрэл дохио асах үед уулзвар руу орсон бол зөрчил гаргасанд тооцох уу?",
    "images": "/images/b/b37ba66d86b6c94fe05c78432fc354bc.jpg",
    "tdate": "2019-03-15 08:46:07",
    "desc": ""
},
{
    "id": "87",
    "topics_id": "7",
    "code": "7.17",
    "questions": "Зөвшөөрсөн гэрэл дохиогоор уулзварт орсон жолооч уулзварыг нэвтэрч амжаагүй байхад дохио өөрчлөгдвөл ямар арга хэмжээ авах вэ?",
    "images": "/images/b/92f22ac08d07143da2e201b07ae9a05c.jpg",
    "tdate": "2019-03-15 08:56:31",
    "desc": ""
},
{
    "id": "88",
    "topics_id": "7",
    "code": "7.18",
    "questions": "Зөвшөөрсөн гэрэл дохиогоор <<Зогс-шугам>>-ыг давах үед дохио өөрчлөгдсөн бол хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/43e8382db4bf0fe69d14f61214621cc3.jpg",
    "tdate": "2019-03-15 09:00:48",
    "desc": "<<Зогс-шугам>> тэмдэглэлийг зөвшөөрсөн дохиогоор нэврэн орсон жолооч дохио өөрчлөгдвөл аюулгүй байдлыг хангаж, явж байгаа чигтээ хөдөлгөөнөө үргэлжлүүлнэ (ЗХД-ийн 8.20)."
},
{
    "id": "89",
    "topics_id": "7",
    "code": "7.19",
    "questions": "Зурагт үзүүлсэн сумны дагуу уулзварыг нэвтрэхдээ аль гэрлэн дохионы заалтыг мөрдөх шаардлагатай вэ?",
    "images": "/images/b/201a9972aa191bea935a57ab26789b29.jpg",
    "tdate": "2019-03-15 09:02:43",
    "desc": ""
},
{
    "id": "90",
    "topics_id": "7",
    "code": "7.20",
    "questions": "Анивчсан шар гэрэл дохио ямар утгатай вэ?",
    "images": "/images/b/54375f75150f0ed2c732a08b7b0b0eaf.jpg",
    "tdate": "2019-03-15 09:07:52",
    "desc": ""
},
{
    "id": "94",
    "topics_id": "7",
    "code": "7.23",
    "questions": "Зохицуулагч дохиураа өргөх үед уулзвар руу орохыг зөвшөөрөх үү?",
    "images": "/images/b/6c5e8560d4f802e1cca09d91b428446f.jpg",
    "tdate": "2019-03-15 09:24:54",
    "desc": ""
},
{
    "id": "92",
    "topics_id": "7",
    "code": "7.21",
    "questions": "Зохицуулагчийн энэ дохио ямар утгатай вэ?",
    "images": "/images/b/80a636355a584b776e7f7118c25bd648.jpg",
    "tdate": "2019-03-15 09:16:39",
    "desc": ""
},
{
    "id": "93",
    "topics_id": "7",
    "code": "7.22",
    "questions": "Энэ тохиолдолд та ямар арга хэмжээ авах вэ?",
    "images": "/images/b/1de6549aed36768ae55673d2512b715d.jpg",
    "tdate": "2019-03-15 09:19:45",
    "desc": ""
},
{
    "id": "95",
    "topics_id": "23",
    "code": "23.1",
    "questions": "Цагт ойролцоогоор 80 км хурдтай яваа тээврийн хэрэгсэл 1 секундэд ямар зайг туулах вэ?",
    "images": "",
    "tdate": "2019-03-15 09:41:07",
    "desc": ""
},
{
    "id": "96",
    "topics_id": "23",
    "code": "23.2",
    "questions": "Хөдөлгөөний хурд ихсэхэд жолоочийн харах талбай хэрхэн өөрчлөгдөх вэ?",
    "images": "",
    "tdate": "2019-03-15 09:48:02",
    "desc": ""
},
{
    "id": "97",
    "topics_id": "23",
    "code": "23.3",
    "questions": "Согтууруулах ундааны зүйл хэрэглэх нь жолоочийн самбаачлах хугацаанд хэрхэн нөлөөлөх вэ?",
    "images": "",
    "tdate": "2019-03-15 09:51:34",
    "desc": "Согтууруулах  ундаа нь жолоочийн самбаачлах чадварыг алдагдуулж, самбаачлах хугацааг ихэсгэдэг."
},
{
    "id": "98",
    "topics_id": "23",
    "code": "23.4",
    "questions": "Тоормосны механизмгүй  чиргүүл чирсэн үед суудлын автомашины тоормосны зам хэрхэн өөрчлөгдөх вэ?",
    "images": "",
    "tdate": "2019-03-15 10:00:46",
    "desc": ""
},
{
    "id": "99",
    "topics_id": "23",
    "code": "23.5",
    "questions": "Аль тохиолдолд автомашинд төвөөс зугтах хүч хамгийн их үүсэх вэ?",
    "images": "",
    "tdate": "2019-03-15 10:10:33",
    "desc": "Төвөөс зугтах хүчний хэмжээ нь автомашины масс болон хурдаас шууд ,эргэлтийн радиусаас урвуу хамаарна.Өөрөөр хэлбэл их хурдтай эргэх буюу бага радиустай тойргоор огцом эргэхэд төвөөс зугтах хүч их үүснэ. "
},
{
    "id": "100",
    "topics_id": "23",
    "code": "23.6",
    "questions": "Дугуй түгжигдэхээс хамгаалах тоормосны системгүй автомашиныг халтиргаатай зам дээр богино зайд зогсоохын тулд яаж тоормослох нь зөв вэ?",
    "images": "",
    "tdate": "2019-03-15 10:36:25",
    "desc": ""
},
{
    "id": "101",
    "topics_id": "23",
    "code": "23.7",
    "questions": "Хойд хөтлөгчтэй автомашинаар эргэлт хийх үед хойд тэнхлэгт шарвалт үүсвэл жолооч ямар арга хэмжээ авах нь  зөв бэ?",
    "images": "",
    "tdate": "2019-03-15 10:52:48",
    "desc": ""
},
{
    "id": "102",
    "topics_id": "23",
    "code": "23.8",
    "questions": "Урд хөтлөгчтэй автомашинаар эргэлт хийх үед хойд тэнхлэгт шарвалт үүсвэл жолооч ямар арга хэмжээ авах нь зөв бэ?",
    "images": "",
    "tdate": "2019-03-15 11:03:22",
    "desc": ""
},
{
    "id": "103",
    "topics_id": "23",
    "code": "23.9",
    "questions": "Эгц уруу замд автомашины аль араан дамжуулгыг сонгож явах вэ?",
    "images": "",
    "tdate": "2019-03-15 11:06:09",
    "desc": ""
},
{
    "id": "104",
    "topics_id": "23",
    "code": "23.10",
    "questions": "Эгц уруу замыг жолооч хэрхэн туулах нь зөв бэ?",
    "images": "",
    "tdate": "2019-03-15 11:14:23",
    "desc": ""
},
{
    "id": "105",
    "topics_id": "3",
    "code": "3.8",
    "questions": "Автомашины тоормосны гэрэл асахгүй болсон тохиолдолд хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/763711850eac90d92cca11b25fe7e55c.jpg",
    "tdate": "2019-03-15 11:18:27",
    "desc": ""
},
{
    "id": "106",
    "topics_id": "3",
    "code": "3.9",
    "questions": "Хамгаалах бүсийг хэн хэрэглэх үүрэгтэй вэ?",
    "images": "",
    "tdate": "2019-03-15 11:22:26",
    "desc": ""
},
{
    "id": "107",
    "topics_id": "3",
    "code": "3.10",
    "questions": "Зорчигч хамгаалах бүс хэрэглэж хөдөлгөөнд оролцох нь хэний хүлээх үүрэг вэ?",
    "images": "/images/b/8ac3143f4b1518f27745467dd6d1a76a.jpg",
    "tdate": "2019-03-15 11:25:50",
    "desc": ""
},
{
    "id": "108",
    "topics_id": "3",
    "code": "3.11",
    "questions": "Хамгаалах малгай өмсөөгүй зорчигчийг мотоциклоор тээвэрлэхийг зөвшөөрөх үү?",
    "images": "/images/b/c6922a399b1df985b7d085e520802544.jpg",
    "tdate": "2019-03-15 11:28:16",
    "desc": ""
},
{
    "id": "109",
    "topics_id": "3",
    "code": "3.12",
    "questions": "Мотоциклын жолооч зөрчил гаргасан уу?",
    "images": "/images/b/0c0bf785dc3bbcc270637a33979035b7.jpg",
    "tdate": "2019-03-15 11:30:34",
    "desc": ""
},
{
    "id": "110",
    "topics_id": "3",
    "code": "3.13",
    "questions": "Осолд нэрвэгдсэн  хүнийг эмнэлэгт яаралтай хүргэж өгөх үүргийг та хүлээх үү?",
    "images": "/images/b/cf195706842720334a208895ed8eaab8.jpg",
    "tdate": "2019-03-15 11:32:46",
    "desc": ""
},
{
    "id": "111",
    "topics_id": "3",
    "code": "3.14",
    "questions": "Зурагт үзүүлснээр зайлшгүй зогсолт хийсэн жолооч зогсох дохио өгч байгаа үед та бололцоотой тусламж үзүүлэх үүрэгтэй юу?",
    "images": "/images/b/d12d7f303797f7b238a1f16cbd28a6fd.jpg",
    "tdate": "2019-03-15 11:35:10",
    "desc": ""
},
{
    "id": "112",
    "topics_id": "3",
    "code": "3.15",
    "questions": "Ямар үүрэг гүйцэтгэж яваа цагдаагийн ажилтанд та автомашинаараа үйлчлэх үүрэгтэй вэ?",
    "images": "",
    "tdate": "2019-03-15 11:39:01",
    "desc": ""
},
{
    "id": "113",
    "topics_id": "7",
    "code": "7.24",
    "questions": "Энэ тохиолдолд зүүн гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/a29b337f4514419b3f270a6d8faa9ec2.jpg",
    "tdate": "2019-03-15 11:41:32",
    "desc": ""
},
{
    "id": "114",
    "topics_id": "3",
    "code": "3.16",
    "questions": "Эрүүл мэндэд нь ноцтой хохирол учирч болзошгүй хүнийг эмнэлэгт хүргэхээр яваа эмнэлэгийн ажилтанд та тээврийн хэрэгслээрээ үйлчлэх үүрэгтэй юу?",
    "images": "",
    "tdate": "2019-03-15 11:43:04",
    "desc": ""
},
{
    "id": "115",
    "topics_id": "7",
    "code": "7.25",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/33fb632c21383f01a4722bf185b05ea4.jpg",
    "tdate": "2019-03-15 11:44:44",
    "desc": ""
},
{
    "id": "116",
    "topics_id": "7",
    "code": "7.26",
    "questions": "Таныг аль чигт явахыг хориглох вэ?",
    "images": "/images/b/90cee89a67840c75d5deb712299ca93d.jpg",
    "tdate": "2019-03-15 11:46:58",
    "desc": ""
},
{
    "id": "117",
    "topics_id": "7",
    "code": "7.27",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/67ce5609697bf43c906d165a79b291b4.jpg",
    "tdate": "2019-03-15 11:48:40",
    "desc": "Зохицуулагчийн энэ дохиогоор чигээрээ буюу баруун гар тийш явахыг зөвшөөрөх (ЗХД-ийн 8.14.б) боловч зүүн гар талын эгнээнээс баруун гар тийш эргэхийг хориглоно (ЗХД-ийн 10.5)."
},
{
    "id": "118",
    "topics_id": "3",
    "code": "3.17",
    "questions": "Зам тээврийн осолд холбогдсон жолооч нэн түрүүнд ямар арга хэмжээ авах вэ?",
    "images": "",
    "tdate": "2019-03-15 11:50:24",
    "desc": ""
},
{
    "id": "119",
    "topics_id": "7",
    "code": "7.28",
    "questions": "Аль тээврийн хэрэгслийн хөдөлгөөнийг зөвшөөрөх вэ?",
    "images": "/images/b/1dde158a22ed810829ee43229fec6f4f.jpg",
    "tdate": "2019-03-15 11:50:38",
    "desc": ""
},
{
    "id": "120",
    "topics_id": "7",
    "code": "7.29",
    "questions": "Аль тээврийн хэрэгслийн хөдөлгөөнийг зөвшөөрөх вэ?",
    "images": "/images/b/4c5d76646a42ed065dd94cec7fd1a5bc.jpg",
    "tdate": "2019-03-15 11:52:50",
    "desc": ""
},
{
    "id": "121",
    "topics_id": "3",
    "code": "3.18",
    "questions": "Зам тээврийн осолд холбогдсон жолооч осолд нэрвэгдсэн хүнийг эмнэлэгт хэрхэн яаралтай хүргэх вэ?",
    "images": "",
    "tdate": "2019-03-15 11:53:55",
    "desc": ""
},
{
    "id": "122",
    "topics_id": "7",
    "code": "7.30",
    "questions": "Аль тээврийн хэрэгслийн жолооч <<Зогс-шугам>> тэмдэглэлийн өмнө зогсох шаардлагатай вэ?",
    "images": "/images/b/7fbc53867df05e9571876fff79afff4b.jpg",
    "tdate": "2019-03-15 11:55:59",
    "desc": ""
},
{
    "id": "123",
    "topics_id": "7",
    "code": "7.31",
    "questions": "Танд аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/50158320999e9077757b261b91514400.jpg",
    "tdate": "2019-03-15 11:58:34",
    "desc": ""
},
{
    "id": "125",
    "topics_id": "3",
    "code": "3.19",
    "questions": "Зам тээврийн осолд холбогдсон жолооч зорчих хэсгийг чөлөөлөх зорилгоор тээврийн хэрэгслээ хэргийн газраас хөдөлгөхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-15 12:04:44",
    "desc": ""
},
{
    "id": "127",
    "topics_id": "3",
    "code": "3.20",
    "questions": "Зам тээврийн ослын улмаас хүний биед гэмтэл учирсан бол осолд холбогдсон жолооч:",
    "images": "",
    "tdate": "2019-03-15 12:08:04",
    "desc": ""
},
{
    "id": "130",
    "topics_id": "3",
    "code": "3.21",
    "questions": "Зам тээврийн ослын улмаас амь нас, эрүүл мэнд хохироогүй бол цагдаагийн байгууллагын ажилтанг хэргийн газарт дуудаж ирүүлэх шаардлагатай юу?",
    "images": "/images/b/3ee7acd3f0a4a22efa89d2eaa80b45a3.jpg",
    "tdate": "2019-03-15 12:16:58",
    "desc": ""
},
{
    "id": "131",
    "topics_id": "7",
    "code": "7.32",
    "questions": "Зохицуулагчийн энэ дохио танд аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/a8a5a9bd902cd5e437d53ab405e071c6.jpg",
    "tdate": "2019-03-15 12:17:29",
    "desc": ""
},
{
    "id": "132",
    "topics_id": "3",
    "code": "3.22",
    "questions": "Өвчтэй буюу ядарсан үедээ тээврийн хэрэгсэл жолоодохыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-15 12:18:55",
    "desc": ""
},
{
    "id": "133",
    "topics_id": "7",
    "code": "7.33",
    "questions": "Зохицуулагчийн энэ дохио танд:",
    "images": "/images/b/e6bce243d629ec5d6fa7a750f23e0639.jpg",
    "tdate": "2019-03-15 12:20:29",
    "desc": ""
},
{
    "id": "134",
    "topics_id": "7",
    "code": "7.34",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/94b3607d7543f16c4861d1304cf3a2bf.jpg",
    "tdate": "2019-03-15 12:24:26",
    "desc": ""
},
{
    "id": "135",
    "topics_id": "3",
    "code": "3.23",
    "questions": "Хэнд жолоогоо шилжүүлэхийг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-15 12:26:30",
    "desc": ""
},
{
    "id": "136",
    "topics_id": "7",
    "code": "7.35",
    "questions": "Энэ тохиолдолд та хөдөлгөөнөө хэрхэн үргэлжлүүлэх  вэ?",
    "images": "/images/b/a7b07ccd731d2ef6e9e54d9ea1f9466c.jpg",
    "tdate": "2019-03-15 12:27:58",
    "desc": ""
},
{
    "id": "137",
    "topics_id": "7",
    "code": "7.36",
    "questions": "Мотоциклын жолооч чигээрээявах бол ямар арга хэмжээ авах вэ?",
    "images": "/images/b/ed67dce5f8034a6d4a1b2dd68055bec4.jpg",
    "tdate": "2019-03-15 12:31:13",
    "desc": ""
},
{
    "id": "138",
    "topics_id": "7",
    "code": "7.37",
    "questions": "Зохицуулагчийн ойлгогдохуйц дохиог баримтлан баруун гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/20a0126e783b1d7465daa4660e41783c.jpg",
    "tdate": "2019-03-15 12:33:43",
    "desc": ""
},
{
    "id": "139",
    "topics_id": "3",
    "code": "3.24",
    "questions": "Тээврийн хэрэгслийн хөдөлгөөний үед жолооч гар утас хэрэглэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-15 12:37:30",
    "desc": ""
},
{
    "id": "140",
    "topics_id": "3",
    "code": "3.25",
    "questions": "Түр зогсож байх үедээ гар утсаар ярихыг зөвшөөрөх үү?",
    "images": "/images/b/1427ce502e6f365889567784587b3548.jpg",
    "tdate": "2019-03-15 12:41:30",
    "desc": ""
},
{
    "id": "141",
    "topics_id": "3",
    "code": "3.26",
    "questions": "Тээврийн хэрэгслийн хөдөлгөөний үед жолооч гар утастай ижил төстэй төхөөрөмж хэрэглэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-15 12:46:13",
    "desc": ""
},
{
    "id": "142",
    "topics_id": "7",
    "code": "7.38",
    "questions": "Зурагт үзүүлснээр замын хориотой хэсэгт зохицуулагч зогсох дохио өгвөл та ямар арга хэмжээ авах вэ?",
    "images": "/images/b/004b25142397336a025b7185e571faf1.jpg",
    "tdate": "2019-03-15 12:48:40",
    "desc": ""
},
{
    "id": "143",
    "topics_id": "3",
    "code": "3.27",
    "questions": "Тээврийн хэрэгсэл жолоодохдоо чихэвч хэрэглэхийг зөвшөөрөх үү?",
    "images": "/images/b/2f62ec523e71cb7e94e244189824e199.jpg",
    "tdate": "2019-03-15 12:49:02",
    "desc": ""
},
{
    "id": "144",
    "topics_id": "3",
    "code": "3.28",
    "questions": "Зурагт үзүүлснээр цувааны дундуур нэвтрэн гарахыг зөвшөөрөх үү?",
    "images": "/images/b/f2b469a8c9316cbdff2437e19a8b7a4e.jpg",
    "tdate": "2019-03-15 12:51:12",
    "desc": ""
},
{
    "id": "145",
    "topics_id": "7",
    "code": "7.39",
    "questions": "Зохицуулагч дохиураа тээврийн хэрэгсэл рүү чиглүүлэн зааж дохивол уг тээврийн хэрэгслийн жолооч ямар арга хэмжээ авах үүрэгтэй вэ?",
    "images": "",
    "tdate": "2019-03-15 12:54:04",
    "desc": ""
},
{
    "id": "146",
    "topics_id": "3",
    "code": "3.29",
    "questions": "Цуваанд яваа тээврийн хэрэгслүүдийн хооронд байр эзлэхийг зөвшөөрөх үү?",
    "images": "/images/b/b0f0fc1a5a1fee69f4c0ce52a312ddd1.jpg",
    "tdate": "2019-03-15 12:55:41",
    "desc": ""
},
{
    "id": "147",
    "topics_id": "7",
    "code": "7.40",
    "questions": "Зохицуулагчийн ойлгогдохуйц дохио нь дүрмийн бусад заалттай зөрчилдөж байвал жолооч:",
    "images": "",
    "tdate": "2019-03-15 12:57:28",
    "desc": ""
},
{
    "id": "149",
    "topics_id": "8",
    "code": "8.1",
    "questions": "Зам тээврийн ослын улмаас зогссон тээврийн хэрэгслийн жолооч ослын дохионы гэрлээ заавал асаах шаардлагатай юу?",
    "images": "",
    "tdate": "2019-03-15 13:03:55",
    "desc": ""
},
{
    "id": "150",
    "topics_id": "8",
    "code": "8.2",
    "questions": "Уулзвар дээр ямар шалтгаанаар зогссон тохиолдолд ослын дохионы гэрлээ асаах шаардлагатай вэ?",
    "images": "",
    "tdate": "2019-03-15 13:11:14",
    "desc": ""
},
{
    "id": "151",
    "topics_id": "8",
    "code": "8.3",
    "questions": "Зайлшгүй зогсолт хийсэн жолооч ослын дохионы гэрлээ заавал асаах шаардлагатай юу?",
    "images": "/images/b/abf538fcf7edc4bbe756ec9b54473269.jpg",
    "tdate": "2019-03-15 13:13:18",
    "desc": ""
},
{
    "id": "152",
    "topics_id": "8",
    "code": "8.4",
    "questions": "Зурагт үзүүлсэн тээврийн хэрэгслүүд зайлшгүй зогсолт хийсэн бол аль тээврийн хэрэгслийн ослын дохионы гэрлийг асаах шаардлагатай вэ?",
    "images": "/images/b/036a597fe5a5e39e2c3711279085da91.jpg",
    "tdate": "2019-03-15 13:15:54",
    "desc": ""
},
{
    "id": "153",
    "topics_id": "13",
    "code": "13.1",
    "questions": "Суудлын машины жолооч зурагт үзүүлсэн хэсэгт зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/d405337ad4df21d2444e8b70a9072d8e.jpg",
    "tdate": "2019-03-15 13:23:18",
    "desc": "'Зогсоол' /5.17/ тэмдэг бүхий талбай байгаа тохиолдолд жолооч уг зогсоолын талбайг ашиглаж зогсоно /ЗХД-ийн 14.1/"
},
{
    "id": "154",
    "topics_id": "8",
    "code": "8.5",
    "questions": "Харанхуй үед замын түр зогсох хориотой хэсэгт зайлшгүй зогсолт хийсэн жолооч ослын дохионы гэрлээ асаах шаардлагатай юу?",
    "images": "",
    "tdate": "2019-03-15 13:23:52",
    "desc": ""
},
{
    "id": "155",
    "topics_id": "8",
    "code": "8.6",
    "questions": "Харанхуй үед гэрэлтүүлэггүй замын хөвөөн дээр оврын гэрэл нь гэмтэлтэй тээврийн хэрэгслийг зогсоохдоо:",
    "images": "",
    "tdate": "2019-03-15 13:27:11",
    "desc": ""
},
{
    "id": "156",
    "topics_id": "4",
    "code": "4.1",
    "questions": "Тусгай гэрлэн дохио ажиллуулсан автомашины жолооч аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/2bc048f0b2331cd9f216b49ea94f37df.jpg",
    "tdate": "2019-03-15 13:27:59",
    "desc": ""
},
{
    "id": "157",
    "topics_id": "4",
    "code": "4.2",
    "questions": "Зурагт үзүүлсэн автомашины цагт 80 км хурдтай явахыг зөвшөөрөх үү?",
    "images": "/images/b/ab12edd3f2d2254cfb501a4b322ae2f5.jpg",
    "tdate": "2019-03-15 13:31:09",
    "desc": ""
},
{
    "id": "158",
    "topics_id": "8",
    "code": "8.7",
    "questions": "Харанхуй үед замын түр ба удаан зогсохыг хориглоогүй хэсэгт оврын гэрэл нь гэмтэлтэй тээврийн хэрэгслийг зогсоохдоо ослын дохионы гэрлийг асаах шаардлагатай юу?",
    "images": "/images/b/0c1654e7daee5d1194d0c47d4a914b85.jpg",
    "tdate": "2019-03-15 13:32:59",
    "desc": ""
},
{
    "id": "159",
    "topics_id": "4",
    "code": "4.3",
    "questions": "Хөх-Улаан өнгийн тусгай гэрлэн дохиогоор тоноглосон автомашины жолооч аль тохиолдолд давуу эрхтэй байх вэ?",
    "images": "",
    "tdate": "2019-03-15 13:37:45",
    "desc": ""
},
{
    "id": "160",
    "topics_id": "8",
    "code": "8.8",
    "questions": "Зогсож байгаа автобусны ослын тохионы гэрэл юуг илэрхийлж байна вэ?",
    "images": "/images/b/8ea392dd0b40b7a4fd998cc2409de6f9.jpg",
    "tdate": "2019-03-15 13:38:06",
    "desc": ""
},
{
    "id": "161",
    "topics_id": "4",
    "code": "4.4",
    "questions": "Шар өнгийн тусгай гэрлэн дохио ажиллуулсан автомашины жолооч хөдөлгөөний аюулгүй байдлыг хангасан нөхцөлд дүрмийн аль заалтыг мөрдөхгүй байж болох вэ?",
    "images": "",
    "tdate": "2019-03-15 13:41:15",
    "desc": ""
},
{
    "id": "162",
    "topics_id": "8",
    "code": "8.9",
    "questions": "Жолооч нүд гялбан зорчих баримжаа алдвал бусдад хэрхэн анхааруулах вэ?",
    "images": "",
    "tdate": "2019-03-15 13:41:25",
    "desc": ""
},
{
    "id": "163",
    "topics_id": "8",
    "code": "8.10",
    "questions": "Аль тээврийн хэрэгслийн ослын дохионы гэрлийг асааж явах шаардлагатай вэ?",
    "images": "/images/b/1ea831855bb0d3c51eac9c9e661e8f95.jpg",
    "tdate": "2019-03-15 13:43:18",
    "desc": ""
},
{
    "id": "164",
    "topics_id": "4",
    "code": "4.5",
    "questions": "Шар өнгийн тусгай гэрлэн дохио ажиллуулсан автомашинд та зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/d7a8c808af1a5de851fa5f5e576089bd.jpg",
    "tdate": "2019-03-15 13:45:02",
    "desc": ""
},
{
    "id": "165",
    "topics_id": "8",
    "code": "8.11",
    "questions": "Суурин газарт ослын зогсолтын тэмдгийг тээврийн хэрэгслээс ямар зайд байрлуулах вэ?",
    "images": "/images/b/eaafb5545b275ebb130a243a491676e9.jpg",
    "tdate": "2019-03-15 13:46:40",
    "desc": ""
},
{
    "id": "166",
    "topics_id": "8",
    "code": "8.12",
    "questions": "Суурин газрын гаднах замд ослын зогсолтын тэмдгийг ямар зайд байрлуулах вэ?",
    "images": "/images/b/33ba2f1ae2e73407db1c42b2b2df1e51.jpg",
    "tdate": "2019-03-15 13:48:42",
    "desc": ""
},
{
    "id": "167",
    "topics_id": "8",
    "code": "8.13",
    "questions": "Энэ тохиолдолд ослын зогсолтын тэмдгийг ямар зайд байрлуулах вэ?",
    "images": "/images/b/3f17b1afb9e85b9a84be9e653fae4669.jpg",
    "tdate": "2019-03-15 13:50:52",
    "desc": ""
},
{
    "id": "168",
    "topics_id": "4",
    "code": "4.6",
    "questions": "Тусгай дуут болон гэрлэн дохио ажиллуулсан автомашин ойртон ирж яваа энэ тохиолдолд суудлын автомашины жолооч ямар үүрэг хүлээх вэ?",
    "images": "/images/b/bf66dc1464e9c127ceddf3befd460c75.jpg",
    "tdate": "2019-03-15 13:52:35",
    "desc": ""
},
{
    "id": "169",
    "topics_id": "8",
    "code": "8.14",
    "questions": "Зам тээврийн ослын улмаас зогссон жолооч тээврийн хэрэгслээ бусад хөдөлгөөнд оролцогчдод анхааруулахын тулд заавал ослын зогсолтын тэмдэг байрлуулах шаардлагатай юу?",
    "images": "",
    "tdate": "2019-03-15 13:53:57",
    "desc": ""
},
{
    "id": "170",
    "topics_id": "8",
    "code": "8.15",
    "questions": "Түр зогсох хориотой газарт зайлшгүй зогсолт хийсэн тээврийн хэрэгслийн жолооч ослын зогсолтын тэмдэг байрлуулах шаардлагатай юу?",
    "images": "",
    "tdate": "2019-03-15 13:58:16",
    "desc": ""
},
{
    "id": "171",
    "topics_id": "4",
    "code": "4.7",
    "questions": "Цуваагаар яваа тээврийн хэрэгслүүд ойртон ирж яваа энэ тохиолдолд суудлын автомашины жолооч аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/e9ba4efde8074710b5a08f843b669d23.jpg",
    "tdate": "2019-03-15 14:00:08",
    "desc": ""
},
{
    "id": "172",
    "topics_id": "13",
    "code": "13.2",
    "questions": "Тээврийн хэрэгслээ хэрхэн байрлуулж зогсоох вэ?",
    "images": "/images/b/3bf64ab279a7dc0c4bd995353280e2c1.jpg",
    "tdate": "2019-03-15 14:01:57",
    "desc": ""
},
{
    "id": "173",
    "topics_id": "4",
    "code": "4.8",
    "questions": "Аль тээврийн хэрэгслийн жолоочийн гүйцэх үйлдлийг хориглох вэ?",
    "images": "/images/b/ba08b6af11c5d67b82a298519a91aab8.jpg",
    "tdate": "2019-03-15 14:02:58",
    "desc": ""
},
{
    "id": "174",
    "topics_id": "13",
    "code": "13.3",
    "questions": "Тээврийн хэрэгслээ хэрхэн байрлуулж зогсоох вэ?",
    "images": "/images/b/e501eeeb783193db77cca064d9bf3c7b.jpg",
    "tdate": "2019-03-15 14:05:32",
    "desc": ""
},
{
    "id": "175",
    "topics_id": "4",
    "code": "4.9",
    "questions": "Тусгай гэрлэн дохио ажиллуулсан цагдаагийн автомашин араас ойртон ирж байвал та заавал зогсох шаардлагатай юу?",
    "images": "/images/b/5b7eba65f32c5a04d38e9c5ddd3ccd33.jpg",
    "tdate": "2019-03-15 14:24:39",
    "desc": ""
},
{
    "id": "176",
    "topics_id": "4",
    "code": "4.10",
    "questions": "Тусгай гэрлэн дохио ажиллуулсан тээврийн хэрэгсэл зогсож байгаа энэ тохиолдолд та ямар арга хэмжээ авах үүрэгтэй вэ?",
    "images": "/images/b/6d02e778fb2d03a30060d913cc475df7.jpg",
    "tdate": "2019-03-15 14:32:38",
    "desc": ""
},
{
    "id": "177",
    "topics_id": "17",
    "code": "17.1",
    "questions": "Харанхуй үед гэрэлтүүлэггүй замаар явахдаа ямар гэрэл хэрэглэх вэ?",
    "images": "",
    "tdate": "2019-03-15 14:36:15",
    "desc": ""
},
{
    "id": "178",
    "topics_id": "5",
    "code": "5.1",
    "questions": "Энэ тэмдэг юуг анхааруулах вэ?",
    "images": "/images/b/c49e8060a31a8ebffc615c8089c8e6df.jpg",
    "tdate": "2019-03-15 14:37:06",
    "desc": ""
},
{
    "id": "179",
    "topics_id": "17",
    "code": "17.2",
    "questions": "Харанхуй үед замын гэрэлтүүлэгтэй хэсгээр явахдаа ямар гэрэл хэрэглэх вэ?",
    "images": "",
    "tdate": "2019-03-15 14:38:02",
    "desc": ""
},
{
    "id": "180",
    "topics_id": "5",
    "code": "5.2",
    "questions": "Аль тэмдэг төмөр замын хаалтгүй гармыг анхааруулах вэ?",
    "images": "/images/b/7f0fbc18835491ee1ea29dc64dc38b18.jpg",
    "tdate": "2019-03-15 14:39:13",
    "desc": ""
},
{
    "id": "181",
    "topics_id": "17",
    "code": "17.3",
    "questions": "Өөдөөс яваа тээврийн хэрэгсэл хүртэл хэдэн метрээс багагүй зайд холын гэрлийг ойрын гэрэлд шилжүүлэх шаардлагатай вэ?",
    "images": "",
    "tdate": "2019-03-15 14:40:27",
    "desc": ""
},
{
    "id": "182",
    "topics_id": "13",
    "code": "13.4",
    "questions": "Эсрэг хөдөлгөөнтэй замд зорчих хэсгийн зүүн гар талд зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/fb946c773b61f7dd30b328cf6dce7208.jpg",
    "tdate": "2019-03-15 14:41:26",
    "desc": ""
},
{
    "id": "183",
    "topics_id": "17",
    "code": "17.4",
    "questions": "Өгсүүр хэсгийн төгсгөлд холын гэрлээ ойрын гэрэлд шилжүүлэх шаардлагатай юу?",
    "images": "/images/b/28fb892684d29c7620a4570135852acf.jpg",
    "tdate": "2019-03-15 14:42:02",
    "desc": ""
},
{
    "id": "184",
    "topics_id": "13",
    "code": "13.5",
    "questions": "Тээврийн хэрэгслээ хэрхэн байрлуулж зогсоох вэ?",
    "images": "/images/b/f75a92130c71a4894a81be5c6e76e7ad.jpg",
    "tdate": "2019-03-15 14:44:51",
    "desc": ""
},
{
    "id": "185",
    "topics_id": "5",
    "code": "5.3",
    "questions": "Төмөр замын гарамд хамгийн ойр очсоныг аль тэмдэг анхааруулах вэ?",
    "images": "/images/b/a669e1e19b90de3391b00930c4b75b04.jpg",
    "tdate": "2019-03-15 14:45:28",
    "desc": ""
},
{
    "id": "186",
    "topics_id": "13",
    "code": "13.6",
    "questions": "Хашлагагүй замын аль хэсэгт түр зогсохыг зөвшөөрөх вэ?",
    "images": "/images/b/6ef4aa61bc5ad39568b73a782e6ddd1f.jpg",
    "tdate": "2019-03-15 14:46:47",
    "desc": ""
},
{
    "id": "187",
    "topics_id": "17",
    "code": "17.5",
    "questions": "Өөдөөс яваа автомашины жолооч гэрлээ үе үе шилжүүлэн дохивол та ямар арга хэмжээ авах вэ?",
    "images": "/images/b/e4a8a4a3785e7fccd3cfab4ad10aeb5a.jpg",
    "tdate": "2019-03-15 14:47:35",
    "desc": ""
},
{
    "id": "188",
    "topics_id": "5",
    "code": "5.4",
    "questions": "Зурагт үзүүлсэн шороон замаас хучилттай нийлэхдээ та ямар журам баримтлах вэ?",
    "images": "/images/b/18828efc04413f42f9e90c650180fbd8.jpg",
    "tdate": "2019-03-15 14:48:38",
    "desc": ""
},
{
    "id": "189",
    "topics_id": "17",
    "code": "17.6",
    "questions": "Харанхуй үед өөдөөс яваа жолоочид холын гэрлээ ойрын гэрэлд шилжүүлэх хэрхэн мэдэгдэх вэ?",
    "images": "",
    "tdate": "2019-03-15 14:49:46",
    "desc": ""
},
{
    "id": "190",
    "topics_id": "13",
    "code": "13.7",
    "questions": "Зурагт үзүүлснээр замын зүүн гар талд зорчих хэсгийг чөлөөлж зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/6f9ad7fa45b04ccf3180330c632d4355.jpg",
    "tdate": "2019-03-15 14:51:40",
    "desc": ""
},
{
    "id": "663",
    "topics_id": "5",
    "code": "5.51",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/a84873b228688f92936d9f2034f0b029.jpg",
    "tdate": "2019-03-18 10:11:05",
    "desc": ""
},
{
    "id": "664",
    "topics_id": "5",
    "code": "5.52",
    "questions": "Энэ тохиолдолд буцаж эргэх үйлдлийг хаана гүйцэтгэхийг зөвшөөрөх вэ?",
    "images": "/images/b/46df8e53b5e1508757386874d4777cc5.jpg",
    "tdate": "2019-03-18 10:13:09",
    "desc": ""
},
{
    "id": "192",
    "topics_id": "13",
    "code": "13.8",
    "questions": "Зорчих хэсгийн аль талд зогсохыг хориглох вэ?",
    "images": "/images/b/dbae0f7ba1669b78a9d79f80de62f28b.jpg",
    "tdate": "2019-03-15 14:53:12",
    "desc": ""
},
{
    "id": "193",
    "topics_id": "17",
    "code": "17.7",
    "questions": "Нүд гялбан зорчих баримжаа алдвал та ямар арга хэмжээ авах вэ?",
    "images": "/images/b/05279fc8ee8828162559f1778313fb5a.jpg",
    "tdate": "2019-03-15 14:53:33",
    "desc": ""
},
{
    "id": "194",
    "topics_id": "17",
    "code": "17.8",
    "questions": "Харанхуй үед гэрэлтүүлэггүй замын хөвөөн дээр тээврийн хэрэгслийг зогсоохдоо ямар гэрэл асаах вэ?",
    "images": "",
    "tdate": "2019-03-15 14:54:58",
    "desc": ""
},
{
    "id": "195",
    "topics_id": "5",
    "code": "5.5",
    "questions": "Энэ тэмдэг юуг анхааруулах вэ?",
    "images": "/images/b/d64e7abd047be3db82a35b81bf3b0ec6.jpg",
    "tdate": "2019-03-15 14:55:26",
    "desc": ""
},
{
    "id": "196",
    "topics_id": "13",
    "code": "13.9",
    "questions": "Аль тээврийн хэрэгслийн жолооч зогсох үйлдлийг буруу гүйцэтгэсэн бэ?",
    "images": "/images/b/d230f133acc663f09a1564460e087b7d.jpg",
    "tdate": "2019-03-15 14:56:15",
    "desc": ""
},
{
    "id": "197",
    "topics_id": "17",
    "code": "17.9",
    "questions": "Харанхуй үед замын гэрэлтүүлэгтэй хэсэгт тээврийн хэрэгслийг зогсоохдоо гэрэл асаах шаардлагатай юу?",
    "images": "/images/b/9ad68320c188d499f6c558358cdcc498.jpg",
    "tdate": "2019-03-15 14:57:20",
    "desc": ""
},
{
    "id": "198",
    "topics_id": "17",
    "code": "17.10",
    "questions": "Гэрэлтүүлүүрийг суурин газарт хэрэглэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-15 14:59:51",
    "desc": ""
},
{
    "id": "199",
    "topics_id": "24",
    "code": "24.1",
    "questions": "Аль нэг гар, хөл нь гэмтсэн хүний хувцсыг аль талаас нь эхэлж тайлах буюу өмсүүлэх вэ?",
    "images": "",
    "tdate": "2019-03-15 15:00:18",
    "desc": ""
},
{
    "id": "200",
    "topics_id": "13",
    "code": "13.10",
    "questions": "Суудлын автомашин зурагт үзүүлснээр зорчих хэсгийн зүүн гар талын захад зогсохыг зөвшөрөх үү?",
    "images": "/images/b/9ff97b772b397183560053f3164f0927.jpg",
    "tdate": "2019-03-15 15:01:49",
    "desc": ""
},
{
    "id": "201",
    "topics_id": "5",
    "code": "5.6",
    "questions": "Энэ тэмдэг юуг анхааруулах вэ?",
    "images": "/images/b/bf8e92ecd45ff5e93c028777249b1935.jpg",
    "tdate": "2019-03-15 15:04:11",
    "desc": ""
},
{
    "id": "202",
    "topics_id": "5",
    "code": "5.7",
    "questions": "Аль тэмдэг замын тахир хэсэгт ойртож байгааг анхааруулах вэ?",
    "images": "/images/b/23a2ec290468148bafe26b0ff0fc19d4.jpg",
    "tdate": "2019-03-15 15:05:42",
    "desc": ""
},
{
    "id": "203",
    "topics_id": "24",
    "code": "24.2",
    "questions": "Шархтай хэсгийг халдваргүйжүүлэх зорилгоор йодыг хэрхэн хэрэглэх вэ?",
    "images": "",
    "tdate": "2019-03-15 15:08:51",
    "desc": ""
},
{
    "id": "483",
    "topics_id": "12",
    "code": "12.1",
    "questions": "Гүйцэж түрүүлэх үйлдэл хийж эхэлмэгц өөдөөс тээврийн хэрэгсэл ойртон ирж  байвал та ямар арга хэмжээ авах вэ?",
    "images": "/images/b/50c902a5f007dc3aec1917f1feaac25d.jpg",
    "tdate": "2019-03-17 10:16:17",
    "desc": ""
},
{
    "id": "484",
    "topics_id": "12",
    "code": "12.2",
    "questions": "Ачааны автомашиныг гүйцэж түрүүлснийхээ дараа хэдийд баруун гар талын эгнээнд шилжих вэ?",
    "images": "/images/b/a1ed6a0a5140b427d6d02227afd747a9.jpg",
    "tdate": "2019-03-17 10:19:58",
    "desc": ""
},
{
    "id": "205",
    "topics_id": "24",
    "code": "24.3",
    "questions": "Хялгасан судасны цус алдалтыг хэрхэн тогтоох вэ?",
    "images": "",
    "tdate": "2019-03-15 15:23:01",
    "desc": ""
},
{
    "id": "206",
    "topics_id": "24",
    "code": "24.4",
    "questions": "Венийн судасны цус алдалтыг хэрхэн тогтоох вэ?",
    "images": "",
    "tdate": "2019-03-15 15:26:24",
    "desc": ""
},
{
    "id": "207",
    "topics_id": "24",
    "code": "24.5",
    "questions": "Гар буюу хөлний артерийн судаснаас алдагдаж байгаа цусыг тогтоохын тулд чангалуурыг шархны аль хэсэгт тавих вэ?",
    "images": "",
    "tdate": "2019-03-15 15:31:03",
    "desc": ""
},
{
    "id": "208",
    "topics_id": "24",
    "code": "24.6",
    "questions": "Цус тогтоох чангалуурыг ямар хугацаагаар тавих вэ?",
    "images": "",
    "tdate": "2019-03-15 15:37:14",
    "desc": ""
},
{
    "id": "209",
    "topics_id": "24",
    "code": "24.7",
    "questions": "Ухаан алдсан хүнд эмнэлгийн анхны тусламж хэрхэн үзүүлэх вэ?",
    "images": "",
    "tdate": "2019-03-15 15:47:12",
    "desc": "Ухаан алдсан хүний цусны даралт огцом буурах аюултай тул биеийн цусан хангамжийг сайжруулах үүднээс хөлийг нь хагас өндөрлөж хэвтүүлнэ"
},
{
    "id": "210",
    "topics_id": "24",
    "code": "24.8",
    "questions": "Амьсгал ба зүрхний үйл ажиллагаа нь саатсан хүнд   ямар дарааллаар анхны тусламж үзүүлэх вэ?",
    "images": "",
    "tdate": "2019-03-15 16:00:39",
    "desc": ""
},
{
    "id": "211",
    "topics_id": "5",
    "code": "5.8",
    "questions": "Энэ тэмдэг юуг анхааруулах вэ?",
    "images": "/images/b/b7599090e34f5126744ad34cf8be3be5.jpg",
    "tdate": "2019-03-15 16:07:00",
    "desc": ""
},
{
    "id": "212",
    "topics_id": "24",
    "code": "24.9",
    "questions": "Нуруу нь гэмтсэн хүнийг хэрхэн тээвэрлэх вэ?",
    "images": "",
    "tdate": "2019-03-15 16:07:30",
    "desc": ""
},
{
    "id": "213",
    "topics_id": "8",
    "code": "8.16",
    "questions": "Түр зогсох хориотой газарт зайлшгүй зогсолт хийсэн тээврийн хэрэгслийн жолооч ослын дохионы гэрлээ асаасан бол ослын  зогсолтын тэмдэг байрлуулах шаардлагатай юу?",
    "images": "",
    "tdate": "2019-03-15 16:07:46",
    "desc": ""
},
{
    "id": "214",
    "topics_id": "5",
    "code": "5.9",
    "questions": "Замын халтиргаатай хэсэг хэдэн метрийн цаанаас эхлэх вэ?",
    "images": "/images/b/8a7f55c8d98a0b6a914eff7ad16df5f5.jpg",
    "tdate": "2019-03-15 16:08:49",
    "desc": ""
},
{
    "id": "215",
    "topics_id": "5",
    "code": "5.10",
    "questions": "Замын бартаа, донсолгоотой хэсэг хаанаас эхлэх вэ?",
    "images": "/images/b/0ce31b0865e26aa51c97c43be35a659d.jpg",
    "tdate": "2019-03-15 16:12:25",
    "desc": ""
},
{
    "id": "216",
    "topics_id": "24",
    "code": "24.10",
    "questions": "Хавирга нь хугарсан хүнийг хэрхэн тээвэрлэх вэ?",
    "images": "",
    "tdate": "2019-03-15 16:12:35",
    "desc": ""
},
{
    "id": "217",
    "topics_id": "5",
    "code": "5.11",
    "questions": "Тэмдгээр анхааруулсан замын аюул бүхий хэсэгт зохицсон арга хэмжээг та хэдийд авч эхлэх вэ?",
    "images": "/images/b/1d7b62b8ae2ea2ad878622dbcf81d071.jpg",
    "tdate": "2019-03-15 16:17:50",
    "desc": "Замын аюул бүхий хэсэгт зохицсон арга хэмжээг урьдчилан авах боломжийг жолоочид хангах үүднээс анхааруулах тэмдгийг тухайн аюул бүхий хэсгийн өмнө тодорхой зайд байрлуулдаг.Иймд жолооч анхааруулах тэмдгийг харсан үеэсээ эхлэн тухайн аюул бүхий хэсэгт зохицсон арга хэмжээг авч эхлэх шаардлагатай.Тухайлбал зурагт үзүүлсэн замын энэ хэсгээс эхлэн та хурдаа хасаж урд яваа тээврийн хэрэгслээс хоорондын зайгаа, өөдөөс яваа тээврийн хэрэгслээс хажуугийн зайгаа аль болох их байхаар барьж, хайрга чулуу үсэрч болзошгүй аюулаас сэргийлэх арга хэмжээг урьдчилан авч эхлэх шаардлагатай."
},
{
    "id": "218",
    "topics_id": "5",
    "code": "5.12",
    "questions": "Энд буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/5fd7a90f9c82a11fd7a2877e583d8b3d.jpg",
    "tdate": "2019-03-15 16:19:06",
    "desc": "Нэг чигийн хөдөлгөөний төгсгөл ойртож байгааг буюу нэг чигийн хөдөлгөөнтэй зорчих хэсгээс эсрэг хөдөлгөөнтэй зорчих хэсэгт шилжих гэж байгааг жолоочид урьдчилан анхааруулах зорилгоор 'Эсрэг хөдөлгөөн' (1.16) тэмдгийг хэрэглэдэг.Өөрөөр хэлбэл зурагт үзүүлсэн зорчих хэсэг нэг чигийн хөдөлгөөнтэй учир буцаж эргэхийг хориглоно."
},
{
    "id": "220",
    "topics_id": "5",
    "code": "5.13",
    "questions": "Аль тэмдэг хурд сааруулагчийг анхааруулах вэ?",
    "images": "/images/b/17b6adfc88f77459d649fb3d60a7deac.jpg",
    "tdate": "2019-03-15 16:23:26",
    "desc": ""
},
{
    "id": "221",
    "topics_id": "5",
    "code": "5.14",
    "questions": "Хэн нь явган хүний гарцаар зам хөндлөн гарч байна вэ?",
    "images": "/images/b/f00f004d3018b5e7a8b5a975e033f4e6.jpg",
    "tdate": "2019-03-15 16:24:55",
    "desc": ""
},
{
    "id": "224",
    "topics_id": "5",
    "code": "5.16",
    "questions": "Тэмдэг юуг анхааруулж байна вэ?",
    "images": "/images/b/08c06999cb85b940bd87d97955f2837e.jpg",
    "tdate": "2019-03-15 16:30:17",
    "desc": ""
},
{
    "id": "225",
    "topics_id": "20",
    "code": "20.8",
    "questions": "Зурагт үзүүлснээр чирэхийг зөвшөөрөх үү?",
    "images": "/images/b/ff0505642fa1011aad1acfc9d3383ec5.jpg",
    "tdate": "2019-03-15 16:32:08",
    "desc": ""
},
{
    "id": "223",
    "topics_id": "5",
    "code": "5.15",
    "questions": "Тэмдэг юуг анхааруулж байна вэ?",
    "images": "/images/b/b42d5d73a29fd92a191f01ca261b7f66.jpg",
    "tdate": "2019-03-15 16:27:13",
    "desc": ""
},
{
    "id": "226",
    "topics_id": "5",
    "code": "5.17",
    "questions": "Тэмдэг юуг анхааруулж байна вэ?",
    "images": "/images/b/6dd8dd71b29a1471385de5020c33c705.jpg",
    "tdate": "2019-03-15 16:33:04",
    "desc": ""
},
{
    "id": "227",
    "topics_id": "5",
    "code": "5.18",
    "questions": "Гарцаар баруун гар тийш эргэж замаас гарахыг зөвшөөрөх үү?",
    "images": "/images/b/6c9c7c9c847086969bef2c95d6ab00d9.jpg",
    "tdate": "2019-03-15 16:34:18",
    "desc": "'Эргэх чиг' (1.29) тэмдэг нь замын огцом эргэх чигийг анхааруулах бөгөөд хөдөлгөөнд ямар нэгэн хориглолт буюу хязгаарлалт тогтоохгүй."
},
{
    "id": "228",
    "topics_id": "20",
    "code": "20.9",
    "questions": "Механикжсан тээврийн хэрэгслийг халтиргаатай замд чирэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-15 16:34:26",
    "desc": ""
},
{
    "id": "229",
    "topics_id": "5",
    "code": "5.19",
    "questions": "Энэ тэмдэг юуг анхааруулах вэ?",
    "images": "/images/b/feba7ed5f2034e48c94ba9a3b224ec55.jpg",
    "tdate": "2019-03-15 16:37:00",
    "desc": ""
},
{
    "id": "230",
    "topics_id": "20",
    "code": "20.10",
    "questions": "Чиргүүлтэй механикжсан тээврийн хэрэгслийг чирэхийг зөвшөөрөх үү?",
    "images": "/images/b/d4399944422cd72053aacf04978ab571.jpg",
    "tdate": "2019-03-15 16:37:55",
    "desc": ""
},
{
    "id": "231",
    "topics_id": "5",
    "code": "5.20",
    "questions": "Энэ тэмдэг нь:",
    "images": "/images/b/f704ce6453fbeb11db1a4a5c3f9505e3.jpg",
    "tdate": "2019-03-15 16:42:11",
    "desc": ""
},
{
    "id": "232",
    "topics_id": "5",
    "code": "5.21",
    "questions": "Аль тэмдгээс цааш тээврийн хэрэгсэл орохыг хориглох вэ?",
    "images": "/images/b/95f0c62d14ca91ef49ea36d75522b4d0.jpg",
    "tdate": "2019-03-15 16:43:56",
    "desc": ""
},
{
    "id": "233",
    "topics_id": "5",
    "code": "5.22",
    "questions": "Суудлын автомашины хөдөлгөөнийг аль тэмдэг хориглох вэ?",
    "images": "/images/b/3f0a34db6ad3ed611a53e1de740da6b1.jpg",
    "tdate": "2019-03-15 16:45:01",
    "desc": ""
},
{
    "id": "234",
    "topics_id": "5",
    "code": "5.23",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/1a02ab559e8824ed9c70f42ab4d88bb0.jpg",
    "tdate": "2019-03-15 16:46:12",
    "desc": ""
},
{
    "id": "235",
    "topics_id": "5",
    "code": "5.24",
    "questions": "Энэ тэмдэг бүх жин нь 3,5 тонноос бага ачааны автомашины хөдөлгөөнийг хориглох уу?",
    "images": "/images/b/9a8a68a27d2ec341fc92d9392329b74f.jpg",
    "tdate": "2019-03-15 16:48:05",
    "desc": ""
},
{
    "id": "236",
    "topics_id": "5",
    "code": "5.25",
    "questions": "Аль тэмдэг мотоциклын хөдөлгөөнийг хориглох вэ?",
    "images": "/images/b/1e951f945f11526626355f369fbe70e3.jpg",
    "tdate": "2019-03-15 16:49:56",
    "desc": ""
},
{
    "id": "237",
    "topics_id": "5",
    "code": "5.26",
    "questions": "Аль суудлын автомашины сумны дагуух хөдөлгөөнийг хориглох вэ?",
    "images": "/images/b/6f75d7f1df86309553564e6c2a0fd03d.jpg",
    "tdate": "2019-03-15 16:52:26",
    "desc": ""
},
{
    "id": "238",
    "topics_id": "5",
    "code": "5.27",
    "questions": "Бүх жин нь 3,5 тонноос бага ачааны автомашины чигээрээ явах хөдөлгөөнийг зөвшөөрөх үү?",
    "images": "/images/b/d94eae0602219bc0a7e4fb4cf691a7eb.jpg",
    "tdate": "2019-03-15 16:53:49",
    "desc": "'Чиргүүлтэй тээврийн хэрэгслийн хөдөлгөөн хориотой' (2.7) тэмдэг нь чиргүүлтэй бүх төрлийн ачааны автомашины хөдөлгөөнийг хориглоно."
},
{
    "id": "239",
    "topics_id": "5",
    "code": "5.28",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/aea11f603fe5077c124aa7669463f2f5.jpg",
    "tdate": "2019-03-15 16:54:48",
    "desc": ""
},
{
    "id": "240",
    "topics_id": "5",
    "code": "5.29",
    "questions": "Уулзвар дээр буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/b47b9b5225d80b510c840e09534d27c0.jpg",
    "tdate": "2019-03-15 16:55:57",
    "desc": ""
},
{
    "id": "241",
    "topics_id": "5",
    "code": "5.30",
    "questions": "Аль чигт явахыг хориглох вэ?",
    "images": "/images/b/0544ed192c89b40cc8c54e0d8eec9944.jpg",
    "tdate": "2019-03-15 16:57:41",
    "desc": ""
},
{
    "id": "242",
    "topics_id": "5",
    "code": "5.31",
    "questions": "Тэмдгийн үйлчлэх хүрээнд гүйцэж түрүүлэх үйлдэл хийхийг зөвшөөрөх үү?",
    "images": "/images/b/2a23b04a86acfea1e2fffd0cd7fef748.jpg",
    "tdate": "2019-03-15 17:03:42",
    "desc": ""
},
{
    "id": "243",
    "topics_id": "5",
    "code": "5.32",
    "questions": "Суудлын автомашины гүйцэж түрүүлэх үйлдлийг зөвшөөрөх үү?",
    "images": "/images/b/4282d10a8d6d93050ff490c0002cfd59.jpg",
    "tdate": "2019-03-15 17:04:47",
    "desc": "'Гүйцэж түрүүлэх хориотой' (2.20) тэмдэг байрласан замын хэсэгт 'Удаан явдалт тээврийн хэрэгсэл' таних тэмдэг бүхий тээврийн хэрэгслийг гүйцэж түрүүлэхийг хориглохгүй."
},
{
    "id": "244",
    "topics_id": "5",
    "code": "5.33",
    "questions": "Замын энэ хэсэгт гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/e3a7f67190575f6ebdfe8213ca891d22.jpg",
    "tdate": "2019-03-15 17:05:47",
    "desc": ""
},
{
    "id": "245",
    "topics_id": "5",
    "code": "5.34",
    "questions": "Энэ тэмдгийн үйлчлэх хүрээнд бүх жин нь 3.5 тонноос бага ачааны автомашинаар гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/07f3795beddd660309bec3ee5b836839.jpg",
    "tdate": "2019-03-15 17:09:30",
    "desc": ""
},
{
    "id": "246",
    "topics_id": "5",
    "code": "5.35",
    "questions": "Суурин газрын гаднах замд энэ тэмдгийн үйлчлэх хүрээнд суудлын автомашин ямар хурдтай явахыг зөвшөөрөх вэ?",
    "images": "/images/b/dcdeaaba188cd87e8de7454eb2e450d1.jpg",
    "tdate": "2019-03-15 17:12:12",
    "desc": ""
},
{
    "id": "247",
    "topics_id": "5",
    "code": "5.36",
    "questions": "Энд түр буюу удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/f3f3cd8554e1d4de4058b5f8586ec1e1.jpg",
    "tdate": "2019-03-15 17:13:27",
    "desc": ""
},
{
    "id": "248",
    "topics_id": "5",
    "code": "5.37",
    "questions": "Суудлын автомашины түр зогсолтыг зөвшөөрөх үү?",
    "images": "/images/b/d6b5db51a174019feb929e6b98d3241f.jpg",
    "tdate": "2019-03-15 17:15:18",
    "desc": "Зурагт үзүүлсэн 'Түр зогсох хориотой' (2.27) тэмдгийн үйлчлэх хүрээ гарцаас цааш үргэлжилнэ."
},
{
    "id": "249",
    "topics_id": "5",
    "code": "5.38",
    "questions": "'Түр зогсох хориотой' тэмдэг зорчих хэсгийн аль талд үйлчлэх вэ?",
    "images": "/images/b/5a736fe167cf7474516a6224a3f21f08.jpg",
    "tdate": "2019-03-15 17:17:54",
    "desc": "'Түр зогсох хориотой' (2.27) тэмдгийн үйлчлэл нь замын тухайн байрласан талдаа хүчинтэй."
},
{
    "id": "250",
    "topics_id": "5",
    "code": "5.39",
    "questions": "Аль тээврийн хэрэгслийн түр зогсолтыг хориглох вэ?",
    "images": "/images/b/ef1b14dbea93413bef36b475a68de859.jpg",
    "tdate": "2019-03-15 17:19:52",
    "desc": "Зурагт үзүүлсэн 'Түр зогсох хориотой' (2.27) тэмдэг нь суурин газрын төгсгөлөөс (5.6тэмдгээс) цааш үйлчлэхгүй."
},
{
    "id": "251",
    "topics_id": "5",
    "code": "5.40",
    "questions": "Энд 5 минут хүртэл хугацаагаар зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/21c594e56d8b94b9a56a475874081ddb.jpg",
    "tdate": "2019-03-15 17:21:54",
    "desc": ""
},
{
    "id": "252",
    "topics_id": "8",
    "code": "8.17",
    "questions": "Зурагт үзүүлсэн замын хэсэгт зайлшгүй зогсолт хийсэн суудлын автомашины жолооч ослын зогсолтын тэмдэг байрлуулах шаардлагатай юу?",
    "images": "/images/b/16a1049d78d162fba54afdf7d9fb1fd8.jpg",
    "tdate": "2019-03-15 17:27:46",
    "desc": ""
},
{
    "id": "253",
    "topics_id": "8",
    "code": "8.18",
    "questions": "Гэрэлтүүллэггүй замын хөвөөн дээр зурагт үзүүлснээр оврын гэрлээ асааж зогсохдоо ослын зогсолтын тэмдэг байрлуулах шаардлагатай юу?",
    "images": "/images/b/29014a2275f641315ba2d9da8633ba19.jpg",
    "tdate": "2019-03-15 17:33:00",
    "desc": ""
},
{
    "id": "254",
    "topics_id": "8",
    "code": "8.19",
    "questions": "Харанхуй үед гэрэлтүүлэггүй замын зорчих хэсэг дээр оврын болон ослын дохионы гэрлүүд нь асахгүй тээврийн хэрэгслийг зогсоохдоо ослын зогсолтын тэмдэг байрлуулах шаардлагатай юу?",
    "images": "",
    "tdate": "2019-03-15 17:38:28",
    "desc": ""
},
{
    "id": "255",
    "topics_id": "8",
    "code": "8.20",
    "questions": "Ослын дохионы гэрэл нь ажиллахгүй автомашиныг чирч хөдөлгөөнд оролцохыг зөвшөөрөх үү?",
    "images": "/images/b/da6c4aa2a71424152a694697cae3eaaa.jpg",
    "tdate": "2019-03-15 17:42:22",
    "desc": ""
},
{
    "id": "256",
    "topics_id": "8",
    "code": "8.21",
    "questions": "Золооч хөдөлгөөн эхлэх болон зогсохын өмнө чиг заах дохиог заавал өгөх шаардлагатай юу?",
    "images": "/images/b/d59671b0920cfe2141684717c2e0be37.jpg",
    "tdate": "2019-03-15 17:44:51",
    "desc": ""
},
{
    "id": "257",
    "topics_id": "8",
    "code": "8.22",
    "questions": "Чиг заах дохиог хэдийд өгөх вэ?",
    "images": "",
    "tdate": "2019-03-15 17:46:27",
    "desc": ""
},
{
    "id": "258",
    "topics_id": "8",
    "code": "8.23",
    "questions": "Уулзварт орохоосоо өмнө чиг заах дохиогоо зогсоохыг аль тээврийн хэрэгслийн жолоочид зөвшөөрөх вэ?",
    "images": "/images/b/0383218a6d7ae504fe1f44694e232a0e.jpg",
    "tdate": "2019-03-15 17:49:29",
    "desc": "Гараар өгсөн дохиог үйлдэл хийж эхлэхийнхээ өмнө дуусгахыг зөвшөөрнө. Харин чиг заах дохиог гэрлээр өгч байгаа тохиолдолд зөвхөн үйлдлээ гүйцэтгэж дууссаны дараа  зогсоохыг зөвшөөрнө (ЗХД-ийн 9.9)."
},
{
    "id": "273",
    "topics_id": "8",
    "code": "8.37",
    "questions": "Таны урд ямар тээврийн хэрэгсэл явж байна вэ?",
    "images": "/images/b/77c31f537714f2f387b3607413c6ebbc.jpg",
    "tdate": "2019-03-15 23:19:22",
    "desc": ""
},
{
    "id": "260",
    "topics_id": "8",
    "code": "8.24",
    "questions": "Аль автомашины жолооч баруун гар тийш эргэх дохио өгч байна вэ?",
    "images": "/images/b/0a9fa561bc3560fba970f5b2f4de760f.jpg",
    "tdate": "2019-03-15 17:52:12",
    "desc": ""
},
{
    "id": "261",
    "topics_id": "8",
    "code": "8.25",
    "questions": "Аль автомашины жолооч зүүн гар тийш эргэх дохио өгч байна вэ?",
    "images": "/images/b/03bd1cf7152054dfeea762a6e20b5a33.jpg",
    "tdate": "2019-03-15 17:54:22",
    "desc": ""
},
{
    "id": "262",
    "topics_id": "8",
    "code": "8.26",
    "questions": "Аль тээврийн хэрэгслийн жолооч чиг заах дохиог буруу өгч байна вэ?",
    "images": "/images/b/a8d8b470f29edb9dabd512c57b9d69a5.jpg",
    "tdate": "2019-03-15 17:58:11",
    "desc": "Ачааны автомашины жолооч зүүн гар тийш, мотоциклын жолооч баруун гар тийш, өөрөөр хэлбэл хоёул явах чигээсээ буруу чигт хандсан дохио өгчээ. Суудлын автомашины жолооч гарцаар баруун гар тийш эргэх дохиог уулзварын өмнө, өөрөөр хэлбэл уулзвараар баруун гар тийш эргэх гэж байгаа мэт ойлголт төрүүлэхээр өгч байгаа нь буруу (ЗХД-ийн 9.11)."
},
{
    "id": "263",
    "topics_id": "8",
    "code": "8.27",
    "questions": "Араас яваа автомашины жолооч ямар утгатай дохио өгч байна вэ?",
    "images": "/images/b/255033b56ccb974027362610dc11c19e.jpg",
    "tdate": "2019-03-15 18:02:08",
    "desc": ""
},
{
    "id": "264",
    "topics_id": "8",
    "code": "8.28",
    "questions": "Мотоциклын жолоочын гараа дээш доош хөдөлгөсөн дохио ямар утгатай вэ?",
    "images": "/images/b/47c8af72f96da824014e63cd063111e4.jpg",
    "tdate": "2019-03-15 18:06:55",
    "desc": ""
},
{
    "id": "265",
    "topics_id": "8",
    "code": "8.29",
    "questions": "Суудлын автомашины жолооч зурагт үзүүлсэн сумны дагуу саадыг тойрон гарахынхаа өмнө баруун гар тийш дохио өгөх шаардлагатай юу?",
    "images": "/images/b/0a1166e16fe807bcad5aba7452a0ece5.jpg",
    "tdate": "2019-03-15 18:09:10",
    "desc": "Чиг заасан дохио нь бусад хөдөлгөөнд оролцогчдыг төөрөлдүүлэхгүй, тэдэнд буруу ойлголт төрүүлэхгүйгээр байвал зохино (ЗХД-ийн 9.11). Зурагт үзүүлснээр саадыг тойрон гарахын өмнө баруун гар тийш дохио өгөх нь зөв мэт боловч энэ нь бусад чиглэлээс яваа жолооч нарт, тухайлбал автобусны жолоочид уулзвараар баруун гар тийш эргэх гэж байгаа мэт буруу ойлголт төрүүлж, улмаар уулзварт түүнтэй зэрэг орж мөргөлдөх аюул үүсгэж болзошгүй юм."
},
{
    "id": "266",
    "topics_id": "8",
    "code": "8.30",
    "questions": "Зурагт үзүүлснээр суудлын автомашины жолооч огцом эргэлтийн өмнө дохио өгөх шаардлагатай юу?",
    "images": "/images/b/429260e8e658188ff8f8ac122c753db1.jpg",
    "tdate": "2019-03-15 18:10:41",
    "desc": "Огцом эргэлтийн өмнө жолооч эгнээгээ өөрчлөхгүй бол чиг заах дохио өгөх шаардлагагүй. Зурагт үзүүлсэн суудлын автомашины дохиог харсан унадаг дугуйчин түүнийг баруун гар тийш шороон замаар эргэх гэж байгааагаар буруу ойлгон, уулзварт зэрэг орж мөргөлдөж болзошгүй юм."
},
{
    "id": "267",
    "topics_id": "8",
    "code": "8.31",
    "questions": "Суурин газарт дуут дохио өгөхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-15 18:12:48",
    "desc": ""
},
{
    "id": "268",
    "topics_id": "8",
    "code": "8.32",
    "questions": "Гүйцэж түрүүлж байгаагаа бусад жолоочид анхааруулах зорилгоор дуут дохио өгөхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-15 18:14:54",
    "desc": ""
},
{
    "id": "269",
    "topics_id": "8",
    "code": "8.33",
    "questions": "Гүйцэж түрүүлэх гэж байгаагаа бусад жолоочид анхааруулах зорилгоор гэрэл шилжүүлэх дохио өгөхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-15 18:17:47",
    "desc": ""
},
{
    "id": "270",
    "topics_id": "8",
    "code": "8.34",
    "questions": "Та суудлын автомашины жолоочид зам тавьж өгөхөөр шийдсэн бол түүнд хэрхэн мэдэгдэх вэ?",
    "images": "/images/b/1616e613987901beef53e768184ed2ae.jpg",
    "tdate": "2019-03-15 18:20:43",
    "desc": ""
},
{
    "id": "271",
    "topics_id": "8",
    "code": "8.35",
    "questions": "Өөдөөс яваа ачааны автомашины бүхээг дээрх гурван гэрэл ямар утга илэрхийлэх вэ?",
    "images": "/images/b/8646bfd1f7dcca009f9b1dc50e2b285b.jpg",
    "tdate": "2019-03-15 18:25:46",
    "desc": ""
},
{
    "id": "272",
    "topics_id": "8",
    "code": "8.36",
    "questions": "Урьд яваа тээврийн хэрэгслийн таних тэмдэгүүд ямар утга илэрхийлэх вэ?",
    "images": "/images/b/34d667124422a052b80a7d8720af252e.jpg",
    "tdate": "2019-03-15 18:30:46",
    "desc": ""
},
{
    "id": "274",
    "topics_id": "8",
    "code": "8.38",
    "questions": "Таны урд  ямар тээврийн хэрэгсэл явж байна юэ?",
    "images": "/images/b/e09d56dda8e722840fc01cd9ac1fb2fb.jpg",
    "tdate": "2019-03-15 23:28:12",
    "desc": ""
},
{
    "id": "275",
    "topics_id": "13",
    "code": "13.11",
    "questions": "Зорчих хэсгийн зүүн гар талын захад зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/3423ca1b9cc0aaef49b5689b2f4de9a7.jpg",
    "tdate": "2019-03-16 13:22:36",
    "desc": ""
},
{
    "id": "276",
    "topics_id": "13",
    "code": "13.12",
    "questions": "Ачаа буулгахын тулд зурагт үзүүлснээр зогсохыг зөвшөөрөх үү",
    "images": "/images/b/16721c493e0447e39917df4a97457f5b.jpg",
    "tdate": "2019-03-16 13:25:07",
    "desc": ""
},
{
    "id": "277",
    "topics_id": "13",
    "code": "13.13",
    "questions": "Зорчих хэсгийн аль талд удаан зогсохыг хориглох вэ?",
    "images": "/images/b/090ca67c483a97145f490dbbaa902a3b.jpg",
    "tdate": "2019-03-16 13:26:38",
    "desc": ""
},
{
    "id": "673",
    "topics_id": "5",
    "code": "5.61",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/3f495c9e5ef104111cabcb66d3456263.jpg",
    "tdate": "2019-03-18 10:26:11",
    "desc": ""
},
{
    "id": "674",
    "topics_id": "5",
    "code": "5.62",
    "questions": "Зурагт үзүүлсэн сумны дагуу хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/b26cda244d119ac2fbfde792024e4752.jpg",
    "tdate": "2019-03-18 10:27:23",
    "desc": "4.1.в 'Зүүн гар тийш явна' тэмдэг бүхий уулзварыг зурагт үзүүлснээр чигээрээ нэвтрэхийг хориглоно."
},
{
    "id": "279",
    "topics_id": "13",
    "code": "13.14",
    "questions": "Энд удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/97f1a37de6b4254302329616b473de41.jpg",
    "tdate": "2019-03-16 13:27:27",
    "desc": "'Зогсоол' /5.17/ тэмдэг нь тээврийн хэрэгсэл удаан зогсоход зориулсан газрыг мэдээлнэ. Нэг чигийн хөдөлгөөнтэй замын зүүн гар талд удаан зогсохыг хориглосон (ЗХД-ийн 14.1).заалттай 5.17 тэмдгийн заалт зөрчигдөж байгаа энэ тохиолдолд тэмдгийн заалтыг баримтална /ЗХД-ийн 7.3/"
},
{
    "id": "280",
    "topics_id": "13",
    "code": "13.15",
    "questions": "Баруун гар талын захаар зогссон тээврийн хэрэгслүүдтэй зэрэгцэн зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/6ecd54e0e855c5765f9056c045004741.jpg",
    "tdate": "2019-03-16 13:32:16",
    "desc": ""
},
{
    "id": "281",
    "topics_id": "13",
    "code": "13.16",
    "questions": "Тээврийн хэрэгслүүдийг зорчих хэсгийн захыг дагуулан хоёр эгнээгээр зэрэгцүүлэн зогсоохыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-16 13:52:35",
    "desc": ""
},
{
    "id": "282",
    "topics_id": "13",
    "code": "13.17",
    "questions": "Зурагт үзүүлснээр хоёр мотоциклыг зэрэгцүүлэн зогсоохыг зөвшөөрөх үү?",
    "images": "/images/b/dfdcf2a879b1b5a32f0c5c0e04445f8a.jpg",
    "tdate": "2019-03-16 13:56:19",
    "desc": ""
},
{
    "id": "676",
    "topics_id": "5",
    "code": "5.64",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/c9d4dc469e4c07d985f6784b8bb647d6.jpg",
    "tdate": "2019-03-18 10:30:26",
    "desc": ""
},
{
    "id": "677",
    "topics_id": "5",
    "code": "5.65",
    "questions": "Суудлын автомашин гарцаар баруун гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/28e047fdecdb799dfaf853e5180525f6.jpg",
    "tdate": "2019-03-18 10:31:47",
    "desc": ""
},
{
    "id": "284",
    "topics_id": "13",
    "code": "13.18",
    "questions": "Суудлын автомашиныг зурагт үзүүлснээр ташуу байрлалаар зогсоохыг зөвшөөрөх үү?",
    "images": "/images/b/3a1262d27beb899f5ef31c408ecb517a.jpg",
    "tdate": "2019-03-16 13:59:49",
    "desc": ""
},
{
    "id": "678",
    "topics_id": "5",
    "code": "5.66",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/9038ddbd40cd8ae63f29f5dd2ba2a270.jpg",
    "tdate": "2019-03-18 10:33:33",
    "desc": ""
},
{
    "id": "286",
    "topics_id": "13",
    "code": "13.19",
    "questions": "Аль тээврийн хэрэгслийн жоолоч хөвөөн дээр зогсох үйлдлийг буруу гүйцэтгэсэн бэ?",
    "images": "/images/b/e3f7a06747415e2400177546c44de753.jpg",
    "tdate": "2019-03-16 14:01:54",
    "desc": "Хөвөөн дээр тээврийн хэрэгслийг ташуу байрлалаар зогсоохыг зөвшөөрөх боловч зорчих хэсэгрүү оруулсан тохиолдолд хориглоно. Мөн нэмэлт тэмдгээр тусгайлан заагаагүй бол явган хүний зам дээр зогсоохыг хориглоно. Иймд зөвхөн мотоциклийн жолооч зогсох үйлдлийг зөв гүйцэтгэжээ."
},
{
    "id": "287",
    "topics_id": "13",
    "code": "13.20",
    "questions": "Аль автомашиныг зурагт үзүүлснээр ташуу байрлалаар зогсоохыг зөвшөөрөх вэ?",
    "images": "/images/b/985ab6c83f1dfa586a189994f0f7032c.jpg",
    "tdate": "2019-03-16 14:04:28",
    "desc": ""
},
{
    "id": "288",
    "topics_id": "13",
    "code": "13.21",
    "questions": "Чиргүүлтэй суудлын автомашиныг зурагт үзүүлснээр зогсоохыг зөвшөөрөх үү? ",
    "images": "/images/b/9e0cf8292ec224b03d12b0be163d0e3b.jpg",
    "tdate": "2019-03-16 22:00:17",
    "desc": ""
},
{
    "id": "289",
    "topics_id": "13",
    "code": "13.22",
    "questions": "Аль тээврийн хэрэгслийг зурагт үзүүлснээр байрлуулж зогсоохыг хориглох вэ?",
    "images": "/images/b/bc900ab67f57c95ca7003a23db3f3639.jpg",
    "tdate": "2019-03-16 22:08:09",
    "desc": ""
},
{
    "id": "291",
    "topics_id": "13",
    "code": "13.23",
    "questions": "Ачааны автомашиныг зурагт үзүүлснээр явган хүний зам дээр зогсоохыг зөвшөөрөх үү?",
    "images": "/images/b/292d72f77a523121749312b08bf54662.jpg",
    "tdate": "2019-03-16 22:16:37",
    "desc": ""
},
{
    "id": "292",
    "topics_id": "13",
    "code": "13.24",
    "questions": "Аль мотоциклыг зурагт үзүүлснээр байрлуулж зогсоохыг зөвшөөрөх вэ?",
    "images": "/images/b/ccbf7095010b600aa56e7b0ae8328c30.jpg",
    "tdate": "2019-03-16 22:20:39",
    "desc": ""
},
{
    "id": "688",
    "topics_id": "5",
    "code": "5.76",
    "questions": "Суурин газрын гаднах замд энэ тэмдгийн үйлчлэх хүрээнд суудлын автомашин ямар хурдтай явахыг зөвшөөрөх вэ?",
    "images": "/images/b/31ea7160593ccda85091ad2d5c52dea8.jpg",
    "tdate": "2019-03-18 10:47:10",
    "desc": ""
},
{
    "id": "294",
    "topics_id": "13",
    "code": "13.25",
    "questions": "Жолооч тээврийн хэрэгслээ орхиж явахын өмнө ямар арга хэмжээ авах үүрэгтэй вэ?",
    "images": "",
    "tdate": "2019-03-16 22:36:41",
    "desc": ""
},
{
    "id": "297",
    "topics_id": "13",
    "code": "13.26",
    "questions": "Тээврийн хэрэгслээ орхиж явах үед жолоочид юуг  хориглох вэ?",
    "images": "",
    "tdate": "2019-03-16 22:45:44",
    "desc": ""
},
{
    "id": "298",
    "topics_id": "13",
    "code": "13.27",
    "questions": "Тээврийн хэрэгслийг орхиж явахдаа 10 нас хүрээгүй хүүхдийг ганцааранг нь үлдээхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-16 22:58:28",
    "desc": ""
},
{
    "id": "299",
    "topics_id": "8",
    "code": "8.39",
    "questions": "Урд яваа тээврийн хэрэгслийн таних тэмдэг ямар утга илэрхийлэх вэ?",
    "images": "/images/b/c836136fe037bf5ffdc460d7915bbe3c.jpg",
    "tdate": "2019-03-16 23:03:59",
    "desc": ""
},
{
    "id": "300",
    "topics_id": "8",
    "code": "8.40",
    "questions": "Таны урд ямар тээврийн хэрэгсэл явж байна вэ?",
    "images": "/images/b/c317ede05d6d5664380eb9fa1a417492.jpg",
    "tdate": "2019-03-16 23:06:28",
    "desc": ""
},
{
    "id": "301",
    "topics_id": "9",
    "code": "9.1",
    "questions": "Жолооч хөдөлгөөн эхлэхийн өмнө",
    "images": "",
    "tdate": "2019-03-16 23:09:41",
    "desc": ""
},
{
    "id": "302",
    "topics_id": "9",
    "code": "9.2",
    "questions": "Аль тээврийн хэрэгслийн жолооч зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/70d6acddcf7daa273af0f4a42cf04a3d.jpg",
    "tdate": "2019-03-16 23:12:06",
    "desc": ""
},
{
    "id": "303",
    "topics_id": "9",
    "code": "9.3",
    "questions": "Та зогсоолд орж зогсохдоо ачааны автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/f164bb1ea3d8a9968c0d4dfb178628b4.jpg",
    "tdate": "2019-03-16 23:13:35",
    "desc": ""
},
{
    "id": "304",
    "topics_id": "9",
    "code": "9.4",
    "questions": "Аль тээврийн хэрэгслийн жолооч зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/ff0b56d01a2c91f075493dbf81ce9cf0.jpg",
    "tdate": "2019-03-16 23:15:29",
    "desc": ""
},
{
    "id": "305",
    "topics_id": "9",
    "code": "9.5",
    "questions": "Аль тээврийн хэрэгслийн жолооч зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/2c01cd09a182561d9e32429b55100c65.jpg",
    "tdate": "2019-03-16 23:16:57",
    "desc": ""
},
{
    "id": "306",
    "topics_id": "9",
    "code": "9.6",
    "questions": "Аль тээврийн хэрэгслийн жолооч давуу эрхтэй вэ?",
    "images": "/images/b/aa97a1e64e7794d8568a1683ac7fb345.jpg",
    "tdate": "2019-03-16 23:18:55",
    "desc": ""
},
{
    "id": "307",
    "topics_id": "9",
    "code": "9.7",
    "questions": "Харилцан байраа солих тохиолдолд аль тээврийн хэрэгслийн жолооч зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/ee0da7a92a0f60531466d65cc0b3b5b0.jpg",
    "tdate": "2019-03-16 23:20:44",
    "desc": ""
},
{
    "id": "308",
    "topics_id": "13",
    "code": "13.28",
    "questions": "10 нас хүрээгүй хүүхдийг тээврийн хэрэгсэлд үлдээж орхиж явахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-16 23:21:30",
    "desc": ""
},
{
    "id": "692",
    "topics_id": "5",
    "code": "5.80",
    "questions": "Цагт 50 км-ээс илүү хурдтай явахыг заасан 'Хурдны доод хязгаарлал' тэмдгийн үйлчлэх хүрээг аль тэмдэг дуусгах вэ?",
    "images": "/images/b/dba9911e7f7056a6a687c777770528c7.jpg",
    "tdate": "2019-03-18 10:58:04",
    "desc": ""
},
{
    "id": "311",
    "topics_id": "9",
    "code": "9.8",
    "questions": "Тээврийн хэрэгслүүдийн харилцан байраа солих дарааллыг заана уу?",
    "images": "/images/b/41b0ef2be407eeb71fa458e68eb915fe.jpg",
    "tdate": "2019-03-16 23:23:15",
    "desc": ""
},
{
    "id": "312",
    "topics_id": "9",
    "code": "9.9",
    "questions": "Аль тохиолдолд суудлын автомашины жолооч зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/32f28449d914bc188c147e140d23ef9c.jpg",
    "tdate": "2019-03-16 23:24:51",
    "desc": ""
},
{
    "id": "313",
    "topics_id": "9",
    "code": "9.10",
    "questions": "Аль тохиолдолд суудлын автомашины жолооч зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/0f730df7576d8d9fc666476f10d3d343.jpg",
    "tdate": "2019-03-16 23:26:31",
    "desc": ""
},
{
    "id": "314",
    "topics_id": "9",
    "code": "9.11",
    "questions": "Та ачааны автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/4f118473820fd6fcec0cf6ad8acf90b5.jpg",
    "tdate": "2019-03-16 23:27:39",
    "desc": ""
},
{
    "id": "315",
    "topics_id": "13",
    "code": "13.29",
    "questions": "Суурин газрын гадна амрах, хонох зэргээр удаан саатахдаа тээврийн хэрэгслээ замын хөвөөн дээр орхихыг зөвшөөрөх үү?",
    "images": "/images/b/f0402226518916220a78b333151a7480.jpg",
    "tdate": "2019-03-16 23:30:22",
    "desc": ""
},
{
    "id": "316",
    "topics_id": "9",
    "code": "9.12",
    "questions": "Та аль чигт явахдаа суудлын автомашины жолоочоос давуу эрхтэй вэ?",
    "images": "/images/b/8e5c0f9e5ddc5566bf0ae373396d0af5.jpg",
    "tdate": "2019-03-16 23:31:09",
    "desc": ""
},
{
    "id": "317",
    "topics_id": "9",
    "code": "9.13",
    "questions": "Та гарцаар зүүн гар тийш эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/bbd87bada0797bfc1c0c97d03080fcc2.jpg",
    "tdate": "2019-03-16 23:33:07",
    "desc": ""
},
{
    "id": "319",
    "topics_id": "9",
    "code": "9.14",
    "questions": "Та чигээрээ явахдаа аль тээврийн хэрэгслийн жолоочоос давуу эрхтэй вэ?",
    "images": "/images/b/0edd5548555b13c61fa59c0a43e5ab92.jpg",
    "tdate": "2019-03-16 23:35:47",
    "desc": ""
},
{
    "id": "320",
    "topics_id": "13",
    "code": "13.30",
    "questions": "Суурин газрын гаднах замд жолооч унтаж амрах зорилгоор удаан зогсохдоо тээврийн хэрэгслээ хаана зогсоохыг зөшөөрөх вэ?",
    "images": "",
    "tdate": "2019-03-16 23:36:45",
    "desc": ""
},
{
    "id": "693",
    "topics_id": "5",
    "code": "5.81",
    "questions": "Энэ тэмдэг юуг мэдээлэх вэ?",
    "images": "/images/b/28db0874f4222ec42461d222fa817089.jpg",
    "tdate": "2019-03-18 11:01:37",
    "desc": ""
},
{
    "id": "323",
    "topics_id": "9",
    "code": "9.15",
    "questions": "Та гарц дээр буцаж эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/a3fa0b16e087af3ea5bfaf3b3930065b.jpg",
    "tdate": "2019-03-16 23:38:38",
    "desc": ""
},
{
    "id": "324",
    "topics_id": "13",
    "code": "13.31",
    "questions": "Энд түр ба удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/471be411df695ec0b1dce3c9ba833dd2.jpg",
    "tdate": "2019-03-16 23:39:44",
    "desc": ""
},
{
    "id": "325",
    "topics_id": "13",
    "code": "13.32",
    "questions": "Зохицуулдаг уулзвар дээр зогсож, хүн буулгах буюу суулгахыг зөвшөөрөх үү?",
    "images": "/images/b/e1d9d3844270e9e60a284fe40d0a80f8.jpg",
    "tdate": "2019-03-16 23:44:01",
    "desc": ""
},
{
    "id": "326",
    "topics_id": "13",
    "code": "13.33",
    "questions": "Зурагт үзүүлснээр уулзвар дээр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/0748bdc063070b351d711a8b0542d70b.jpg",
    "tdate": "2019-03-16 23:47:20",
    "desc": "Тэнхлэгийн үргэлжилсэн шугамтай Т-хэлбэрийн уулзварын хөдөлгөөнд огтлолцохгүй хэсэгт зогсохыг хориглохгүй"
},
{
    "id": "327",
    "topics_id": "9",
    "code": "9.16",
    "questions": "Та гарцаар зүүн гар тийш эргэж замд нийлэхдээ:",
    "images": "/images/b/e665cab71a9cd5d719195a5780abc76c.jpg",
    "tdate": "2019-03-16 23:48:06",
    "desc": ""
},
{
    "id": "328",
    "topics_id": "13",
    "code": "13.34",
    "questions": "Аль тээврийн хэрэгслийн түр зогсолтыг зөвшөөрөх вэ?",
    "images": "/images/b/209c9daf204d20a4f02474b80c6d3c94.jpg",
    "tdate": "2019-03-16 23:49:51",
    "desc": ""
},
{
    "id": "329",
    "topics_id": "9",
    "code": "9.17",
    "questions": "Та гарцаар баруун гар тийш эргэж замаас гарахдаа явган зорчигчид зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/052ca9a97c96b1627612a06e1b873d3d.jpg",
    "tdate": "2019-03-16 23:50:11",
    "desc": ""
},
{
    "id": "330",
    "topics_id": "13",
    "code": "13.35",
    "questions": "Суудлын автомашины түр зогсолтыг зөвшөөрөх үү?",
    "images": "/images/b/0506ca11f7ee87abecb6eff99a6eae80.jpg",
    "tdate": "2019-03-16 23:51:21",
    "desc": ""
},
{
    "id": "331",
    "topics_id": "13",
    "code": "13.36",
    "questions": "Суудлын автомашины түр зогсолтыг зөвшөөрөх үү? ",
    "images": "/images/b/3dff45cc815b61d0cb938a8a597f1233.jpg",
    "tdate": "2019-03-16 23:53:43",
    "desc": "'Түр зогсох хориотой' /2.27/ тэмдгийн үйлчлэх хүрээ уулзвараас цааш үргэлжлэхгүй /ЗХД-ийн 1-р хавсралтын 2.7/."
},
{
    "id": "332",
    "topics_id": "9",
    "code": "9.18",
    "questions": "Та гарцаар зүүн гар тийш эргэхдээ:",
    "images": "/images/b/35a656b109b433ad4395750065081748.jpg",
    "tdate": "2019-03-16 23:54:12",
    "desc": ""
},
{
    "id": "333",
    "topics_id": "13",
    "code": "13.37",
    "questions": "Суудлын автомашины түр зогсолтыг зөвшөөрөх үү?",
    "images": "/images/b/576d9dc1be94b54f5db13ac3d7d64ddd.jpg",
    "tdate": "2019-03-16 23:56:43",
    "desc": ""
},
{
    "id": "334",
    "topics_id": "9",
    "code": "9.19",
    "questions": "Та гарцаар зүүн гар тийш эргэж замд нийлэхдээ:",
    "images": "/images/b/84ae872f6d8973c2a965c7b7c2354426.jpg",
    "tdate": "2019-03-16 23:58:55",
    "desc": ""
},
{
    "id": "335",
    "topics_id": "13",
    "code": "13.38",
    "questions": "Гарцад хамгийн ойр хэдэн метрт түр ба удаан зогсохыг зөвшөөрөх вэ?",
    "images": "/images/b/5890d56cb871487f5912a6725a199dfa.jpg",
    "tdate": "2019-03-16 23:59:14",
    "desc": ""
},
{
    "id": "336",
    "topics_id": "13",
    "code": "13.39",
    "questions": "Аль тээврийн хэрэгслийн түр зогсолтыг хориглох вэ?",
    "images": "/images/b/1125a7844036efe668c95db55d5efff7.jpg",
    "tdate": "2019-03-17 00:00:52",
    "desc": "'Түр зогсох хориотой' /2.27/ тэмдгийн үйлчлэх хүрээ гарцаас цааш үргэлжилнэ."
},
{
    "id": "337",
    "topics_id": "9",
    "code": "9.20",
    "questions": "Суудлын автомашины жолооч гарцаар баруун гар тийш эргэхдээ:",
    "images": "/images/b/7eb9686a40aea87a45e3b4fd0ef1cef9.jpg",
    "tdate": "2019-03-17 00:01:23",
    "desc": ""
},
{
    "id": "338",
    "topics_id": "13",
    "code": "13.40",
    "questions": "Суудлын автомашины түр зогсолтыг зөвшөөрөх үү?",
    "images": "/images/b/f580d10fedd1cba6c8c0a1a0f829f4e1.jpg",
    "tdate": "2019-03-17 00:02:47",
    "desc": ""
},
{
    "id": "339",
    "topics_id": "9",
    "code": "9.21",
    "questions": "Аль тээврийн хэрэгслийн жолооч зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/a5fd482e0721f007b804ea17ca4c5dac.jpg",
    "tdate": "2019-03-17 00:04:24",
    "desc": ""
},
{
    "id": "340",
    "topics_id": "9",
    "code": "9.22",
    "questions": "Хөдөлгөөнөө зэрэг эхэлж байгаа энэ тохиолдолд аль автомашины жолооч зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/d82e09026175fda8575fbbb18510d7ef.jpg",
    "tdate": "2019-03-17 00:06:25",
    "desc": ""
},
{
    "id": "341",
    "topics_id": "13",
    "code": "13.41",
    "questions": "Явган хүний гарц дээр түр зогсохыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 00:08:46",
    "desc": ""
},
{
    "id": "342",
    "topics_id": "9",
    "code": "9.23",
    "questions": "Замын зэргэлдээх нутаг дэвсгэр дотор зурагт үзүүлснээр хөдөлгөөн огтлолцох тохиолдолд аль тээврийн хэрэгслийн жолооч зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/238ac5c2b3c6c18fdafa56ff9ddb344b.jpg",
    "tdate": "2019-03-17 00:09:00",
    "desc": "Хөдөлгөөний дараалал нь дүрмийн бусад заалтаар тусгайлан зохицуулагдаагүй газарт, тухайлбал замын зэргэлдээх нутаг дэвсгэр дотор жолооч баруун гар талаас ойртон ирсэн тээврийн хэрэгсэлд зам  тавьж өгөх үүрэг хүлээнэ (ЗХД-ийн 10.10)"
},
{
    "id": "343",
    "topics_id": "13",
    "code": "13.42",
    "questions": "Явган хүний гарцад хэдэн метрээс ойр зайд түр ба удаан зогсохыг хориглох вэ? ",
    "images": "/images/b/361bd8bc4c86a0f4c9112d792d8f9bfc.jpg",
    "tdate": "2019-03-17 00:11:25",
    "desc": ""
},
{
    "id": "344",
    "topics_id": "9",
    "code": "9.24",
    "questions": "Суудлын автомашины жолооч аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/94088445ba1d5ac99f489caa3f39c148.jpg",
    "tdate": "2019-03-17 00:12:38",
    "desc": ""
},
{
    "id": "345",
    "topics_id": "13",
    "code": "13.43",
    "questions": "Аль тээврийн хэрэгслийн түр зогсолтыг хориглох вэ?",
    "images": "/images/b/6a869f74c2e0d1d88a64e33df5221fa0.jpg",
    "tdate": "2019-03-17 00:13:42",
    "desc": ""
},
{
    "id": "346",
    "topics_id": "13",
    "code": "13.44",
    "questions": "Аль автомашины түр зогсолтыг зөвшөөрөх вэ ?",
    "images": "/images/b/eadb51a8c887bd569f5a9c7c771fcf90.jpg",
    "tdate": "2019-03-17 00:15:20",
    "desc": ""
},
{
    "id": "347",
    "topics_id": "9",
    "code": "9.25",
    "questions": "Та саадыг тойрон гарахдаа өөдөөс яваа ачааны автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/7d2abd682802d125385feab2329ff06e.jpg",
    "tdate": "2019-03-17 00:15:45",
    "desc": ""
},
{
    "id": "348",
    "topics_id": "9",
    "code": "9.26",
    "questions": "Та чигээрээ явахдаа суудлын автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/e93e1bd763ab05054f0264044f561e97.jpg",
    "tdate": "2019-03-17 00:16:58",
    "desc": ""
},
{
    "id": "349",
    "topics_id": "13",
    "code": "13.45",
    "questions": "Энд зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/a19e1a536e4c94c4f2a9257c750ac141.jpg",
    "tdate": "2019-03-17 00:18:43",
    "desc": ""
},
{
    "id": "350",
    "topics_id": "9",
    "code": "9.27",
    "questions": "Та аль чигт явахдаа өөдөөс яваа тээврийн хэрэгслээс давуу эрхтэй вэ?",
    "images": "/images/b/b6ed56c2b0d6433562625f168faa39d6.jpg",
    "tdate": "2019-03-17 00:19:36",
    "desc": ""
},
{
    "id": "351",
    "topics_id": "13",
    "code": "13.46",
    "questions": "Шөнийн цагаар суудлын автомашины жолооч энд түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/51b6fb75986dadd66574a7fdfeae9ca5.jpg",
    "tdate": "2019-03-17 00:20:27",
    "desc": ""
},
{
    "id": "352",
    "topics_id": "9",
    "code": "9.28",
    "questions": "Суудлын автомашины жолооч саадыг тойрон гарахдаа аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/88dbd237c5c5c7826951955a89fa91da.jpg",
    "tdate": "2019-03-17 00:24:07",
    "desc": "Суудлын автомашины жолооч саадыг тойрон гарахдаа өөдөөс яваа ердийн хөсөгт зам тавьж өгөх үүрэгтэй (ЗХД- ийн 10.12) бөгөөд харин араасаа яваа автобусанд зам тавьж өгөх үүрэг хүлээхгүй. Автобусны жолоочын хувьд саадыг тойрон гарч байгаа буюу зүүн гар тийш дохио өгсөн суудлын автомашиныг гүйцэж түрүүлэх хориотой (ЗХД-ийн 13.2.б,в)."
},
{
    "id": "353",
    "topics_id": "13",
    "code": "13.47",
    "questions": "Чиглэлийн тээврийн хэрэгслийн буудал дээр хүн буулгах, суулгахын тулд бусад тээврийн хэрэгсэл зогсохыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 00:24:09",
    "desc": ""
},
{
    "id": "354",
    "topics_id": "9",
    "code": "9.29",
    "questions": "Өөдөөс өгсөж яваа ачааны автомашин саадыг тойрон гарах гэж байгаа энэ тохиолдолд та зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/69dad27a25e6df6c0c2efcfc6b329bcf.jpg",
    "tdate": "2019-03-17 00:26:30",
    "desc": ""
},
{
    "id": "355",
    "topics_id": "9",
    "code": "9.30",
    "questions": "Өгсүүр замд та саадыг тойрон гарахдаа өөдөөс уруудаж яваа суудлын автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/7c33ba52498cf69f19971eb05db81674.jpg",
    "tdate": "2019-03-17 00:28:58",
    "desc": ""
},
{
    "id": "356",
    "topics_id": "9",
    "code": "9.31",
    "questions": "Аль эгнээнээс чигээрээ нэвтрэхийг зөвшөөрөх вэ?",
    "images": "/images/b/60007b8d1c45b6bc8797df9e822f2692.jpg",
    "tdate": "2019-03-17 00:30:46",
    "desc": ""
},
{
    "id": "357",
    "topics_id": "9",
    "code": "9.32",
    "questions": "Зурагт үзүүлсэн уулзвараар та баруун гар тийш эргэхийн өмнө байраа хэрхэн эзлэх вэ?",
    "images": "/images/b/b599f5891e516a57f09414c186af9bfb.jpg",
    "tdate": "2019-03-17 00:33:04",
    "desc": ""
},
{
    "id": "358",
    "topics_id": "9",
    "code": "9.33",
    "questions": "Та уулзвараар зүүн гар тийш эргэхийн тулд аль эгнээг сонгох вэ?",
    "images": "/images/b/caa373a9e15349d6e26ea06c6901fd69.jpg",
    "tdate": "2019-03-17 00:34:51",
    "desc": ""
},
{
    "id": "359",
    "topics_id": "13",
    "code": "13.48",
    "questions": "Чиглэлийн тээврийн хэрэгслийн буудал дээр өдрийн цагаар бусад тээврийн хэрэгсэл зогсож хүн буулгах ,суулгахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 00:35:11",
    "desc": ""
},
{
    "id": "360",
    "topics_id": "13",
    "code": "13.49",
    "questions": "Таксийн зогсоол дээр хүн буулгах, суулгахын тулд бусад тээврийн хэрэгсэл түр зогсохыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 00:39:01",
    "desc": ""
},
{
    "id": "361",
    "topics_id": "14",
    "code": "14.1",
    "questions": "Та баруун гар тийш эргэхдээ аль явган зорчигчийг урьдчилан өнгөрүүлэх үүрэгтэй вэ?",
    "images": "/images/b/14bd2fb3f9a5cabccf590cd70c7d66a0.png",
    "tdate": "2019-03-17 00:39:02",
    "desc": "А явган зорчигчийг зам хөндлөн гарахыг хориглоно."
},
{
    "id": "362",
    "topics_id": "9",
    "code": "9.34",
    "questions": "Аль тээврийн хэрэгслийн хөдөлгөөнийг зөвшөөрөх вэ?",
    "images": "/images/b/fa50f8434634635666e347b244b1a1c6.jpg",
    "tdate": "2019-03-17 00:39:20",
    "desc": ""
},
{
    "id": "364",
    "topics_id": "9",
    "code": "3.35",
    "questions": "Зурагт үзүүлснээр баруун гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/7bd0cfeba9afb973293156a73756666a.jpg",
    "tdate": "2019-03-17 00:40:50",
    "desc": ""
},
{
    "id": "365",
    "topics_id": "13",
    "code": "13.50",
    "questions": "Энд удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/1bacc972fddbd0f0bb011952f7bc1fd8.jpg",
    "tdate": "2019-03-17 00:41:09",
    "desc": ""
},
{
    "id": "366",
    "topics_id": "14",
    "code": "14.2",
    "questions": "Та зүүн гар тийш эргэхдээ явган зорчигчид зам тавиж өгөх үүрэгтэй юу?",
    "images": "/images/b/6d50038189849f91717c4bba2fb41cbc.png",
    "tdate": "2019-03-17 00:43:31",
    "desc": ""
},
{
    "id": "367",
    "topics_id": "9",
    "code": "3.36",
    "questions": "Энэ эгнээнээс аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/6ea905a35110e25f55ba4834f8ed68a4.jpg",
    "tdate": "2019-03-17 00:43:56",
    "desc": ""
},
{
    "id": "368",
    "topics_id": "13",
    "code": "13.51",
    "questions": "Замын энэ хэсэгт түр ба удаан зогсохыг:",
    "images": "/images/b/397b394e09e9987fcc8593409910fb92.jpg",
    "tdate": "2019-03-17 00:44:36",
    "desc": ""
},
{
    "id": "369",
    "topics_id": "9",
    "code": "9.37",
    "questions": "Аль тээврийн хэрэгслийн жолооч байраа буруу эзэлсэн вэ?",
    "images": "/images/b/7a0b6b7f95fbc70764be081d8498983d.jpg",
    "tdate": "2019-03-17 00:45:15",
    "desc": "Зурагт үзүүлсэн зогсоолоос зам руу нийлж буй зорчих хэсэг  дээр суудлын автомашины жолооч эсрэг урсгал сөрж байраа буруу эзэлсэн байна."
},
{
    "id": "370",
    "topics_id": "9",
    "code": "9.38",
    "questions": "Аль эгнээнэс тойрох хөлдгөөнтэй уулзварт орохыг зөвшөөрөх вэ?",
    "images": "/images/b/5e1791fa7e73e516a674dbaac3a4a843.jpg",
    "tdate": "2019-03-17 00:47:06",
    "desc": "Уулзвараар нэвтрэх хөдөлгөөн нь зөвхөн нэг чигт зөвшөөрөгдсөн тохиолдолд аль ч эгнээнээс тухайн чигт явахыг зөвшөөрнө (ЗХД-ийн 10.5). Тойрох хөдөлгөөнтэй уулзвар нь дээрх нөхцөлийг хангах учир аль ч эгнээнээс уг уулзвар руу орохыг зөвшөөрнө."
},
{
    "id": "371",
    "topics_id": "14",
    "code": "14.3",
    "questions": "Та аль чигт явахдаа явган зорчигчийг урьдчилан өнгөрүүлэх үүрэг хүлээх вэ?",
    "images": "/images/b/13c518dd7a68d994b74a692015a378ce.png",
    "tdate": "2019-03-17 00:47:24",
    "desc": "Зохицуулагчийн зөвхөн ар талаас зам хөндлөн гарах явган зорчигчийн хөдөлгөөнийг зөвшөөрнө /ЗХД-ийн 8.14.в/."
},
{
    "id": "372",
    "topics_id": "9",
    "code": "9.39",
    "questions": "Аль эгнээнээс зүүн гар тийш эргэхийг зөвшөөрөх вэ?",
    "images": "/images/b/9edb5c903f55239aac3f66644ab8facc.jpg",
    "tdate": "2019-03-17 00:48:17",
    "desc": "Зурагт нэг чигиин хөдөлгөөнтэй замын төгсгөлд  ойртож байгааг харуулжээ. Ийм замаас зүүн гар тийш эргэхдээ зорчих хэсгийн хамгийн зүүн гар талын захад (А эгнээнд) байр эзлэх шаардлагатай (ЗХД-ийн 10.5)"
},
{
    "id": "373",
    "topics_id": "13",
    "code": "13.52",
    "questions": "Хүн буух буюу суулгахын тулд зурагт үзүүлсэн эгнээнд түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/481e1a883769edac5ff7d3db26d29a22.jpg",
    "tdate": "2019-03-17 00:49:03",
    "desc": ""
},
{
    "id": "374",
    "topics_id": "14",
    "code": "14.4",
    "questions": "Та баруун гар тийш эргэхдээ аль явган зорчигчийг урьдчилан өнгөрүүлэх үүрэгтэй вэ?",
    "images": "/images/b/1ddbf6496926eae81629a106a4a6247a.png",
    "tdate": "2019-03-17 00:49:39",
    "desc": "Б явган зорчигчийг зам хөндлөн гарахыг хориглоно."
},
{
    "id": "375",
    "topics_id": "13",
    "code": "13.53",
    "questions": "Суудалын таксийн түр зогсолтыг зөвшөөрөх үү?",
    "images": "/images/b/60cfb4c203a039f509a1099edfe3e051.jpg",
    "tdate": "2019-03-17 00:50:33",
    "desc": ""
},
{
    "id": "376",
    "topics_id": "9",
    "code": "9.40",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/0a4a158d75ceafe8eb14332ae246accc.jpg",
    "tdate": "2019-03-17 00:50:46",
    "desc": "Зурагт үзүүлсэн нэг чигийн хөдөлгөөнтэй замын төгсгөлөөс суудлын автомашин буцаж эргэхийг (Г чигт) хориглох бөгөөд зүүн гар тийш эргэхийн өмнө зорчих хэсгийн хамгийн зүүн гар талын эгнээ, баруун гар тийш эргэхийн өмнө зорчих хэсгийн хамгийн баруун гар талын эгнээг эзэлсэн байвал зохих тул энэ эгнээнээс баруун болон зүүн гар тийш (А ба В чигт) эргэхийг мөн хориглоно (ЗХД-ийн 10.5). Иймд энэ эгнээнээс зөвхөн чигээрээ  (Б чигт) явахыг зөвшшөрнө."
},
{
    "id": "377",
    "topics_id": "13",
    "code": "13.54",
    "questions": "Мотоциклын жолооч энд хүн буулгахын тулд түр зогсохыг зөвшөөрөх үү? ",
    "images": "/images/b/a9f0549eb4656c9a65bd382342b31710.jpg",
    "tdate": "2019-03-17 00:53:42",
    "desc": ""
},
{
    "id": "378",
    "topics_id": "9",
    "code": "9.41",
    "questions": "Аль тээврийн хэрэгслийн хөдөлгөөнийг хориглох вэ?",
    "images": "/images/b/cba5125c32cfc2ed8e5c7196811c8271.jpg",
    "tdate": "2019-03-17 00:53:53",
    "desc": "Зурагт хөндлөн зам нь нэг чигийн хөдөлгөөнтэй уулзварыг үзүүлжээ. Мотоциклын жолоочын хувьд баруун гар тийш эргэхийг (хөндлөн замын урсгал сөрөхийг) хориглоно. Суудлын автомашины жолоочын хувьд зүүн гар тийш эргэхдээ зөрчих хэсгийн хамгийн зүүг гар талын эгнээг эзлэх ёстой бөгөөд зурагт үзүүлсэн эгнээнээс эргэхийг хориглоно."
},
{
    "id": "379",
    "topics_id": "14",
    "code": "14.5",
    "questions": "Зохицуулдаггүй уулзвараар та аль чигт явахдаа явган зорчигчид зам тавьж өгөх үүрэг хүлээх вэ?",
    "images": "/images/b/c4ab2ee4395267896058b2d9e8fc6c9f.png",
    "tdate": "2019-03-17 00:54:56",
    "desc": ""
},
{
    "id": "380",
    "topics_id": "9",
    "code": "9.42",
    "questions": "Аль тээврийн хэрэгслийн жолооч эгнээ байраа буруу эзэлсэн вэ?",
    "images": "/images/b/93d795a02919929671f1efa9f126cab5.jpg",
    "tdate": "2019-03-17 00:55:48",
    "desc": "Зурагт үзүүлсэн <<Орох хориотой >> (2.1) тэмдэг нь суудлын автомашины яваа зам нэг чигийн (цаанаас нааш чиглэлтэй) хөдөлгөөнтэй болохыг харуулж байгаа бөгөөд суудлын автомашины жолооч зүүн гар тийш эргэхдээ эгнээ байраа зөв эзэлсэн байна. Харин ачааны автомашины жолооч эсрэг урсгал сөрж байраа буруу эзэлжээ."
},
{
    "id": "381",
    "topics_id": "13",
    "code": "13.55",
    "questions": "Энд түр зогсохыг зөвшөөрөх үү? ",
    "images": "/images/b/e0c08849ff570050546dedce6bb4b0af.jpg",
    "tdate": "2019-03-17 00:56:20",
    "desc": ""
},
{
    "id": "382",
    "topics_id": "9",
    "code": "9.43",
    "questions": "Аль эгнээнээс зүүн гар тийш эргэхийг зөвшөөрөх вэ?",
    "images": "/images/b/d8f9d6c3dabd4c122d1f6e58528035bc.jpg",
    "tdate": "2019-03-17 00:57:40",
    "desc": ""
},
{
    "id": "383",
    "topics_id": "13",
    "code": "13.56",
    "questions": "Энд удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/423c2387feec2bedd42d4a4b109807bc.jpg",
    "tdate": "2019-03-17 00:58:20",
    "desc": ""
},
{
    "id": "384",
    "topics_id": "14",
    "code": "14.6",
    "questions": "Суудлын автомашины жолооч баруун гар тийш эргэхдээ хэнд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/adc2e21948c52b0a33976aceaddb2a61.png",
    "tdate": "2019-03-17 00:59:09",
    "desc": ""
},
{
    "id": "385",
    "topics_id": "9",
    "code": "9.44",
    "questions": "Аль эгнээнээс буцаж эргэхийг зөвшөөрөх вэ?",
    "images": "/images/b/fb24c2532dc244ab20f03ec121defa12.jpg",
    "tdate": "2019-03-17 00:59:18",
    "desc": ""
},
{
    "id": "386",
    "topics_id": "13",
    "code": "13.57",
    "questions": "Энд түр ба удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/5822cbbb80482cb71980565396c54596.jpg",
    "tdate": "2019-03-17 01:00:11",
    "desc": "Сургууль орчмын бүс дотор зорчих хэсэг дээр удаан зогсохыг хориглох /ЗХД-ийн 14.9.в/ бөгөөд харин зорчих хэсгийг чөлөөлсөн тохиолдолд энэ хязгаарлалт үйлчлэхгүй."
},
{
    "id": "387",
    "topics_id": "9",
    "code": "9.45",
    "questions": "Энэ эгнээнээс баруун гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/166390216d2b587c94a94cf75761046d.jpg",
    "tdate": "2019-03-17 01:01:24",
    "desc": ""
},
{
    "id": "388",
    "topics_id": "13",
    "code": "13.58",
    "questions": "Энд хөвөөн дээр удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/a042336838ee790767fc49c37c586ad1.jpg",
    "tdate": "2019-03-17 01:01:30",
    "desc": ""
},
{
    "id": "389",
    "topics_id": "9",
    "code": "9.46",
    "questions": "Суудлын автомашин аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/9a3b931345b5b18348098aae8379b359.jpg",
    "tdate": "2019-03-17 01:03:12",
    "desc": ""
},
{
    "id": "390",
    "topics_id": "13",
    "code": "13.59",
    "questions": "Төмөр замын гарам хүртэл 15 м зайд түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/4d7ce65bec4b2f4301f65d7c1783a430.jpg",
    "tdate": "2019-03-17 01:03:38",
    "desc": ""
},
{
    "id": "391",
    "topics_id": "9",
    "code": "9.47",
    "questions": "Хөдөлгөөний нягтрал ихсэж саатсан үед зурагт үзүүлсэн сумны дагуу уулзвар нэвтрэхийг зөвшөөрөх үү?",
    "images": "/images/b/d1a1e022f75ccc85fc819639407f317d.jpg",
    "tdate": "2019-03-17 01:06:05",
    "desc": ""
},
{
    "id": "392",
    "topics_id": "13",
    "code": "13.60",
    "questions": "Төмөр зам гараад түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/0de2c4f7fd4210bf5260b181a46e7daf.jpg",
    "tdate": "2019-03-17 01:06:14",
    "desc": ""
},
{
    "id": "393",
    "topics_id": "14",
    "code": "14.7",
    "questions": "Уулзварын цаана хөдөлгөөний түгжрэл бий болсон энэ тохиолдолд та чигээрээ явахын тулд ямар арга хэмжээ авах вэ?",
    "images": "/images/b/408df8cbd82c759daa2209e62a673e29.jpg",
    "tdate": "2019-03-17 01:06:25",
    "desc": ""
},
{
    "id": "394",
    "topics_id": "9",
    "code": "9.48",
    "questions": "Мотоциклын жолооч байраа зөв эзэлсэн үү?",
    "images": "/images/b/3ce8dbc2bb0db2860a14e59dacf2072e.jpg",
    "tdate": "2019-03-17 01:07:19",
    "desc": "Мотоциклын жолооч баруун гар тийш эргэхдээ зорчих хэсгийн баруун гар талын захад байр эзлэх журмыг зөрчжээ."
},
{
    "id": "395",
    "topics_id": "13",
    "code": "13.61",
    "questions": "Төмөр замаас 20 метр зайд түр ба удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/43426ed29a888ac58d9b3d4506520d4c.jpg",
    "tdate": "2019-03-17 01:08:04",
    "desc": "Гармын эхлэлийг 1.3.а тэмдгээр тооцох бөгөөд уг тэмдэгт 20 м-ээс ойр зайд зогсохыг хориглоно /ЗХД-ийн 14.8.д/."
},
{
    "id": "396",
    "topics_id": "13",
    "code": "13.62",
    "questions": "Төмөр замын гарам хүртэл 50 метр зайд түр ба удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/0c32e592ed93e99df43c3225c280d9a5.jpg",
    "tdate": "2019-03-17 01:09:05",
    "desc": ""
},
{
    "id": "397",
    "topics_id": "9",
    "code": "9.49",
    "questions": "Аль тээврийн хэрэгслийн хөдөлгөөнийг зөвшөөрөх вэ?",
    "images": "/images/b/dace3e43c46f7eedcba282b8ed95655b.jpg",
    "tdate": "2019-03-17 01:10:01",
    "desc": "Ачааны автомашиныг тухайн эгнээнээс зөвхөн чигээрээ явах буюу буцаж эргэхийг зөвшөөрнө."
},
{
    "id": "398",
    "topics_id": "14",
    "code": "14.8",
    "questions": "Уулзварын цаана хөдөлгөөн саатсан энэ тохиолдолд суудлын автомашин уулвар руу орохыг зөвшөөрөх үү?",
    "images": "/images/b/4a0f1ce6ed68de56eeccead2d12d6095.jpg",
    "tdate": "2019-03-17 01:10:13",
    "desc": ""
},
{
    "id": "399",
    "topics_id": "13",
    "code": "13.63",
    "questions": "Төмөр замын гарамд хамгийн ойр хэдэн метрийн зайд удаан зогсохыг зөвшөөрөх вэ?",
    "images": "",
    "tdate": "2019-03-17 01:10:25",
    "desc": ""
},
{
    "id": "400",
    "topics_id": "13",
    "code": "13.64",
    "questions": "Замын энэ хэсэгт удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/3928f108b74dcca2a65b62c2c27b60c4.jpg",
    "tdate": "2019-03-17 01:11:08",
    "desc": "'Төмөр замын гарамд ойртоно' 1.4.в, 1.4.е /нэг зураастай/ тэмдэг нь гарам хүртэл хамгийн холдоо 100 м-т тавигдах тул үүнээс дотогш удаан зогсохыг хориглоно /ЗХД-ийн 14.9.б/."
},
{
    "id": "401",
    "topics_id": "13",
    "code": "13.65",
    "questions": "Гүүрэн дээр түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/99d42f39e342226d54856273aecef903.jpg",
    "tdate": "2019-03-17 01:12:14",
    "desc": ""
},
{
    "id": "402",
    "topics_id": "9",
    "code": "9.50",
    "questions": "Аль тээврийн хэрэгслийн хөдөлгөөнийг зөвшөөрөх  вэ?",
    "images": "/images/b/524a4e15eb3a171622c55e8064e169bf.jpg",
    "tdate": "2019-03-17 01:13:54",
    "desc": "Уулзвар нэвтрэх хөдөлгөөн нь зөвхөн нэг чигт (баруун гар тийш) эргэхийг зөвшөөрнө (ЗХД-ийн 10.5)."
},
{
    "id": "403",
    "topics_id": "13",
    "code": "13.66",
    "questions": "Гүүрэн доор зорчих хэсгийг чөлөөлж түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/5da13ba24805eb7620a8663037f25931.jpg",
    "tdate": "2019-03-17 01:13:58",
    "desc": ""
},
{
    "id": "404",
    "topics_id": "13",
    "code": "13.67",
    "questions": "Хонгил дотор түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/3d6985a11877fc7d19bd938e6898518f.jpg",
    "tdate": "2019-03-17 01:15:03",
    "desc": ""
},
{
    "id": "405",
    "topics_id": "9",
    "code": "9.51",
    "questions": "Суудлын автомашины жолооч тухайн эгнээнээс аль сумны дагуу явахыг зөвшөөрөх вэ?",
    "images": "/images/b/cdbe4f967d4a6a35f569512ed2845b2f.jpg",
    "tdate": "2019-03-17 01:16:41",
    "desc": "Суудлын автомашины жолооч зөвхөн зүүн гар тийш эргэхдээ уг чигийн дагуу хөдөлгөөний үргэлжлэлийг заасан 1.7 тэмдэглэлийг баримтлах үүрэгтэй тул Б сумны дагуу эргэхийг хориглоно ( ЗХД-ийн 10.8). Харин чигээрээ (В чигт) явах тохиолдолд 1.7 тэмдэглэлийг давахыг хориглохгүй."
},
{
    "id": "406",
    "topics_id": "13",
    "code": "13.68",
    "questions": "Зурагт үзүүлснээр  түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/c00e4d0d536244e636bcc2eb54ce8e79.jpg",
    "tdate": "2019-03-17 01:16:42",
    "desc": ""
},
{
    "id": "407",
    "topics_id": "14",
    "code": "14.9",
    "questions": "Шар гэрэл дохио анивчиж байгаа үед та энэ уулварыг хэрхэн нэвтрэх вэ?",
    "images": "/images/b/14190f4c9ab14da1aeca97111fa9dcf9.jpg",
    "tdate": "2019-03-17 01:16:48",
    "desc": ""
},
{
    "id": "408",
    "topics_id": "13",
    "code": "13.69",
    "questions": "Замын энэ хэсэгт ачаа буулгахын тулд түр зогсохыг зөвшөөрөх үү? ",
    "images": "/images/b/461e690b750d33b393ab18dfd3e78ed6.jpg",
    "tdate": "2019-03-17 01:17:38",
    "desc": ""
},
{
    "id": "409",
    "topics_id": "9",
    "code": "9.52",
    "questions": "Зурагт үзүүлсэн сумны дагуу чигээрээ нэвтрэхийг зөвшөөрөх үү?",
    "images": "/images/b/8c475ea01bb9a4bd59e86796bee21537.jpg",
    "tdate": "2019-03-17 01:17:58",
    "desc": "Суудлын автомашины жолооч чигээрээ явахдаа уг чигийн дагуу эгнээний үргэлжлэлийг заасан 1.7 тэмдэглэлийг баримтлах үүрэгтэй ( ЗХД-ийн 10.8)."
},
{
    "id": "410",
    "topics_id": "13",
    "code": "13.70",
    "questions": "Зорчих хэсгийн зүүн гар талд зогссон автобусны эсрэг харалдаа зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/5c563affd17cf6b7968ea3d128cb70e6.jpg",
    "tdate": "2019-03-17 01:18:51",
    "desc": ""
},
{
    "id": "411",
    "topics_id": "13",
    "code": "13.71",
    "questions": "Замын энэ хэсэгт зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/215dadeca1842c4bf6b7c5d5c0f1d7d0.jpg",
    "tdate": "2019-03-17 01:20:35",
    "desc": ""
},
{
    "id": "412",
    "topics_id": "9",
    "code": "9.53",
    "questions": "Аль сумны дагуу эргэхийг зөвшөөрөх вэ?",
    "images": "/images/b/40c3be2c17bfc45063725f864bc32f42.jpg",
    "tdate": "2019-03-17 01:20:38",
    "desc": ""
},
{
    "id": "413",
    "topics_id": "13",
    "code": "13.72",
    "questions": "Суудлын автомашиныг энд зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/b8e170971336f1724bfa8616e177c1b8.jpg",
    "tdate": "2019-03-17 01:21:59",
    "desc": ""
},
{
    "id": "414",
    "topics_id": "14",
    "code": "14.10",
    "questions": "Уулзварт нийлсэн зорчих хэсгүүдийн гадаргуугийн ялгааг тодорхойлж чадахгүй тохиолдолд та уулзварыг хэрхэн нэвтрэх вэ? ",
    "images": "/images/b/babbb04d567e037f8153ead6ddd84320.jpg",
    "tdate": "2019-03-17 01:22:30",
    "desc": ""
},
{
    "id": "415",
    "topics_id": "9",
    "code": "9.54",
    "questions": "Суудлын автомашины сумны дагуух хөдөлгөөнийг зөвшөөрөх үү?",
    "images": "/images/b/2362860f38aed9932f7a48515010e64a.jpg",
    "tdate": "2019-03-17 01:22:55",
    "desc": ""
},
{
    "id": "416",
    "topics_id": "13",
    "code": "13.73",
    "questions": "Зурагт үзүүлснээр түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/6cf126a8d3f6af57dc918bea278ef101.jpg",
    "tdate": "2019-03-17 01:24:38",
    "desc": ""
},
{
    "id": "417",
    "topics_id": "9",
    "code": "9.55",
    "questions": "Өөдөөсөө яваа тээврийн хэрэгслүүд зүүн гар тийш эргэхдээ аль зурагт үзүүлснээр зөрөх вэ?",
    "images": "/images/b/484a2289dce2132db60e52f775e5e823.jpg",
    "tdate": "2019-03-17 01:24:38",
    "desc": ""
},
{
    "id": "418",
    "topics_id": "9",
    "code": "9.56",
    "questions": "Аль сумны дагуу баруун гар тийш эргэхийг зөвшөөрөх вэ?",
    "images": "/images/b/223f265e4e47276dd33f1e4d0adb34df.jpg",
    "tdate": "2019-03-17 01:25:50",
    "desc": ""
},
{
    "id": "419",
    "topics_id": "13",
    "code": "13.74",
    "questions": "Мотоциклийн жолооч энд хүн буулгахын тулд түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/4c7d3d465c96a70d0a94ec7283f7ec3d.jpg",
    "tdate": "2019-03-17 01:26:10",
    "desc": ""
},
{
    "id": "420",
    "topics_id": "14",
    "code": "14.11",
    "questions": "Та зүүн гар тийш эргэхдээ суудлын автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/056e299fb098fce999614d9b4f9823a4.jpg",
    "tdate": "2019-03-17 01:27:17",
    "desc": ""
},
{
    "id": "421",
    "topics_id": "13",
    "code": "13.75",
    "questions": "Аль  тээврийн хэрэгслийн түр зогсолтыг хориглох вэ?",
    "images": "/images/b/895242d3e37752262d27b27809eca0b6.jpg",
    "tdate": "2019-03-17 01:27:41",
    "desc": "Зурагт үзүүлсэн 1.10 тэмдэглэлийг ачааны автомашин талаас тасархай шугам, суудлын автомашин талаас үргэлжилсэн шугаман тэмдэглэлд тооцно."
},
{
    "id": "422",
    "topics_id": "9",
    "code": "9.57",
    "questions": "Зурагт үзүүлснээр тойрох хөдөлгөөнтэй уулзвар руу зэрэгцэн орохдоо аль автомашины жолооч зөрчил гаргаж байна вэ?",
    "images": "/images/b/f274218a327a3cd43771fb594178a4bb.jpg",
    "tdate": "2019-03-17 01:28:30",
    "desc": "Уулзвараар баруун гар тийш эргэх үйлдлийг зорчих хэсгийн баруун гар талын захад аль болох ойр явж гүйцэтгэх (ЗХД-ийн 10.8.в), мөн зэрэгцэн эргэхдээ эргэлтийн дотор талд яваа тээврийн хэрэгслийн жолооч аль болох богино зайг туулж нэвтрэх (ЗХД-ийн 10.8.г) заалтыг Б автомашины жолооч зөрчжээ. А автомашины жолоочийн хувьд баруун гар тийш зэрэгцэн эргэхдээ эзэлж яваа байрлалаа солихгүйгээр хажуугийн зайгаа барьж нэвтрэх (ЗХД-ийн 10.8.г) заалтыг зөрчжээ."
},
{
    "id": "423",
    "topics_id": "14",
    "code": "14.12",
    "questions": "Та зүүн гар тийш эргэхдээ ачааны автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/b6673583072bf6466071b868df4f39ad.jpg",
    "tdate": "2019-03-17 01:28:55",
    "desc": ""
},
{
    "id": "424",
    "topics_id": "13",
    "code": "13.76",
    "questions": "Энд түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/9ac6749e75378e7584ffa8a29603373f.jpg",
    "tdate": "2019-03-17 01:28:56",
    "desc": ""
},
{
    "id": "425",
    "topics_id": "13",
    "code": "13.77",
    "questions": "Энд түр ба удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/0c0fb1fb7ad606f8eece299d9917606b.jpg",
    "tdate": "2019-03-17 01:29:37",
    "desc": ""
},
{
    "id": "426",
    "topics_id": "14",
    "code": "14.13",
    "questions": "Та буцаж эргэхдээ мотоциклд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/31df00473fe0d2aaf6f3c88a58ac6c65.jpg",
    "tdate": "2019-03-17 01:30:24",
    "desc": ""
},
{
    "id": "427",
    "topics_id": "9",
    "code": "9.58",
    "questions": "Ачааны автомашинтай зүүн гар тийш зэрэгцэн эргэх тохиолдолд суудлын автомашины жолооч аль сумны дагуу хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх вэ?",
    "images": "/images/b/b3e08307a9b8de6bc58726f1ab200328.jpg",
    "tdate": "2019-03-17 01:31:09",
    "desc": "Зурагт үзүүлснээр зэрэгцэн эргэх тохиолдолд эргэлтийн дотор  талд яваа суудлын автомашины жолооч аль болох богино зайг туулах үүднээс А сумны дагуу хөдөлгөөнөө  үргэлжлүүлэх үүрэгтэй (ЗХД-ийн 10.8.г)."
},
{
    "id": "428",
    "topics_id": "13",
    "code": "13.78",
    "questions": "Энд автомашинаа орхиж явахыг зөвшөөрөх үү?",
    "images": "/images/b/6abb0645a4e109cf5204cfe172095038.jpg",
    "tdate": "2019-03-17 01:31:26",
    "desc": ""
},
{
    "id": "751",
    "topics_id": "5",
    "code": "5.119",
    "questions": "Аль тэмдэг цагт 40 км хурдтай явахыг зөвшөөрөх вэ?",
    "images": "/images/b/b34c5f874a172290df996481dac15eb1.jpg",
    "tdate": "2019-03-18 12:16:57",
    "desc": ""
},
{
    "id": "430",
    "topics_id": "14",
    "code": "14.14",
    "questions": "Та баруун гар тийш эргэхдээ автобусанд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/d5034dbd6d093aa3faa9f7ef6ae37c13.jpg",
    "tdate": "2019-03-17 01:31:57",
    "desc": ""
},
{
    "id": "431",
    "topics_id": "13",
    "code": "13.79",
    "questions": "Энд түр ба удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/02271bf5c1be9d282f6527ef45396855.jpg",
    "tdate": "2019-03-17 01:32:58",
    "desc": "Зурагт үзүүлснээр зорчих хэсгийг чөлөөлсөн тохиолдолд зогсохыг хориглохгүй /ЗХД-ийн 14.8.м/"
},
{
    "id": "750",
    "topics_id": "5",
    "code": "5.118",
    "questions": "Аль тэмдэг байрласан зорчих хэсэг дээр буцаж эргэхийг хориглох вэ?",
    "images": "/images/b/7bda334aad1eecd845d2c12b5d6d2cc7.jpg",
    "tdate": "2019-03-18 12:15:15",
    "desc": ""
},
{
    "id": "433",
    "topics_id": "14",
    "code": "14.15",
    "questions": "Та чигээрээ явахдаа суудлын автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/692b7b9129e3fe13decd7da500633d76.jpg",
    "tdate": "2019-03-17 01:33:56",
    "desc": "Гэрэл дохионы зохицуулгатай уулзварт дарааллын тэмдгийн заалтыг мөрдөхгүй /ЗХД-ийн 8.3/."
},
{
    "id": "434",
    "topics_id": "13",
    "code": "13.80",
    "questions": "Дугуй хагарснаас шалтгаалан уулзвар дээр зогссон тохиолдолд жолооч нэн түрүүнд ямар арга хэмжээ авах шаардлагатай вэ?",
    "images": "/images/b/8fc6290c3fcf54451fe061f741a57ddf.jpg",
    "tdate": "2019-03-17 01:35:16",
    "desc": ""
},
{
    "id": "435",
    "topics_id": "9",
    "code": "9.59",
    "questions": "Уулзварыг чигээрээ нэвтрэх зорилготой ирсэн суудлын автомашины жолооч энэ тохиолдолд ямар арга хэмжээ авах шаардлагатай вэ?",
    "images": "/images/b/8be334c5f10e98966918e1626c43b71b.jpg",
    "tdate": "2019-03-17 01:36:32",
    "desc": "Зурагт үзүүлснээр захын эгнээг эзэлсэн суудлын автомашины жолоооч чигээрээ явах зорилготой байлаа ч араас нь баруун гар тийш эргэхээр тээврийн хэрэгсэл ирсэн тохиолдолд гэрэл дохио өөрчлөгдөхийг хүлээлгүйгээр өөрийн явах чигийг үл харгалзан тухайн чигт эргэх үүрэгтэй (ЗХД-ийн 10.7)."
},
{
    "id": "436",
    "topics_id": "14",
    "code": "14.16",
    "questions": "Та аль чигт явахдаа тракторт зам тавьж өгөх шаардлагатай вэ?",
    "images": "/images/b/3cb8a8c2a57b227f42a0a69adb2dc451.jpg",
    "tdate": "2019-03-17 01:37:16",
    "desc": ""
},
{
    "id": "437",
    "topics_id": "14",
    "code": "14.17",
    "questions": "Та баруун гар тийш эргэхдээ суудлын автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/0d25557983aeb330c611063de3232b02.jpg",
    "tdate": "2019-03-17 01:39:02",
    "desc": ""
},
{
    "id": "438",
    "topics_id": "9",
    "code": "9.60",
    "questions": "Энэ тохиолдолд суудлын автомашины жолооч заавал зүүн гар тийш эргэх шаардлагатай юу?",
    "images": "/images/b/1b8c00d7a1caa259328ad57ee33ce0ae.jpg",
    "tdate": "2019-03-17 01:39:24",
    "desc": "Тухайн эгнээнээс чигээрээ явахыг зөвшөөрсөн 1.17 тэмдэглэл байгаа тохиоолдолд, мөн зурагт үзүүлснээр захын эгнээг эзлээгүй тохиолдолд суудлын автомашины жолоочийг заавал зүүн гар тийг эргэхийг шаардахгүй (ЗХД-ийн 10.7)."
},
{
    "id": "439",
    "topics_id": "14",
    "code": "14.18",
    "questions": "Та баруун гар тийш эргэхдээ явган зорчигчид зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/3cb2d0ecc71dad1aa5554fa284a0ba6b.jpg",
    "tdate": "2019-03-17 01:40:45",
    "desc": ""
},
{
    "id": "440",
    "topics_id": "14",
    "code": "14.19",
    "questions": "Та баруун гар тийш эргэхдээ ачааны автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/80c207c30d3d562a529c9fe06991cdec.jpg",
    "tdate": "2019-03-17 01:42:40",
    "desc": ""
},
{
    "id": "441",
    "topics_id": "11",
    "code": "11.1",
    "questions": "Суурин газарт суудлын автомашины зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "",
    "tdate": "2019-03-17 01:42:45",
    "desc": ""
},
{
    "id": "442",
    "topics_id": "11",
    "code": "11.2",
    "questions": "Суурин газрын гадна суудлын автомашины зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "",
    "tdate": "2019-03-17 01:45:09",
    "desc": ""
},
{
    "id": "443",
    "topics_id": "14",
    "code": "14.20",
    "questions": "Жолооч аль гэрэл дохиогоор баруун гар тийш эргэхдээ бусад чиглэлээс яваа тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/b6edd2c93e1ca888e6e7a1b82f765a3b.jpg",
    "tdate": "2019-03-17 01:45:13",
    "desc": ""
},
{
    "id": "444",
    "topics_id": "11",
    "code": "11.3",
    "questions": "Харанхуй үед гэрэлтүүлэггүй замын хэсэгт суудлын автомашины ойрын гэрлийг асааж цагт 80 км хурдтай явахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 01:56:57",
    "desc": "Харанхуй үед болон үзэгдэлт хангалтгүй нөхцөлд жолооч өөрийн үзэгдэх хүрээн дотор тээврийн хэрэгслээ зогсоох боломжтой хурдыг сонгож явна (ЗХД-ийн 10.12). Харанхуй үед тээврийн хэрэгслийн ойрын гэрэл нь жолоочид замын үзэгдэлтийг 30-40 м-ийн зайд хангадаг. Гэтэл цагт 80 км хурдтай яваа суудлын автомашины бүрэн зогсолтын зам нь жолоочийн самбаачлах дундаж хугацаа (1 сек)-нд туулах зам болон автомашины тоормосны системийн ажиллагаа, зам дугуйн барьцалт сайн байх үеийн тоормосны замын  уртаар тооцоход 60-70 м болох бөгөөд энэ нь үзэгдэх хүрээнээс бараг хоёр дахин давах тул ЗХД-ийн дээрх заалтын шаардлагыг хангахгүй юм."
},
{
    "id": "445",
    "topics_id": "11",
    "code": "11.4",
    "questions": "Суурин газрын гадна мотоциклын зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "/images/b/d2b10d289cfd81bc3b7f9f065da55529.jpg",
    "tdate": "2019-03-17 01:58:51",
    "desc": ""
},
{
    "id": "446",
    "topics_id": "11",
    "code": "11.5",
    "questions": "Аль мотоциклын жолооч цагт 60 км-ээс илүү хурдтай явах хориотой вэ?",
    "images": "/images/b/1d449205cf2cc618873cef334f859cb9.jpg",
    "tdate": "2019-03-17 02:00:20",
    "desc": ""
},
{
    "id": "447",
    "topics_id": "11",
    "code": "11.6",
    "questions": "Суурин газарт чиргүүлтэй суудлын автомашины зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "",
    "tdate": "2019-03-17 02:02:22",
    "desc": ""
},
{
    "id": "448",
    "topics_id": "11",
    "code": "11.7",
    "questions": "Суурин газрын гадна талын автомашины зөвшөөрөгдөх дээд хурд аль тохиолдолд цагт 60км  байх вэ?",
    "images": "",
    "tdate": "2019-03-17 02:06:06",
    "desc": ""
},
{
    "id": "449",
    "topics_id": "11",
    "code": "11.8",
    "questions": "Суудлын автомашины зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "/images/b/edd73bdfd54db1ae59fb1bcef108afd4.jpg",
    "tdate": "2019-03-17 02:07:59",
    "desc": ""
},
{
    "id": "450",
    "topics_id": "11",
    "code": "11.9",
    "questions": "Тууш замд чиргүүлтэй суудлын автомашины зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "",
    "tdate": "2019-03-17 02:09:42",
    "desc": ""
},
{
    "id": "451",
    "topics_id": "11",
    "code": "11.10",
    "questions": "Тууш замд мотоциклын зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "",
    "tdate": "2019-03-17 02:12:10",
    "desc": ""
},
{
    "id": "452",
    "topics_id": "11",
    "code": "11.11",
    "questions": "Зурагт үзүүлсэн ачааны автомашины зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "/images/b/b9a18a5201c234a10b4202935abb6f2c.jpg",
    "tdate": "2019-03-17 02:14:48",
    "desc": ""
},
{
    "id": "453",
    "topics_id": "11",
    "code": "11.12",
    "questions": "Ачааны автомашин цагт 100 км хурдтай явахыг зөвшөөрөх үү?",
    "images": "/images/b/46b56ef1a09da20d00f45845259817c8.jpg",
    "tdate": "2019-03-17 02:17:05",
    "desc": ""
},
{
    "id": "454",
    "topics_id": "11",
    "code": "11.13",
    "questions": "Зурагт үзүүлсэн тээврийн хэрэгслийн зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "/images/b/1511bd7e279d6f9ab126a36e4f59edcd.jpg",
    "tdate": "2019-03-17 02:18:37",
    "desc": ""
},
{
    "id": "455",
    "topics_id": "11",
    "code": "11.14",
    "questions": "Тээврийн хэрэгслийн хурдыг аль тохиолдолд цагт 40 км-ээс хэтрүүлэхийг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-17 02:22:01",
    "desc": ""
},
{
    "id": "456",
    "topics_id": "11",
    "code": "11.15",
    "questions": "Зурагт үзүүлсэн замын хэсэгт суудлын автомашины зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "/images/b/efd7919c3932650faaf71aae699e34fa.jpg",
    "tdate": "2019-03-17 02:23:42",
    "desc": ""
},
{
    "id": "457",
    "topics_id": "11",
    "code": "11.16",
    "questions": "Тээврийн хэрэгслийн хурдыг хаана цагт 20 км-ээс хэтрүүлэхийг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-17 02:26:58",
    "desc": ""
},
{
    "id": "458",
    "topics_id": "11",
    "code": "11.17",
    "questions": "Тээврийн хэрэгслийн техникийн тодорхойлолтоор тогтоосон дээд хурдыг хэтрүүлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 02:29:29",
    "desc": ""
},
{
    "id": "459",
    "topics_id": "11",
    "code": "11.18",
    "questions": "Зурагт үзүүлсэн ачааны автомашины зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "/images/b/aae23cb9845fe0cca23144c8f295b63b.jpg",
    "tdate": "2019-03-17 02:31:11",
    "desc": ""
},
{
    "id": "460",
    "topics_id": "11",
    "code": "11.19",
    "questions": "Жолооч зам дээр шалтгаангүйгээр хэт удаан явахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 02:33:08",
    "desc": ""
},
{
    "id": "461",
    "topics_id": "11",
    "code": "11.20",
    "questions": "Аль тохиолдолд огцом тоормослохыг зөвшөөрөх вэ? ",
    "images": "",
    "tdate": "2019-03-17 02:36:25",
    "desc": ""
},
{
    "id": "463",
    "topics_id": "9",
    "code": "9.61",
    "questions": "Энэ тохиолдолд зурагт үзүүлснээр баруун гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/a0a27185b51ad629eb7884e12c06013a.jpg",
    "tdate": "2019-03-17 09:15:38",
    "desc": ""
},
{
    "id": "464",
    "topics_id": "9",
    "code": "9.62",
    "questions": "Зорчих хэсгийн өргөн хүрэлцэхгүй тохиолдолд зурагт үзүүлснээр буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/9e1541c09778616f106ab00495679f06.jpg",
    "tdate": "2019-03-17 09:19:10",
    "desc": ""
},
{
    "id": "465",
    "topics_id": "9",
    "code": "9.63",
    "questions": "Аль хэсэг дээр буцаж эргэхийг хориглох вэ?",
    "images": "/images/b/c7e35873532a83990591a4208c74c41b.jpg",
    "tdate": "2019-03-17 09:23:15",
    "desc": ""
},
{
    "id": "466",
    "topics_id": "9",
    "code": "9.64",
    "questions": "Аль тээврийн хэрэгслийн хөдөлгөөнийг хориглох вэ?",
    "images": "/images/b/8ce5caf8b0d68dfe451d12bea0ce8086.jpg",
    "tdate": "2019-03-17 09:25:02",
    "desc": ""
},
{
    "id": "467",
    "topics_id": "9",
    "code": "9.65",
    "questions": "Зурагт үзүүлснээр буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/81790d8131ff4a6e0dec2ab3176eb557.jpg",
    "tdate": "2019-03-17 09:27:11",
    "desc": ""
},
{
    "id": "468",
    "topics_id": "9",
    "code": "9.66",
    "questions": "Зурагт үзүүлснээр буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/91eca2466114e9b132903e1ef8ed6a3e.jpg",
    "tdate": "2019-03-17 09:28:22",
    "desc": ""
},
{
    "id": "469",
    "topics_id": "9",
    "code": "9.67",
    "questions": "Аль сумны дагуу буцаж эргэхийг хориглох вэ?",
    "images": "/images/b/93992df84dc275f8b8cf3fda144fbe23.jpg",
    "tdate": "2019-03-17 09:30:29",
    "desc": ""
},
{
    "id": "470",
    "topics_id": "9",
    "code": "9.68",
    "questions": "Гүүрэн дээр буцаж эргэхийг зөвшөөрөх үү",
    "images": "/images/b/86f8c8f977adcddac696a851fffafe62.jpg",
    "tdate": "2019-03-17 09:32:38",
    "desc": ""
},
{
    "id": "471",
    "topics_id": "9",
    "code": "9.69",
    "questions": "Хонгил дотор буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/1c0ae5353a52013e247a2173f424998d.jpg",
    "tdate": "2019-03-17 09:34:36",
    "desc": ""
},
{
    "id": "472",
    "topics_id": "9",
    "code": "9.70",
    "questions": "Замын хэсэгт буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/24114f41dd3f0ed5e8d55212f7e33ad8.jpg",
    "tdate": "2019-03-17 09:37:01",
    "desc": ""
},
{
    "id": "473",
    "topics_id": "9",
    "code": "9.71",
    "questions": "Зүүн гар талын зам руу орохын тулд уулзвар дээр зурагт үзүүлснээр ухрахыг зөвшөөрөх үү?",
    "images": "/images/b/40760e476e22824c4d3e662ded3e2d73.jpg",
    "tdate": "2019-03-17 09:39:11",
    "desc": ""
},
{
    "id": "474",
    "topics_id": "9",
    "code": "9.72",
    "questions": "Зурагт үзүүлснээр хашаа руу ухарч орохыг зөвшөөрөх үү?",
    "images": "/images/b/19350bd42ae1e466a10987d609b03938.jpg",
    "tdate": "2019-03-17 09:40:38",
    "desc": ""
},
{
    "id": "475",
    "topics_id": "9",
    "code": "9.73",
    "questions": "Буцаж явахын тулд зурагт үзүүлснээр ухрах үйлдэл хийхийг зөвшөөрөх үү?",
    "images": "/images/b/77401030d1b21544ee954c4f79178e81.jpg",
    "tdate": "2019-03-17 09:43:20",
    "desc": ""
},
{
    "id": "476",
    "topics_id": "9",
    "code": "9.74",
    "questions": "Зурагт үзүүлсэн замын хэсэгт ухрах хөдөлгөөнийг зөвшөөрөх үү?",
    "images": "/images/b/def4c260d3304de56745a5d2f418b578.jpg",
    "tdate": "2019-03-17 09:55:18",
    "desc": ""
},
{
    "id": "477",
    "topics_id": "9",
    "code": "9.75",
    "questions": "Зурагт үзүүүлсэн замын хэсэгт ухрахыг зөвшөөрөх үү?",
    "images": "/images/b/fb3d5871e59f2b71a9c4b2dfcf451292.jpg",
    "tdate": "2019-03-17 09:57:36",
    "desc": ""
},
{
    "id": "478",
    "topics_id": "9",
    "code": "9.76",
    "questions": "Зорчигч суулгахын тулд замын энэ хэсэгт ухрахыг зөвшөөрөх үү?",
    "images": "/images/b/e4a595a13473bf2d61f3206218efc2c2.jpg",
    "tdate": "2019-03-17 10:01:06",
    "desc": ""
},
{
    "id": "479",
    "topics_id": "9",
    "code": "9.77",
    "questions": "Зогсоолын талбай руу суудлын таксийг ухрааж зогсоохыг зөвшөөрөх үү?",
    "images": "/images/b/60428a84d88aea9efadb975d1db20964.jpg",
    "tdate": "2019-03-17 10:02:50",
    "desc": ""
},
{
    "id": "480",
    "topics_id": "9",
    "code": "9.78",
    "questions": "Энд ухрах хөдөлгөөнийг зөвшөөрөх үү?",
    "images": "/images/b/ecb54f664fc4477cdb52af722acc78c2.jpg",
    "tdate": "2019-03-17 10:04:24",
    "desc": ""
},
{
    "id": "481",
    "topics_id": "9",
    "code": "9.79",
    "questions": "Гүүрний наана гарч зогсохын тулд зурагт үзүүлснээр ухрахыг зөвшөөрөх үү?",
    "images": "/images/b/4b19237b470f1b0baf6a683bdc2e73df.jpg",
    "tdate": "2019-03-17 10:05:58",
    "desc": ""
},
{
    "id": "482",
    "topics_id": "9",
    "code": "9.80",
    "questions": "Замын энэ хэсэгт ухрахыг зөвшөөрөх үү?",
    "images": "/images/b/addcf399068bf7b123f854b747f36e47.jpg",
    "tdate": "2019-03-17 10:07:59",
    "desc": "Зурагт үзүүлснээр үзэгдэлт 100 м-ийн дотор хязгаарлагдмал газар ухрахыг хориглоно (ЗХД-ийн 10.15). Ухрах үйлдлийг бусдын тусламжтайгаар гүйцэтгэх нь замын хориотой хэсэгт уг үйлдлийг хийхийг зөвшөөрөх үндэслэл болохгүй."
},
{
    "id": "485",
    "topics_id": "12",
    "code": "12.3",
    "questions": "Энэ тохиолдолд танд гүйцэж түрүүлэх үйлдэл эхлэхийг зөвшөөрөх үү?",
    "images": "/images/b/8e4aea7298d185e7846482805af93eae.jpg",
    "tdate": "2019-03-17 10:24:17",
    "desc": ""
},
{
    "id": "486",
    "topics_id": "12",
    "code": "12.4",
    "questions": "Энэ тохиолдолд танд гүйцэж түрүүлэх үйлдэл эхлэхийг зөвшөөрөх үү?",
    "images": "/images/b/49be07575bef97bfd868ae775438c967.jpg",
    "tdate": "2019-03-17 10:26:28",
    "desc": "Зурагт үзүүлснээр араас яваа тээврийн хэрэгсэл таныг гүйцэж түрүүлж байгаа үед танд гүйцэж түрүүлэх үйлдэл эхлэхийг хориглоно (ЗХД-ийн 13.2.г)."
},
{
    "id": "487",
    "topics_id": "12",
    "code": "12.5",
    "questions": "Гүйцэгдэж байгаа үед та ямар үүрэг хүлээх вэ?",
    "images": "/images/b/ab35cccded4df39040d744143fb03d33.jpg",
    "tdate": "2019-03-17 10:29:44",
    "desc": ""
},
{
    "id": "488",
    "topics_id": "12",
    "code": "12.6",
    "questions": "Гүйцэж түрүүлэх нь аюултай болохыг та арынхаа автомашины жолоочид хэрхэн анхааруулах вэ?",
    "images": "/images/b/34675d013bf745a07b22c4432b4c0fe3.jpg",
    "tdate": "2019-03-17 10:32:55",
    "desc": ""
},
{
    "id": "489",
    "topics_id": "12",
    "code": "12.7",
    "questions": "Уулзвар дээр гүйцэж  түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/c812dfd779f07ae590d041e0d04fc205.jpg",
    "tdate": "2019-03-17 10:34:37",
    "desc": ""
},
{
    "id": "490",
    "topics_id": "12",
    "code": "12.8",
    "questions": "Уулзвар дээр гүйцэхийг зөвшөөрөх үү?",
    "images": "/images/b/23976361455b5b508c398d2c520317c6.jpg",
    "tdate": "2019-03-17 10:35:51",
    "desc": ""
},
{
    "id": "491",
    "topics_id": "12",
    "code": "12.9",
    "questions": "Энд гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/3ad6a7eafc38e9a206914c600bb8cd11.jpg",
    "tdate": "2019-03-17 10:37:09",
    "desc": ""
},
{
    "id": "492",
    "topics_id": "12",
    "code": "12.10",
    "questions": "Энд гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/87bc1ccdcfacf3c60fcc7c20bc049d3c.jpg",
    "tdate": "2019-03-17 10:39:28",
    "desc": ""
},
{
    "id": "493",
    "topics_id": "12",
    "code": "12.11",
    "questions": "Энд гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/4be31d39e41540e809ce58f4021e004a.jpg",
    "tdate": "2019-03-17 10:41:22",
    "desc": ""
},
{
    "id": "494",
    "topics_id": "12",
    "code": "12.12",
    "questions": "Энд хэт удаан явж байгаа ачааны автомашиныг цагт 20 км-ээс хэтрэхгүй хурдаар гүйцэхийг зөвшөөрөх үү?",
    "images": "/images/b/534df7358028f969a9d13da9f8c32110.jpg",
    "tdate": "2019-03-17 10:44:37",
    "desc": "Хороолол дотор гүйцэж түрүүлэхийг хориглох боловч зурагт үзүүлсэн нэг чигийн хөдөлгөөнтэй (5.7 тэмдэгтэй) зорчих хэсэг дээр гүйцэх үйлдэл хийхийг хориглохгүй. Гэхдээ гүйцэх үйлдэл хийхдээ гүйцэгдэж байгаа тээврийн хэрэгслийн урдуур явган зорчигч явж байгаа эсэхийг анхаарч мэдсэн байх шаардлагатай (ЗХД-ийн 13.5)."
},
{
    "id": "495",
    "topics_id": "12",
    "code": "12.13",
    "questions": "Энд гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/1b23b2e1352226584e8ac9d6e8eb5397.jpg",
    "tdate": "2019-03-17 10:45:42",
    "desc": ""
},
{
    "id": "496",
    "topics_id": "12",
    "code": "12.14",
    "questions": "Аль суудлын автомашины зурагт үзүүлсэн үйлдлийг хориглох вэ?",
    "images": "/images/b/847c71bba00f1d6e2f6d15a9f7b814e4.jpg",
    "tdate": "2019-03-17 10:48:46",
    "desc": ""
},
{
    "id": "497",
    "topics_id": "12",
    "code": "12.15",
    "questions": "Суурин газрын доторх замын энэ хэсэгт гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/12aae42385b80e4c52fa60c207cc7146.jpg",
    "tdate": "2019-03-17 10:50:46",
    "desc": ""
},
{
    "id": "498",
    "topics_id": "15",
    "code": "15.1",
    "questions": "Та аль зорчигчид зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/b10e9377cbd5188deb2f5488710d1336.jpg",
    "tdate": "2019-03-17 10:52:00",
    "desc": ""
},
{
    "id": "499",
    "topics_id": "12",
    "code": "12.16",
    "questions": "Төмөр замын гарам гараад гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/208c66411508735a337554cb0be6c2e7.jpg",
    "tdate": "2019-03-17 10:53:14",
    "desc": ""
},
{
    "id": "500",
    "topics_id": "15",
    "code": "15.2",
    "questions": "Шар гэрэл дохио анивчиж байгаа энэ тохиолдолд та явган хүний гарцыг хэрхэн нэвтрэх вэ?",
    "images": "/images/b/a2eaa8b4700aa231e583c207123744b0.jpg",
    "tdate": "2019-03-17 10:58:21",
    "desc": ""
},
{
    "id": "501",
    "topics_id": "15",
    "code": "15.3",
    "questions": "Энэ тохиолдолд та зам хөндлөн гарахаар завдаж байгаа зорчигчийг урьдчилан өнгөрүүлэх үүрэгтэй юу?",
    "images": "/images/b/ef3240374eba9e009de4fcbd55ba8494.jpg",
    "tdate": "2019-03-17 11:01:48",
    "desc": ""
},
{
    "id": "502",
    "topics_id": "12",
    "code": "12.17",
    "questions": "Замын өгсүүр хэсгийн төгсгөлд гүйцэж түрүүлэх үйлдэл эхлэхийг зөвшөөрөх үү?",
    "images": "/images/b/0a3e222fcc2f3da23aaea1cbd783d8af.jpg",
    "tdate": "2019-03-17 11:03:25",
    "desc": ""
},
{
    "id": "503",
    "topics_id": "15",
    "code": "15.4",
    "questions": "Зөвшөөрсөн гэрэл дохио асах үед та хөдөлгөөн эхлэхдээ аль явган зорчигчийг урьдчилан өнгөрүүлэх үүрэгтэй вэ?",
    "images": "/images/b/ac4935488cc93a1f5650188fbdc29681.jpg",
    "tdate": "2019-03-17 11:06:10",
    "desc": ""
},
{
    "id": "504",
    "topics_id": "12",
    "code": "12.18",
    "questions": "Энд мотоциклыг гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/b0ce8fe2f3a064a578f6941e2ccdb44e.jpg",
    "tdate": "2019-03-17 11:06:11",
    "desc": "<<Гүйцэж түрүүлэх хориотой >> (2.20) тэмдгийн үйлчлэх хүрээнд мотоциклыг  гүйцэж түрүүлэхийг  зөвшөөрнө. Мөн өгсүүр замд өгсүүрийн төгсгөлд хүрэхээс өмнө үйлдлээ дуусгаж амжих бол гүйцэж түрүүлэхийг хориглохгүй."
},
{
    "id": "505",
    "topics_id": "12",
    "code": "12.19",
    "questions": "Энд гүйцэх үйлдэл эхлэхийг зөвшөөрөх үү?",
    "images": "/images/b/348164201230c105ad513bcd570d75d8.jpg",
    "tdate": "2019-03-17 11:07:32",
    "desc": ""
},
{
    "id": "506",
    "topics_id": "12",
    "code": "12.20",
    "questions": "Замын энэ хэсэгт гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/acb939789482481581ba766b920e3718.jpg",
    "tdate": "2019-03-17 11:08:37",
    "desc": ""
},
{
    "id": "507",
    "topics_id": "15",
    "code": "15.5",
    "questions": "Баруун гар талын эгнээнд яваа тээврийн хэрэгсэл явган хүний гарцын өмнө хурдаа хасаж зогсвол та нэн түрүүнд ямар арга хэмжээ авах вэ?",
    "images": "/images/b/fb4b1c22b9269be6dccc6475975318be.jpg",
    "tdate": "2019-03-17 11:11:38",
    "desc": ""
},
{
    "id": "508",
    "topics_id": "10",
    "code": "10.1",
    "questions": "Зурагт үзүүлсэн эсрэг хөдөлгөөнтэй замаас та зүүн гар тийш эргэхдээ байрлалаа хэрхэн эзлэх вэ?",
    "images": "/images/b/1a98af7aeff7423c104f47c5efc36f29.jpg",
    "tdate": "2019-03-17 11:14:11",
    "desc": ""
},
{
    "id": "509",
    "topics_id": "15",
    "code": "15.6",
    "questions": "Явган хүний гарц дээр гүйцэх үйлдэл хийхийг зөвшөөрөх үү?",
    "images": "/images/b/fe8355adb86aacf5f6a24cdf3c8a743e.jpg",
    "tdate": "2019-03-17 11:16:11",
    "desc": ""
},
{
    "id": "510",
    "topics_id": "10",
    "code": "10.2",
    "questions": "Зурагт үзүүлсэн замаас та зүүн гар тийш эргэхдээ байрлалаа хэрхэн эзлэх вэ?",
    "images": "/images/b/a20502668ebb461ec065d2afca7514cf.jpg",
    "tdate": "2019-03-17 11:16:29",
    "desc": ""
},
{
    "id": "511",
    "topics_id": "15",
    "code": "15.7",
    "questions": "Зурагт үзүүлсэн явган зорчигчид та зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/f5a34d5bb9b45eb1a914ecbc9ff8497d.jpg",
    "tdate": "2019-03-17 11:19:26",
    "desc": ""
},
{
    "id": "512",
    "topics_id": "10",
    "code": "10.3",
    "questions": "Тээврийн хэрэгслүүд зурагт үзүүлснээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/50e85a00053a54d618781729245da475.jpg",
    "tdate": "2019-03-17 11:20:51",
    "desc": ""
},
{
    "id": "513",
    "topics_id": "10",
    "code": "10.4",
    "questions": "Зурагт үзүүлснээр нэг эгнээнд хоёр мотоцикл зэрэгцэн явахыг зөвшөөрөх үү?",
    "images": "/images/b/8f24e6786b522c5b9b94fb73dd430861.jpg",
    "tdate": "2019-03-17 11:22:52",
    "desc": ""
},
{
    "id": "514",
    "topics_id": "10",
    "code": "10.5",
    "questions": "Зурагт үзүүлсэн эсрэг хөдөлгөөнтэй замд аль эгнээгээр байрлан явахыг зөвшөөрөх вэ?",
    "images": "/images/b/d924874c6204591ca2c593352b51cd8c.jpg",
    "tdate": "2019-03-17 11:25:03",
    "desc": ""
},
{
    "id": "515",
    "topics_id": "15",
    "code": "15.8",
    "questions": "Зурагт үзүүлснээр ослын дохионы гэрлээ асааж зогссон автобусны дэргэдүүр өнгөрөхдөө та ямар үүрэг хүлээх вэ?",
    "images": "/images/b/646820b521470b2213dfcd541d7b498b.jpg",
    "tdate": "2019-03-17 11:26:56",
    "desc": ""
},
{
    "id": "516",
    "topics_id": "10",
    "code": "10.6",
    "questions": "Хоёр эгнээгээр зорчдог замын баруун гар талын эгнээнд хөдөлгөөний нягтрал ихсэж саатсан үед зүүн гар талын эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/c6374c5fa57e873554f494b8126513f9.jpg",
    "tdate": "2019-03-17 11:28:26",
    "desc": ""
},
{
    "id": "517",
    "topics_id": "10",
    "code": "10.7",
    "questions": "Гүйцэж түрүүлэх зорилгоор эсрэг урсгал сөрөхийг зөвшөөрөх үү?",
    "images": "/images/b/7fb098a1e22710e908b04fa17d8254df.jpg",
    "tdate": "2019-03-17 11:29:36",
    "desc": ""
},
{
    "id": "518",
    "topics_id": "15",
    "code": "15.9",
    "questions": "Энэ тохиолдолд та хүүхдүүдийг урьдчилан өнгөрүүлэх үүрэгтэй юу?",
    "images": "/images/b/4d579fc29f1a60d3bdf85628bb919e5c.jpg",
    "tdate": "2019-03-17 11:30:01",
    "desc": ""
},
{
    "id": "519",
    "topics_id": "10",
    "code": "10.8",
    "questions": "Саадыг тойрон гарахын тулд эсрэг урсгал сөрөхийг зөвшөөрөх үү?",
    "images": "/images/b/3797b5381182c63d9130ac57eba6a564.jpg",
    "tdate": "2019-03-17 11:32:13",
    "desc": ""
},
{
    "id": "520",
    "topics_id": "15",
    "code": "15.10",
    "questions": "Явган хүний гарцын цаана хөдөлгөөн саатсан энэ тохиолдолд гарц руу орохыг зөвшөөрөх үү?",
    "images": "/images/b/58c5b2ed8217aeef423e5fa38db0b592.jpg",
    "tdate": "2019-03-17 11:33:46",
    "desc": ""
},
{
    "id": "521",
    "topics_id": "10",
    "code": "10.9",
    "questions": "Эсрэг хөдөлгөөнтэй хоёр эгнээгээр зорчдог замд зүүн гар талын эгнээ рүү орохыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 11:36:33",
    "desc": ""
},
{
    "id": "522",
    "topics_id": "10",
    "code": "10.10",
    "questions": "Та суудлын автомашиныг гүйцэж түрүүлсний дараа баруун гар талын эгнээнд шилжих шаардлагатай юу?",
    "images": "/images/b/03075ae36c06b25b5f0ffcd4410a2601.jpg",
    "tdate": "2019-03-17 11:39:21",
    "desc": ""
},
{
    "id": "523",
    "topics_id": "10",
    "code": "10.11",
    "questions": "Гарцаар зүүн гар тийш эргэхийн тулд зурагт үзүүлснээр эсрэг урсгал сөрөхийг зөвшөөрөх үү?",
    "images": "/images/b/60edff4fef998822cdc0afef872cee65.jpg",
    "tdate": "2019-03-17 11:42:03",
    "desc": ""
},
{
    "id": "524",
    "topics_id": "16",
    "code": "16.1",
    "questions": "Жолооч төмөр замыг гарамгүй хэсгээр нэвтэрхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 11:42:06",
    "desc": ""
},
{
    "id": "525",
    "topics_id": "10",
    "code": "10.12",
    "questions": "Эргэлтийн радиусыг алсуур болгохын тулд зурагт үзүүлснээр урсгал сөрөхийг зөвшөөрөх үү?",
    "images": "/images/b/8062543a1941d1a8567a84e276a5dafb.jpg",
    "tdate": "2019-03-17 11:45:02",
    "desc": ""
},
{
    "id": "526",
    "topics_id": "10",
    "code": "10.13",
    "questions": "Зурагт үзүүлсэн зорчих хэсгийн дунд эгнээ нь:",
    "images": "/images/b/2228599e65a04e13e10c6a9c0b71104d.jpg",
    "tdate": "2019-03-17 11:47:11",
    "desc": ""
},
{
    "id": "527",
    "topics_id": "10",
    "code": "10.14",
    "questions": "Аль эгнээгээр байрлан явахыг зөвшөөрөх вэ?",
    "images": "/images/b/423a918192c53041547fd43078ae8500.jpg",
    "tdate": "2019-03-17 11:49:37",
    "desc": ""
},
{
    "id": "528",
    "topics_id": "16",
    "code": "16.2",
    "questions": "Галт тэрэг ойртон ирж яваа энэ тохиолдолд жолооч ямар арга хэмжээ авбал зохих вэ?",
    "images": "/images/b/e8d0b8380d89b89e44dde8bb20fc3bb7.jpg",
    "tdate": "2019-03-17 11:52:02",
    "desc": ""
},
{
    "id": "529",
    "topics_id": "10",
    "code": "10.15",
    "questions": "Дунд эгнээгээр байрлан явахыг зөшөөрөх үү?",
    "images": "/images/b/ae320f4aa8ff12750456cdf457e83eec.jpg",
    "tdate": "2019-03-17 11:54:16",
    "desc": ""
},
{
    "id": "530",
    "topics_id": "16",
    "code": "16.3",
    "questions": "Төмөр замын гармын анивчсан улаан гэрэл дохио нь:",
    "images": "",
    "tdate": "2019-03-17 11:56:24",
    "desc": ""
},
{
    "id": "531",
    "topics_id": "10",
    "code": "10.16",
    "questions": "Гурван эгнээгээр зорчдог замын сөрөг хөдөлгөөнтэй дунд эгнээ рүү аль тохиолдолд орохыг зөвшөөрөх вэ?",
    "images": "",
    "tdate": "2019-03-17 11:58:11",
    "desc": ""
},
{
    "id": "532",
    "topics_id": "10",
    "code": "10.17",
    "questions": "Гүйцэж түрүүлэх зорилгоор дунд эгнээнд орохыг зөвшөөрөх үү?",
    "images": "/images/b/651b18de0a3086989456278f3d630b39.jpg",
    "tdate": "2019-03-17 12:00:14",
    "desc": ""
},
{
    "id": "533",
    "topics_id": "16",
    "code": "16.4",
    "questions": "Төмөр замын гармын дуут дохио нь:",
    "images": "",
    "tdate": "2019-03-17 12:02:35",
    "desc": ""
},
{
    "id": "534",
    "topics_id": "16",
    "code": "16.5",
    "questions": "Төмөр замын гармын хаалт хаагдаж эхэлбэл та ямар арга хэмжээ авах вэ? ",
    "images": "/images/b/12edeb58f08a218dbba2db8d90ceebb9.jpg",
    "tdate": "2019-03-17 12:14:08",
    "desc": ""
},
{
    "id": "535",
    "topics_id": "16",
    "code": "16.6",
    "questions": "Энэ тохиолдолд та ямар арга хэмжээ авах вэ?",
    "images": "/images/b/d25ad57a82fceb73127da8ebba3fbc29.jpg",
    "tdate": "2019-03-17 12:29:23",
    "desc": ""
},
{
    "id": "536",
    "topics_id": "16",
    "code": "16.7",
    "questions": "Энэ тохиолдолд төмөр замын гарам нэвтэрхийг зөвшөөрөх үү?",
    "images": "/images/b/b2847430c6ac7ce07c6865acc7df4a9f.jpg",
    "tdate": "2019-03-17 12:36:54",
    "desc": ""
},
{
    "id": "537",
    "topics_id": "16",
    "code": "16.8",
    "questions": "Энэ тохиолдолд та хаана зогсож галт тэргийг өнгөрүүлэх үүрэгтэй вэ?",
    "images": "/images/b/fc9dc5d6626350bbd93e855e506f7065.jpg",
    "tdate": "2019-03-17 12:41:00",
    "desc": ""
},
{
    "id": "538",
    "topics_id": "16",
    "code": "16.9",
    "questions": "Энэ тохиолдолд та хаана зогсож галт тэргийг өнгөрүүлэх вэ? ",
    "images": "/images/b/ee0d1ceeaa69bb2f89bc4b052982f252.jpg",
    "tdate": "2019-03-17 12:47:07",
    "desc": ""
},
{
    "id": "539",
    "topics_id": "16",
    "code": "16.10",
    "questions": "Энэ тохиолдолд та хаана зогсож галт тэргийг өнгөрүүлэх вэ?",
    "images": "/images/b/d16cd2408546b827939059f92c045eed.jpg",
    "tdate": "2019-03-17 12:52:58",
    "desc": ""
},
{
    "id": "540",
    "topics_id": "16",
    "code": "16.11",
    "questions": "Төмөр замын гармын хаалтаас ямар зайд зогсож галт тэргийг өнгөрүүлэх үүрэгтэй вэ?",
    "images": "/images/b/8b2278dfe5d6ba95ea5dba3c726df5c4.jpg",
    "tdate": "2019-03-17 13:02:53",
    "desc": ""
},
{
    "id": "541",
    "topics_id": "16",
    "code": "16.12",
    "questions": "Төмөр зам хүртэл хамгийн ойрдоо хэдэн метрийн зайд зогсож галт тэргийг өнгөрүүлэх вэ?",
    "images": "/images/b/f325b0a20e0b2008a4c04c8c7fa29783.jpg",
    "tdate": "2019-03-17 13:06:23",
    "desc": ""
},
{
    "id": "542",
    "topics_id": "16",
    "code": "16.13",
    "questions": "Төмөр замын гармын өмнө зогссон автомашиныг тойрон гарахыг зөвшөөрөх үү?",
    "images": "/images/b/307d2304e1bfe12a3b2a08fbbe64d44e.jpg",
    "tdate": "2019-03-17 13:14:05",
    "desc": ""
},
{
    "id": "543",
    "topics_id": "16",
    "code": "16.14",
    "questions": "Төмөр замын гармын цаана хөдөлгөөн саатсан энэ тохиолдолд гарам руу орохыг зөвшөөрөх үү?",
    "images": "/images/b/86075ce07ae45077e7f68b4a0662b440.jpg",
    "tdate": "2019-03-17 13:26:20",
    "desc": ""
},
{
    "id": "544",
    "topics_id": "16",
    "code": "16.15",
    "questions": "Төмөр замын гарам дээр техникийн саатлаар зогссон тээврийн хэрэгслийн жолооч нэн түрүүнд ямар арга хэмжээ авах шаардлагатай вэ?",
    "images": "",
    "tdate": "2019-03-17 13:32:52",
    "desc": ""
},
{
    "id": "545",
    "topics_id": "16",
    "code": "16.16",
    "questions": "Төмөр замын гарам дээр зайлшгүй зогсолт хийсэн тээврийн хэрэгслийн жолооч гармыг нэн даруй чөлөөлөх боломжгүй бол анхааруулах дохиог хэрхэн өгөх вэ?",
    "images": "",
    "tdate": "2019-03-17 13:51:02",
    "desc": ""
},
{
    "id": "546",
    "topics_id": "16",
    "code": "16.17",
    "questions": "Төмөр замын гарам дээр зайлшгүй зогсолт хийсэн тээврийн  хэрэгслийн жолооч галт тэрэг ирж яваа үед зогсох дохиог хэрхэн өгөх вэ?",
    "images": "",
    "tdate": "2019-03-17 15:13:14",
    "desc": ""
},
{
    "id": "547",
    "topics_id": "16",
    "code": "16.18",
    "questions": "Тээврийн хэрэгслээсээ хэд орчим метрийн зайнаас галт тэргэнд зогсох дохиог өгвөл зохих вэ?",
    "images": "/images/b/11df124b9959dd5439f1ca10e811f139.jpg",
    "tdate": "2019-03-17 15:18:09",
    "desc": ""
},
{
    "id": "548",
    "topics_id": "16",
    "code": "16.19",
    "questions": "Төмөр замын гарам дээр зайлшгүй зогсолт хийсэн тээврийн хэрэгслийн жолооч түгшүүрийн дуут дохиог хэрхэн өгөх вэ?",
    "images": "",
    "tdate": "2019-03-17 15:26:00",
    "desc": ""
},
{
    "id": "549",
    "topics_id": "16",
    "code": "16.20",
    "questions": "Харанхуй үед төмөр замын гарам дээр зайлшгүй зогсолт хийсэн тохиолдолд ойртон ирж яваа галт тэргэнд зогсох дохиог хэрхэн өгөх вэ? ",
    "images": "",
    "tdate": "2019-03-17 15:57:45",
    "desc": ""
},
{
    "id": "550",
    "topics_id": "18",
    "code": "18.1",
    "questions": "Та аль явган зорчигчид зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/57708ca70c4c0cede6b7a888563fa617.jpg",
    "tdate": "2019-03-17 16:04:34",
    "desc": ""
},
{
    "id": "551",
    "topics_id": "18",
    "code": "18.2",
    "questions": "Энд зөвшөөрөгдөх дээд хурд хэд вэ?",
    "images": "/images/b/20650a8cdeef1fad00d5e4593fb83cda.jpg",
    "tdate": "2019-03-17 16:54:32",
    "desc": ""
},
{
    "id": "552",
    "topics_id": "18",
    "code": "18.3",
    "questions": "Хороолол дотор гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/b1905815edb13927c142781455ba4305.jpg",
    "tdate": "2019-03-17 16:59:29",
    "desc": ""
},
{
    "id": "553",
    "topics_id": "18",
    "code": "18.4",
    "questions": "Энд тээврийн хэрэгслийг асаалттай зогсоохыг зөвшөөрөх үү?",
    "images": "/images/b/f8d5858c520fb81b0aa9c5962209fdbf.jpg",
    "tdate": "2019-03-17 17:04:24",
    "desc": ""
},
{
    "id": "554",
    "topics_id": "18",
    "code": "18.5",
    "questions": "Хороолол дотор суудлын автомашиныг удаан зогсоохыг зөвшөөрөх үү?",
    "images": "/images/b/0ceedb8bd40df1a0fbbe7bfa92bc6369.jpg",
    "tdate": "2019-03-17 17:36:59",
    "desc": ""
},
{
    "id": "555",
    "topics_id": "18",
    "code": "18.6",
    "questions": "Энд ачааны автомашины хөдөлгүүрийг унтрааж удаан зогсоохыг зөвшөөрөх үү?",
    "images": "/images/b/5773f0cc6f1a4362eb0ca132d1cd443f.jpg",
    "tdate": "2019-03-17 17:42:39",
    "desc": ""
},
{
    "id": "556",
    "topics_id": "18",
    "code": "18.7",
    "questions": "Хороолллын доторх хэсгийг жолооч дамжин өнгөрөх зорилгоор ашиглахыг зөвшөөрөх үү?",
    "images": "/images/b/ba3cb36733e9a5f49a6bc0bdf65273b3.jpg",
    "tdate": "2019-03-17 17:46:08",
    "desc": ""
},
{
    "id": "557",
    "topics_id": "18",
    "code": "18.8",
    "questions": "Замын зэргэлдээх нутаг дэвсгэр дотор жолооч ямар үүрэг хүлээх вэ?",
    "images": "",
    "tdate": "2019-03-17 17:54:00",
    "desc": ""
},
{
    "id": "558",
    "topics_id": "18",
    "code": "18.9",
    "questions": "Та зурагт үзүүлснээр хорооллоос гарч зам руу орохдоо аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/855a9c40f4a7372474b8e5a68ae76aa5.jpg",
    "tdate": "2019-03-17 18:13:27",
    "desc": "Хорооллын доторх зорчих хэсгүүдийн огтлолцол дээр баруун гар талаас ирсэн тээврийн хэрэгсэлд зам тавьж өгөх /ЗХД-ийн 10.10/ тул суудлын автомашины жолооч танд зам тавьж өгөх үүрэг хүлээнэ.Харин та хорооллоос гарч замд нийлэхдээ ачааны автомашинд зам тавьж өгөх үүрэгтэй /ЗХД-ийн 19.4/."
},
{
    "id": "559",
    "topics_id": "18",
    "code": "18.10",
    "questions": "Та аль явган зорчигчид зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/f507bee9005e740aaa21b6260f32db04.jpg",
    "tdate": "2019-03-17 18:21:01",
    "desc": ""
},
{
    "id": "560",
    "topics_id": "14",
    "code": "14.21",
    "questions": "Та баруун гар тийш эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/4de5a385f424345de087f89575bbdd7f.jpg",
    "tdate": "2019-03-17 18:25:43",
    "desc": ""
},
{
    "id": "561",
    "topics_id": "14",
    "code": "14.22",
    "questions": "Та буцаж эргэхдээ автобусанд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/2ffaaf7a2932e422c45afb6aba0c3ac3.jpg",
    "tdate": "2019-03-17 18:27:51",
    "desc": ""
},
{
    "id": "562",
    "topics_id": "14",
    "code": "14.23",
    "questions": "Та зүүн гар тийш эргэхдээ :",
    "images": "/images/b/9fab9fd3a379cbb5e4ea788e0ed0c95b.jpg",
    "tdate": "2019-03-17 18:30:58",
    "desc": ""
},
{
    "id": "563",
    "topics_id": "14",
    "code": "14.24",
    "questions": "Та баруун гар тийш эргэхдээ шар өнгийн тусгай гэрэл дохио ажиллуулж яваа ачааны автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/9c3a99ddadb97eea0af0a3f018bc2f2e.jpg",
    "tdate": "2019-03-17 18:35:00",
    "desc": ""
},
{
    "id": "564",
    "topics_id": "14",
    "code": "14.25",
    "questions": "Та зүүн гар тийш эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/a5aba0b340ab44367560e13dada9f760.jpg",
    "tdate": "2019-03-17 18:38:33",
    "desc": ""
},
{
    "id": "565",
    "topics_id": "14",
    "code": "14.26",
    "questions": "Та буцаж эргэхдээ суудлын автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/c794078193bd638f21f8182962302fc4.jpg",
    "tdate": "2019-03-17 18:45:02",
    "desc": "Зохицуулагч хөдөлгөөн зохицуулж байгаа уулзварт гэрэл дохио болон дарааллын тэмдгийг мөрдөхгүй /ЗХД-ийн 8.3/."
},
{
    "id": "566",
    "topics_id": "22",
    "code": "22.1",
    "questions": "Ажлын тоормосны системийн ямар өөрчлөлттэй суудлын автомашиныг ашиглахыг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-17 18:45:44",
    "desc": ""
},
{
    "id": "567",
    "topics_id": "14",
    "code": "14.27",
    "questions": "Та баруун гар  тийш эргэхдээ суудлын автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/0fdf2fdfe9bcd57f1c8fa6b1567ed5d5.jpg",
    "tdate": "2019-03-17 18:48:13",
    "desc": ""
},
{
    "id": "568",
    "topics_id": "22",
    "code": "22.2",
    "questions": "Хөдөлгөөнд оролцож явах үед зогсоолын тоормос ажиллахгүй болсон бол хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 18:51:43",
    "desc": ""
},
{
    "id": "569",
    "topics_id": "22",
    "code": "22.3",
    "questions": "Ямар гэмтэлтэй тээврийн хэрэгсэлийг ашиглахыг хориглох  вэ?",
    "images": "",
    "tdate": "2019-03-17 18:57:02",
    "desc": ""
},
{
    "id": "570",
    "topics_id": "22",
    "code": "22.4",
    "questions": "Жолооны механизмын хүчлүүр ажиллахгүй болсон автомашиныг ашиглахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 19:01:25",
    "desc": ""
},
{
    "id": "571",
    "topics_id": "14",
    "code": "14.28",
    "questions": "Аль тээврийн хэрэгслийн жолооч зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/9b17a673fa1aed6ecade05c9f1407554.jpg",
    "tdate": "2019-03-17 19:02:05",
    "desc": ""
},
{
    "id": "573",
    "topics_id": "22",
    "code": "22.5",
    "questions": "Суудлын автомашины дугуйн газарт тулах хэсэг дэх хээний гүний зөвшөөрөгдөх доод хэмжээ хэд вэ?",
    "images": "",
    "tdate": "2019-03-17 19:05:39",
    "desc": ""
},
{
    "id": "574",
    "topics_id": "22",
    "code": "22.6",
    "questions": "Дугуйн хээний гүн нь үйлдвэрээс тогтоосон элэгдлийн тэмдэглэгээний хязгаарт хүрсэн суудлын автомашиныг ашиглахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 19:09:55",
    "desc": ""
},
{
    "id": "575",
    "topics_id": "22",
    "code": "22.7",
    "questions": "Тээврийн хэрэгсэлд тухайн төрөлд нь тохироогүй хэмжээтэй дугуй тавьж ашиглахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 19:15:55",
    "desc": ""
},
{
    "id": "576",
    "topics_id": "22",
    "code": "22.8",
    "questions": "Аль дугуйнуудын хээ хоорондоо адил байхыг шаардах вэ?",
    "images": "/images/b/4d9df73da9ee195a49313da3446cf7db.jpg",
    "tdate": "2019-03-17 19:21:05",
    "desc": ""
},
{
    "id": "577",
    "topics_id": "22",
    "code": "22.9",
    "questions": "Аль үзүүлэлт нь тогтоосон хэмжээнээс хэтэрсэн тээврийн хэрэгслийг ашиглахыг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-17 19:25:35",
    "desc": ""
},
{
    "id": "578",
    "topics_id": "22",
    "code": "22.10",
    "questions": "Хөдөлгүүрийн ямар гэмтэлтэй тээврийн хэрэгслийг ашиглахыг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-17 19:31:14",
    "desc": ""
},
{
    "id": "579",
    "topics_id": "22",
    "code": "22.11",
    "questions": "Хөдөлгүүрийн ямар гэмтэлтэй тээврийн хэрэгслийг ашиглахыг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-17 19:37:01",
    "desc": ""
},
{
    "id": "580",
    "topics_id": "22",
    "code": "22.12",
    "questions": "Хол,ойрын гэрлийн тусгалын тохиргоо алдагдсан автомашиныг ашиглахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 19:42:09",
    "desc": ""
},
{
    "id": "581",
    "topics_id": "22",
    "code": "22.13",
    "questions": "Аль гэрэл нь асахгүй болсон автомашиыг ашиглахыг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-17 19:48:22",
    "desc": ""
},
{
    "id": "582",
    "topics_id": "22",
    "code": "22.14",
    "questions": "Чиг заах дохионы гэрлүүд нь асахгүй болсон автомашиныг ашиглахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 19:55:18",
    "desc": ""
},
{
    "id": "583",
    "topics_id": "22",
    "code": "22.15",
    "questions": "Аль эд анги нь ажиллахгүй болсон автомашиныг ашиглахыг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-17 19:59:37",
    "desc": ""
},
{
    "id": "584",
    "topics_id": "22",
    "code": "22.16",
    "questions": "Аль хэрэгсэл нь ажиллахгүй болсон автомашиныг ашиглахыг хориглох вэ?",
    "images": "",
    "tdate": "2019-03-17 20:03:50",
    "desc": ""
},
{
    "id": "585",
    "topics_id": "22",
    "code": "22.17",
    "questions": "Аль хэрэгсэл нь ажиллахгүй болсон суудлын автомашиныг ашиглахыг зөвшөөрөх вэ?",
    "images": "",
    "tdate": "2019-03-17 20:14:03",
    "desc": ""
},
{
    "id": "586",
    "topics_id": "22",
    "code": "22.18",
    "questions": "Аль эд анги нь байхгүй болсон суудлын автомашиныг ашиглахыг зөвшөөрөх вэ?",
    "images": "",
    "tdate": "2019-03-17 20:22:22",
    "desc": ""
},
{
    "id": "587",
    "topics_id": "22",
    "code": "22.19",
    "questions": "Суудлын автомашинд аль хэрэгслийг шаардахгүй вэ?",
    "images": "",
    "tdate": "2019-03-17 20:37:39",
    "desc": ""
},
{
    "id": "588",
    "topics_id": "22",
    "code": "22.20",
    "questions": "Гурван дугуйт мотоциклд аль хэрэгслийг шаардахгүй вэ?",
    "images": "",
    "tdate": "2019-03-17 20:41:00",
    "desc": ""
},
{
    "id": "589",
    "topics_id": "21",
    "code": "21.1",
    "questions": "Суудлын автомашинд техникийн тодорхойлолтоор тогтоосон  тооноос олон зорчигч тээвэрлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 21:24:38",
    "desc": ""
},
{
    "id": "591",
    "topics_id": "21",
    "code": "21.2",
    "questions": "Суудлын автомашинд заавал хүүхдийн нэмэгдэл суудал, хамгаалах хэрэгсэл ашиглаж тээвэрлэх хүүхдийн насны дээд хязгаар хэд вэ?",
    "images": "",
    "tdate": "2019-03-17 21:44:57",
    "desc": ""
},
{
    "id": "592",
    "topics_id": "21",
    "code": "21.3",
    "questions": "Хүүхдийн нэмэгдэл  суудал, хамгаалах хэрэгслийг суудлын автомашины урд суудалд байрлуулж ашиглахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 21:52:21",
    "desc": ""
},
{
    "id": "593",
    "topics_id": "21",
    "code": "21.4",
    "questions": "Суудлын автомашины урд суудалд 10 хүртэлх насны хүүхдийг зориулалтын нэмэгдэл суудал, хамгаалах хэрэгсэлгүй тээвэрлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 22:11:54",
    "desc": ""
},
{
    "id": "594",
    "topics_id": "21",
    "code": "21.5",
    "questions": "Суудлын автомашины  арын суудалд 10 хүртэлх насны хүүхдийг зориулалтын нэмэгдэл суудал, хамгаалах хэрэгсэлгүй тээвэрлэхийг зөвшөөрөх үү?",
    "images": "/images/b/58bbb08e7d88440a56baba95404a45a6.jpg",
    "tdate": "2019-03-17 22:21:20",
    "desc": ""
},
{
    "id": "595",
    "topics_id": "10",
    "code": "10.18",
    "questions": "Та ачааны автомашиныг гүйцэж түрүүлсний дараа баруун гар талын эгнээнд шилжих шаардлагатай юу?",
    "images": "/images/b/4db1c72d4709ee0f19c9ab07f6870279.jpg",
    "tdate": "2019-03-17 22:24:32",
    "desc": ""
},
{
    "id": "596",
    "topics_id": "10",
    "code": "10.19",
    "questions": "Ердийн хөсгийг гүйцэж түрүүлэх зорилгоор зүүн гар талын эгнээнд урсгал сөрөхийг зөвшөөрөх үү?",
    "images": "/images/b/b35a0501b1fdebc765de3511944965fd.jpg",
    "tdate": "2019-03-17 22:34:27",
    "desc": ""
},
{
    "id": "597",
    "topics_id": "21",
    "code": "21.6",
    "questions": "Аль тохиолдолд 10 хүртэлх насны хүүхдийг зориулалтын нэмэгдэл суудал буюу хүүхдийн хамгаалах хэрэгсэлгүй тээвэрлэхийг зөвшөөрөх вэ?",
    "images": "/images/b/a0347f32f3bfbef686c838719cee2da5.jpg",
    "tdate": "2019-03-17 22:34:46",
    "desc": ""
},
{
    "id": "598",
    "topics_id": "10",
    "code": "10.20",
    "questions": "Аль тээврийн хэрэгслийг зурагт үзүүлсэн сумны дагуу хөдөлгөөнөө үргэлжлүүлэхийг хориглох вэ?",
    "images": "/images/b/cb46a3905b10ff144dd983f04e147436.jpg",
    "tdate": "2019-03-17 22:36:47",
    "desc": ""
},
{
    "id": "599",
    "topics_id": "10",
    "code": "10.21",
    "questions": "Та уулзварыг чигээрээ нэвтрэхийн тулд аль эгнээг эзлэх вэ?",
    "images": "/images/b/48077e94e25d62aff8551481167bff50.jpg",
    "tdate": "2019-03-17 22:39:52",
    "desc": "Дунд эгнээ нь сөрөг хөдөлгөөнтэй гурван эгнээгээр зорчдог замаас зөвхөн зүүн гар тийш буюу  буцаж эргэхийн тулд дунд эгнээнд байр эзлэхийг зөвшөөрнө (ЗХД-ийн 10.14).  Иймд зурагт үзүүлсэн уулзвараар чигээрээ нэвтрэхийн тулд зөвхөн баруун гар талын эгнээг эзлэх шаардлагатай."
},
{
    "id": "600",
    "topics_id": "10",
    "code": "10.22",
    "questions": "Аль эгнээнэс зүүн гар тийш эргэхийг зөвшөөрөх вэ?",
    "images": "/images/b/ff4fe2a8858a64342ffce3ca5a4a8e58.jpg",
    "tdate": "2019-03-17 22:41:56",
    "desc": ""
},
{
    "id": "601",
    "topics_id": "21",
    "code": "21.7",
    "questions": "Суудлын таксинд зориулалтын нэмэгдэл суудал, хамгаалах хэрэгсэл байхгүй тохиолдолд 10 хүртэлх насны хүүхдийг  насанд хүрсэн хүн өвөр дээрээ авч явахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 22:44:25",
    "desc": ""
},
{
    "id": "602",
    "topics_id": "10",
    "code": "10.23",
    "questions": "Сөрөг хөдөлгөөнтэй дунд эгнээнээс аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/df92a389b5d1182668b78b88dbac9e39.jpg",
    "tdate": "2019-03-17 22:44:28",
    "desc": ""
},
{
    "id": "603",
    "topics_id": "10",
    "code": "10.24",
    "questions": "Аль сумны дагуу эргэхийг зөвшөөрөх вэ?",
    "images": "/images/b/6a372078df31c776b04387baf3e0af58.jpg",
    "tdate": "2019-03-17 22:46:00",
    "desc": "Жолооч уулзвар, гарцаар гарахдаа эсрэг урсгалыг сөрөхгүйгээр үйлдлийг гүйцэтгэнэ (ЗХД- ийн 10.8.а). Иймд зөвхөн В сумны дагуу зүүн гар тийш эргэхийг зөвшөөрнө."
},
{
    "id": "604",
    "topics_id": "21",
    "code": "21.8",
    "questions": "Зурагт үзүүлсэн автомашинд 10 хүртэлх насны хүүхдийг насанд хүрсэн хүн өвөр дээрээ авч явахыг зөвшөөрөх үү?",
    "images": "/images/b/5e199e6d1c7dd797821e4ac889213c57.jpg",
    "tdate": "2019-03-17 22:48:04",
    "desc": ""
},
{
    "id": "605",
    "topics_id": "10",
    "code": "10.25",
    "questions": "Суудлын автомашин зурагт үзүүлснээр зүүн гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/8cf98a839f3252ba84942fd965f11ad8.jpg",
    "tdate": "2019-03-17 22:48:09",
    "desc": ""
},
{
    "id": "606",
    "topics_id": "10",
    "code": "10.26",
    "questions": "Дунд эгнээнээс аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/f531c8a17198636245536715d51b8428.jpg",
    "tdate": "2019-03-17 22:49:55",
    "desc": ""
},
{
    "id": "607",
    "topics_id": "10",
    "code": "10.27",
    "questions": "Зурагт үзүүлсэн замын дунд эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/333e6917a8cf80d895b68e8ca2228f2a.jpg",
    "tdate": "2019-03-17 22:51:26",
    "desc": ""
},
{
    "id": "608",
    "topics_id": "10",
    "code": "10.28",
    "questions": "Дунд эгнээнээс аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/a6e445eb6e97886efb54b15a8ff4184f.jpg",
    "tdate": "2019-03-17 22:53:02",
    "desc": ""
},
{
    "id": "609",
    "topics_id": "21",
    "code": "21.9",
    "questions": "Ачааны автомашины жолоочийн бүхээгт 10 хүртэлх насны хүүхдийг зориулалтын нэмэгдэл суудал, хамгаалах хэрэгсэлгүй тээвэрлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 22:54:47",
    "desc": ""
},
{
    "id": "610",
    "topics_id": "10",
    "code": "10.29",
    "questions": "Дөрөв буюу түүнээс олон эгнээгээр зорчдог замд эсрэг урсгал сөрөхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 22:56:27",
    "desc": ""
},
{
    "id": "611",
    "topics_id": "10",
    "code": "10.30",
    "questions": "Зурагт үзүүлснээр гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/60bc41868e4fd2d27e0547811da431c8.jpg",
    "tdate": "2019-03-17 22:57:37",
    "desc": ""
},
{
    "id": "612",
    "topics_id": "10",
    "code": "10.31",
    "questions": "Суурин газрын гаднах замд жолооч эгнээгээ хэрхэн сонгож явах вэ?",
    "images": "",
    "tdate": "2019-03-17 23:02:08",
    "desc": ""
},
{
    "id": "613",
    "topics_id": "21",
    "code": "21.10",
    "questions": "Суудлын автомашинд зорчигчийн өвөр дээр хүн тээвэрлэхийг зөвшөөрөх үү?",
    "images": "/images/b/58f34ff4459732591240f37df1d6dfb3.jpg",
    "tdate": "2019-03-17 23:03:12",
    "desc": ""
},
{
    "id": "614",
    "topics_id": "10",
    "code": "10.32",
    "questions": "Аль эгнээгээр байрлан явахыг зөвшөөрөх вэ?",
    "images": "/images/b/b2366c92f9bb94082e0cda778278d102.jpg",
    "tdate": "2019-03-17 23:04:14",
    "desc": ""
},
{
    "id": "615",
    "topics_id": "10",
    "code": "10.33",
    "questions": "Та ачааны автомашиныг гүйцсэнийхээ дараа баруун гар талын эгнээнд шилжих шаардлагатай юу?",
    "images": "/images/b/485a654fabd6dbda52aa2ed690d9a2d1.jpg",
    "tdate": "2019-03-17 23:06:31",
    "desc": ""
},
{
    "id": "616",
    "topics_id": "21",
    "code": "21.11",
    "questions": "Ачааны автомашины тэвшинд хүн тээвэрлэхийг зөвшөөрөх үү?",
    "images": "/images/b/82b900cbdc219727ce939a49ad85e097.jpg",
    "tdate": "2019-03-17 23:07:13",
    "desc": ""
},
{
    "id": "617",
    "topics_id": "10",
    "code": "10.34",
    "questions": "Аль эгнээгээр байрлан явахыг зөвшөөрөх вэ?",
    "images": "/images/b/b483625bffe1878c783f39b6529beca2.jpg",
    "tdate": "2019-03-17 23:09:14",
    "desc": ""
},
{
    "id": "618",
    "topics_id": "21",
    "code": "21.12",
    "questions": "Аяллын зориулалттай чиргүүлд хүн тээввэрлэхийг зөвшөөрөх үү?",
    "images": "/images/b/5cacd0fd680d2c92dfa5410acbfa5ffe.jpg",
    "tdate": "2019-03-17 23:09:51",
    "desc": ""
},
{
    "id": "619",
    "topics_id": "10",
    "code": "10.35",
    "questions": "Суурин газрын гаднах замд баруун гар талын зөвшөөрөгдсөн эгнээ чөлөөтэй байхад зүүн гар талын эгнээгээр явахыг зөвшөөрөх үү?",
    "images": "/images/b/893f499961789bca521e0b32612a6f60.jpg",
    "tdate": "2019-03-17 23:12:32",
    "desc": ""
},
{
    "id": "620",
    "topics_id": "21",
    "code": "21.13",
    "questions": "10 хүртэлх насны хүүхдийг мотоциклын арын суудалд тээвэрлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 23:13:43",
    "desc": ""
},
{
    "id": "621",
    "topics_id": "10",
    "code": "10.36",
    "questions": "Суурин газрын гаднах замд баруун гар талын эгнээ чөлөөтэй байхад аль чигт явахын тулд зурагт үзүүлснээр байр эзлэхийг зөвшөөрөх вэ?",
    "images": "/images/b/6b0cf3277c097146635b5858afb09b02.jpg",
    "tdate": "2019-03-17 23:16:50",
    "desc": ""
},
{
    "id": "622",
    "topics_id": "21",
    "code": "21.14",
    "questions": "Ачааны мотоциклын тэвшинд хүн тээвэрлэхийг зөвшөөрөх үү?",
    "images": "/images/b/ca539bd08deedc42390f6b60be7f81f9.jpg",
    "tdate": "2019-03-17 23:16:56",
    "desc": ""
},
{
    "id": "623",
    "topics_id": "10",
    "code": "10.37",
    "questions": "Ачааны  автомашин зурагт үзүүлсэн эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/511a57d40fc8942852f55803ca524de4.jpg",
    "tdate": "2019-03-17 23:18:51",
    "desc": ""
},
{
    "id": "624",
    "topics_id": "21",
    "code": "21.15",
    "questions": "Суудлын автомашины урд суудалд согтуу хүн тээвэрлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 23:20:27",
    "desc": ""
},
{
    "id": "625",
    "topics_id": "10",
    "code": "10.38",
    "questions": "Та суудлын автомашин жолоодож яваа бол аль эгнээгээр хөдөлгөөнөө үргэлжлүүлэх вэ?",
    "images": "/images/b/5ae6ec0ec09b705b32372f59d77d54b6.jpg",
    "tdate": "2019-03-17 23:22:43",
    "desc": ""
},
{
    "id": "626",
    "topics_id": "21",
    "code": "21.16",
    "questions": "Суудлын автомашины арын суудалд согтуу хүн тээвэрлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 23:23:39",
    "desc": ""
},
{
    "id": "627",
    "topics_id": "10",
    "code": "10.39",
    "questions": "Энэ эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/ebbdffb285429555a61e4e5e4fa595a8.jpg",
    "tdate": "2019-03-17 23:25:19",
    "desc": ""
},
{
    "id": "628",
    "topics_id": "21",
    "code": "21.17",
    "questions": "Суудлын автомашинаар зурагт үзүүлсэн ачааг тээвэрллэхийг зөвшөөрөх үү?",
    "images": "/images/b/1e9f2026ae0eb0af041a1d69dd3bdb41.jpg",
    "tdate": "2019-03-17 23:28:10",
    "desc": ""
},
{
    "id": "629",
    "topics_id": "10",
    "code": "10.40",
    "questions": "Та ачааны автомашиныг гүйцсэнийхээ дараа баруун гар талын эгнээнд заавал шилжих шаардлагатай юу?",
    "images": "/images/b/37bd6a0405c9d236d4ab6c2fc971735b.jpg",
    "tdate": "2019-03-17 23:28:28",
    "desc": ""
},
{
    "id": "630",
    "topics_id": "10",
    "code": "10.41",
    "questions": "Энэ эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/d05457892f55d8dabf22eefa2f7a1f7c.jpg",
    "tdate": "2019-03-17 23:30:36",
    "desc": ""
},
{
    "id": "631",
    "topics_id": "10",
    "code": "10.42",
    "questions": "Уулзварыг чигээрээ нэвтрэхийн тулд энэ эгнээнд байр эзлэхийг зөвшөөрөх үү?",
    "images": "/images/b/8a50fcb6608ecb24fc20dd02604f322f.jpg",
    "tdate": "2019-03-17 23:33:20",
    "desc": ""
},
{
    "id": "632",
    "topics_id": "21",
    "code": "21.18",
    "questions": "Суудлын автомашинаар түүний овроос уртаашаа илүү гарсан ачаа тээвэрлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 23:34:33",
    "desc": ""
},
{
    "id": "633",
    "topics_id": "10",
    "code": "10.43",
    "questions": "Уулзвар нэвтэрснийхээ дараа та баруун гар талын эгнээнд шилжих үүрэгтэй юу?",
    "images": "/images/b/4885cf04f81caf7850c076c7b1441ad7.jpg",
    "tdate": "2019-03-17 23:35:06",
    "desc": ""
},
{
    "id": "634",
    "topics_id": "10",
    "code": "10.44",
    "questions": "Уулзварыг чигээрээ нэвтрэхийн тулд зурагт үзүүлсэн сумны дагуу эгнээ байраа өөрчлөхийг зөвшөөрөх үү?",
    "images": "/images/b/1490641c6126c04fec95b4e90ec1beaf.jpg",
    "tdate": "2019-03-17 23:38:15",
    "desc": "Зурагт үзүүлсэн дунд эгнээнээс чигээрээ явах боломжтой байхад баруун гар талын эгнээ рүү шилжих шаардлагагүй бөгөөд хөдөлгөөний эрчим ихтэй үед ийм үйлдэл хийхийг хориглоно (ЗХД-ийн 11.7)."
},
{
    "id": "635",
    "topics_id": "10",
    "code": "10.45",
    "questions": "Аль эгнээгээр байрлан явахыг зөвшөөрөх вэ?",
    "images": "/images/b/3e5b67898093309df3f4dadcd62088af.jpg",
    "tdate": "2019-03-17 23:40:54",
    "desc": ""
},
{
    "id": "636",
    "topics_id": "10",
    "code": "10.46",
    "questions": "Энэ эгнэээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/40cdd6d769b137db7d44855813ff4380.jpg",
    "tdate": "2019-03-17 23:43:51",
    "desc": ""
},
{
    "id": "637",
    "topics_id": "21",
    "code": "21.19",
    "questions": "Бүх жин нь 3.5 тонноос бага ачааны автомашинаар түүний овроос арагшаа 2 м-ээс илүү гарсан ачаа тээвэрлэхийг зөвшөөрөх үү?",
    "images": "/images/b/c4343c54d9c4835ea00b754d3b67656f.jpg",
    "tdate": "2019-03-17 23:45:47",
    "desc": ""
},
{
    "id": "638",
    "topics_id": "10",
    "code": "10.47",
    "questions": "Хөдөлгөөний эрчим ихтэй үед суудлын автомашинаар энэ эгнээнд байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/b9f7dd1728551e91ec191337c9843e82.jpg",
    "tdate": "2019-03-17 23:47:09",
    "desc": ""
},
{
    "id": "639",
    "topics_id": "10",
    "code": "10.48",
    "questions": "Хөдөлгөөний эрчим ихтэй үед ачааны автомашинаар энэ эгнээнд байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/38ceb22249a7547f98e9c742655d9f1e.jpg",
    "tdate": "2019-03-17 23:50:08",
    "desc": ""
},
{
    "id": "640",
    "topics_id": "21",
    "code": "21.20",
    "questions": "Мотоциклоор ачаа тээвэрлэхийг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-17 23:51:27",
    "desc": ""
},
{
    "id": "641",
    "topics_id": "10",
    "code": "10.49",
    "questions": "Суудлын автомашинаар гүйцэх үйлдэл хийхийн тулд зүүн гар талын эгнээнд орохыг зөвшөөрөх үү?",
    "images": "/images/b/4427f5e41cfa403a7aa77cd0fdab0c80.jpg",
    "tdate": "2019-03-17 23:52:11",
    "desc": "Гүйцэх үйлдэл нь хөдөлгөөний эрчим ихтэй, бусад эгнээ чөлөөгүй үед хийгдэж байгаа үйлдэл учир зөвшөөрнө."
},
{
    "id": "642",
    "topics_id": "10",
    "code": "10.50",
    "questions": "Суудлын автомашинаар аль чигт явахын тулд энэ эгнээнд байр эзлэхийг зөвшөөрөх вэ?",
    "images": "/images/b/f92a73a77551bc3c2e9e61634839c870.jpg",
    "tdate": "2019-03-17 23:54:01",
    "desc": ""
},
{
    "id": "643",
    "topics_id": "10",
    "code": "10.51",
    "questions": "Суудлын автомашинаар аль чигт явахын тулд зүүн гар талын эгнээнд байр эзлэхийг зөвшөөрөх вэ?",
    "images": "/images/b/5c6805dbf11478711f8c8c634db0dd71.jpg",
    "tdate": "2019-03-17 23:57:21",
    "desc": ""
},
{
    "id": "644",
    "topics_id": "10",
    "code": "10.52",
    "questions": "Суудлын автомашинаар уулзварыг чигээрээ нэвтрэхийн тулд энэ эгнээнд байр эзлэхийг зөвшөөрөх үү?",
    "images": "/images/b/e217cd191ca0d8fa1cef2fd50001e779.jpg",
    "tdate": "2019-03-17 23:59:51",
    "desc": ""
},
{
    "id": "645",
    "topics_id": "10",
    "code": "10.53",
    "questions": "Ачааны автомашинаар уулзварыг чигээрээ нэвтрэхийн тулд энэ эгнээнд байр эзлэхийг зөвшөөрөх үү?",
    "images": "/images/b/499f7c34d3c87c67fc2c24d497be847b.jpg",
    "tdate": "2019-03-18 00:09:15",
    "desc": ""
},
{
    "id": "646",
    "topics_id": "10",
    "code": "10.54",
    "questions": "Ачааны автомашинаар уулзварыг чигээрээ нэвтрэхийн тулд энэ эгнээнд байр эзлэхийг зөвшөөрөх үү?",
    "images": "/images/b/26bcbab29654d44db3a3f80622b1dbb9.jpg",
    "tdate": "2019-03-18 00:13:49",
    "desc": ""
},
{
    "id": "647",
    "topics_id": "10",
    "code": "10.55",
    "questions": "Суудлын автомашинаар аль эгнээнд байрлан явахыг зөвшөөрөх вэ?",
    "images": "/images/b/56e3a5a5b70b44c61311e920cb8fe8c0.jpg",
    "tdate": "2019-03-18 00:18:37",
    "desc": ""
},
{
    "id": "648",
    "topics_id": "10",
    "code": "10.56",
    "questions": "Суудлын автомашин зурагт үзүүлсэн эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/b6c0e148b40c1819230db192e4cc1823.jpg",
    "tdate": "2019-03-18 00:21:24",
    "desc": ""
},
{
    "id": "649",
    "topics_id": "10",
    "code": "10.57",
    "questions": "Аль эгнээнэээс баруун гар тийш эргэхийг зөвшөөрөх вэ?",
    "images": "/images/b/b3032b707e9f2f10a8ca8a4b8f4aaf1a.jpg",
    "tdate": "2019-03-18 00:24:05",
    "desc": ""
},
{
    "id": "650",
    "topics_id": "10",
    "code": "10.58",
    "questions": "Зурагт үзүүлснээр  баруун гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/b1c9fe187aaa82a7a115c23530b65b25.jpg",
    "tdate": "2019-03-18 00:25:37",
    "desc": ""
},
{
    "id": "651",
    "topics_id": "10",
    "code": "10.59",
    "questions": "Аль чигт явахын тулд баруун гар талын эгнээнд байр эзлэхийг зөвшөөрөх вэ?",
    "images": "/images/b/c7406e775e5df701b8b430d72b02a267.jpg",
    "tdate": "2019-03-18 00:27:38",
    "desc": ""
},
{
    "id": "652",
    "topics_id": "10",
    "code": "10.60",
    "questions": "Зурагт үзүүлсэн таних тэмдэг бүхий автомашин энэ эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/716f756f88d00a63942f310be9d3e3e9.jpg",
    "tdate": "2019-03-18 00:29:50",
    "desc": ""
},
{
    "id": "653",
    "topics_id": "5",
    "code": "5.41",
    "questions": "Энэ тэмдэг нь:",
    "images": "/images/b/f3c9bef6ef518b60500d96abbbdd7f14.jpg",
    "tdate": "2019-03-18 09:42:59",
    "desc": ""
},
{
    "id": "654",
    "topics_id": "5",
    "code": "5.42",
    "questions": "Та энэ уулзварыг нэвтрэхдээ:",
    "images": "/images/b/d87d73b2a9a41a6336f6671ed0c5e332.jpg",
    "tdate": "2019-03-18 09:45:28",
    "desc": ""
},
{
    "id": "655",
    "topics_id": "5",
    "code": "5.43",
    "questions": "Энэ тэмдэг нь:",
    "images": "/images/b/06ec2158f02c6437ae54cd1d57d0236f.jpg",
    "tdate": "2019-03-18 09:48:14",
    "desc": ""
},
{
    "id": "656",
    "topics_id": "5",
    "code": "5.44",
    "questions": "Суудлын автомашины жолооч зам тавьж өгөх үйлдлийг зурагт үзүүлснээр гүйцэтгэхийг зөвшөөрөх үү?",
    "images": "/images/b/9317c47ec40dd2961d419f9318e237ce.jpg",
    "tdate": "2019-03-18 09:51:21",
    "desc": "'Зам тавьж өгнө' (3.4) тэмдэг нь зам тавьж өгөх үйлдлийг тухайн уулзварын аль хэсэгт гүйцэтгэхийг жолоочид тусгайлан заахгүй бөгөөд зөвхөн уг үйлдлийг зөв гүйцэтгэхийг шаардана.Өөрөөр хэлбэл зурагт үзүүлснээр суудлын автомашины жолооч хөндлөн замаас яваа автобусны хурд болон чигийг өөрчлөхөд нөлөөлөхгүй байдлаар уулзварт орж зам тавьж өгөхийг тэмдгийн заалт зөрчсөн буюу уг үйлдлийг буруу гүйцэтгэсэн гэж үзэхгүй."
},
{
    "id": "657",
    "topics_id": "5",
    "code": "5.45",
    "questions": "Хөдөлгөөний зохицуулгагүй үед аль тэмдэг хөндлөн замаар яваа тээврийн хэрэгсэлд зам тавьж өгөхийг шаардах вэ?",
    "images": "/images/b/bf8b7a86105a5c80b52cdda642379a23.jpg",
    "tdate": "2019-03-18 09:53:20",
    "desc": ""
},
{
    "id": "658",
    "topics_id": "5",
    "code": "5.46",
    "questions": "Уулзварыг хэрхэн нэвтрэх вэ?",
    "images": "/images/b/6df1e44310e9c749e62566dd59e9120c.jpg",
    "tdate": "2019-03-18 10:01:09",
    "desc": ""
},
{
    "id": "659",
    "topics_id": "5",
    "code": "5.47",
    "questions": "Суудлын автомашины жолооч 'Зогс-шугам' тэмдэглэлийн өмнө зогсолт хийх шаардлагатай юу?",
    "images": "/images/b/5b684c07e5edc9a0c831853cc6abab37.jpg",
    "tdate": "2019-03-18 10:03:44",
    "desc": ""
},
{
    "id": "660",
    "topics_id": "5",
    "code": "5.48",
    "questions": "Та саадыг тойрон гарахдаа өөдөөс яваа ачааны автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/f5002f4468ccd88a0cee15ddd2ce9087.jpg",
    "tdate": "2019-03-18 10:05:09",
    "desc": ""
},
{
    "id": "661",
    "topics_id": "5",
    "code": "5.49",
    "questions": "Гүүрний өмнө тавигдсан энэ тэмдэг нь:",
    "images": "/images/b/74421024338de8595aaace5d5e962902.jpg",
    "tdate": "2019-03-18 10:07:45",
    "desc": ""
},
{
    "id": "662",
    "topics_id": "5",
    "code": "5.50",
    "questions": "Энэ тохиолдолд мотоциклтой нэгэн зэрэг гүүрээр нэвтрэхийг зөвшөөрөх үү?",
    "images": "/images/b/3db174b39c78d07f65ed71bfa9198d94.jpg",
    "tdate": "2019-03-18 10:09:36",
    "desc": ""
},
{
    "id": "665",
    "topics_id": "5",
    "code": "5.53",
    "questions": "Зурагт үзүүлсэн сумны дагуу гарцаар зүүн гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/167cc027375321acacabcc904f10d18c.jpg",
    "tdate": "2019-03-18 10:14:21",
    "desc": "Уулзварын шууд өмнө байрласан 4.1.а 'Чигээрээ явна' тэмдэг нь зөвхөн тэр уулзвартаа хамаарна. Иймд уулзварыг чигээрээ нэвтэрсний дараа зүүн гар тийш эргэхийг хориглохгүй."
},
{
    "id": "666",
    "topics_id": "5",
    "code": "5.54",
    "questions": "Аль сумны дагуу буцаж эргэхийг хориглох вэ?",
    "images": "/images/b/fbc300e871c2fd47a9c24bc46a0929fe.jpg",
    "tdate": "2019-03-18 10:15:29",
    "desc": ""
},
{
    "id": "667",
    "topics_id": "5",
    "code": "5.55",
    "questions": "Зурагт үзүүлсэн сумны дагуу гарцаар зүүн гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/cfc162ef52497b6d28b537592f91eb21.jpg",
    "tdate": "2019-03-18 10:16:49",
    "desc": "Уулзварын цаана (замын эхэнд) байрласан 4.1.а 'Чигээрээ явна' тэмдэг нь дараагийн уулзвар хүртэл хүчинтэй байх ба буцаж эргэх буюу гарцаар зүүн гар тийш эргэхийг хориглоно."
},
{
    "id": "668",
    "topics_id": "5",
    "code": "5.56",
    "questions": "Аль тээврийн хэрэгслийн хөдөлгөөнийг хориглох вэ?",
    "images": "/images/b/69b7fae1d4493d12467469f64545c8b0.jpg",
    "tdate": "2019-03-18 10:18:18",
    "desc": "Уулзварын цаана (замын эхэнд) байрласан 4.1.а 'Чигээрээ явна' тэмдэг гарцаар баруун гар тийш эргэхийг хориглохгүй."
},
{
    "id": "669",
    "topics_id": "5",
    "code": "5.57",
    "questions": "Аль чигт явахыг хориглох вэ?",
    "images": "/images/b/8570413597af68a9f19a1b6c91b8c53d.jpg",
    "tdate": "2019-03-18 10:20:02",
    "desc": ""
},
{
    "id": "670",
    "topics_id": "5",
    "code": "5.58",
    "questions": "Зурагт үзүүлснээр түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/eb4d93f261995e69d2e313a4e9afd309.jpg",
    "tdate": "2019-03-18 10:22:14",
    "desc": ""
},
{
    "id": "671",
    "topics_id": "5",
    "code": "5.59",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/1aae2070f94d01cdba22701aff5cb3f7.jpg",
    "tdate": "2019-03-18 10:23:37",
    "desc": ""
},
{
    "id": "672",
    "topics_id": "5",
    "code": "5.60",
    "questions": "Зурагт үзүүлсэн сумны дагуу хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/ca76932b392edaa6bf9e8088e4287fd4.jpg",
    "tdate": "2019-03-18 10:24:55",
    "desc": ""
},
{
    "id": "675",
    "topics_id": "5",
    "code": "5.63",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/14533714c8d2866557effff066eab954.jpg",
    "tdate": "2019-03-18 10:28:57",
    "desc": ""
},
{
    "id": "679",
    "topics_id": "5",
    "code": "5.67",
    "questions": "Аль сумны дагуу явахыг хориглох вэ?",
    "images": "/images/b/be28573acc7856136184015f87a20d8c.jpg",
    "tdate": "2019-03-18 10:35:10",
    "desc": ""
},
{
    "id": "680",
    "topics_id": "5",
    "code": "5.68",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/b1f96c4e9f5d1866b5dcbaae7238d03b.jpg",
    "tdate": "2019-03-18 10:36:03",
    "desc": "Замын тухайн хэсэгт байнгын тэмдгээс зөрүү утга бүхий түр тэмдэг тавьсан байвал түр тэмдгийн заалтыг баримтална. Түр тэмдэг нь зөөврийн суурьтай байна.(ЗХД-ийн 7.4)."
},
{
    "id": "681",
    "topics_id": "5",
    "code": "5.69",
    "questions": "Уулзвараар зүүн гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/f93f364302c73cf54397623b5baa7a32.jpg",
    "tdate": "2019-03-18 10:37:05",
    "desc": ""
},
{
    "id": "682",
    "topics_id": "5",
    "code": "5.70",
    "questions": "Аль сумны дагуу саадыг тойрон гарахыг зөвшөөрөх вэ?",
    "images": "/images/b/e31453744a3eb0c2a10768ee48711c83.jpg",
    "tdate": "2019-03-18 10:38:24",
    "desc": ""
},
{
    "id": "683",
    "topics_id": "5",
    "code": "5.71",
    "questions": "Аль сумны дагуу явахыг хориглох вэ?",
    "images": "/images/b/82168b93f525302ca732cc10ad0b5a73.jpg",
    "tdate": "2019-03-18 10:39:21",
    "desc": ""
},
{
    "id": "684",
    "topics_id": "5",
    "code": "5.72",
    "questions": "Аль сумны дагуу явахыг зөвшөөрөх вэ?",
    "images": "/images/b/3e3bcf6f69a3a85e04f3715531218951.jpg",
    "tdate": "2019-03-18 10:40:38",
    "desc": "Нэг чигийн хөдөлгөөнтэй (5.7 тэмдэгтэй) замд буцаж эргэхийг хориглоно."
},
{
    "id": "685",
    "topics_id": "5",
    "code": "5.73",
    "questions": "Зурагт үзүүлснээр буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/c260a947d1e2682677ee445924ae6119.jpg",
    "tdate": "2019-03-18 10:41:38",
    "desc": ""
},
{
    "id": "686",
    "topics_id": "5",
    "code": "5.74",
    "questions": "Аль сумны дагуу явахыг хориглох вэ?",
    "images": "/images/b/c16f57795bd802898987e0930481e845.jpg",
    "tdate": "2019-03-18 10:42:50",
    "desc": "'Тойрох хөдөлгөөн' (4.3) тэмдэг нь тухайн уулзварыг зөвхөн сум заасан чигийн дагуу тойрч нэвтрэхийг зөвшөөрнө.Иймд А сумны дагуу буюу тэмдэгт заасан чигийн эсрэг явахыг хориглоно.Уулзвараар нэвтрэх хөдөлгөөн нь зөвхөн нэг чигт зөвшөөрөгдсөн тохиолдолд аль ч эгнээнээс тухайн чигт явахыг зөвшөөрөх (ЗХД-ийн 10.5) тул зурагт үзүүлснээр зүүн гар талын эгнээнээс Б сумны дагуу явахыг хориглохгүй."
},
{
    "id": "687",
    "topics_id": "5",
    "code": "5.75",
    "questions": "Энэ тэмдэг байрласан замаар мотоциклын хөдөлгөөнийг зөвшөөрөх үү?",
    "images": "/images/b/808c6147ec9d6888ec8f33f9f4d222ad.jpg",
    "tdate": "2019-03-18 10:44:40",
    "desc": ""
},
{
    "id": "689",
    "topics_id": "5",
    "code": "5.77",
    "questions": "Суудлын автомашин зурагт үзүүлсэн эгнээгээр цагт 40 км хурдтай явахыг зөвшөөрөх үү?",
    "images": "/images/b/2cbb72375c3254c0b2f49b2be6dcf270.jpg",
    "tdate": "2019-03-18 10:49:18",
    "desc": ""
},
{
    "id": "690",
    "topics_id": "5",
    "code": "5.78",
    "questions": "Зурагт үзүүлсэн таних тэмдэгтэй автомашин зүүн гар талын эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/9f7415d4234533220ed8adf6f16d4cbf.jpg",
    "tdate": "2019-03-18 10:52:30",
    "desc": "'Хурдны хязгаар' таних тэмдэг бүхий тээврийн хэрэгслийн хурдыг уг таних тэмдэгт зааснаас хэтрүүлэхийг хориглоно (ЗХД-ийн 12.6.в).Иймд зурагт үзүүлсэн ачааны автомашины цагт 30 км-ээс илүү хурдтай явах боломжгүй тул хурдны доод хязгаарлал тогтоосон (4.6 тэмдэг бүхий) эгнээгээр явахыг хориглоно."
},
{
    "id": "691",
    "topics_id": "5",
    "code": "5.79",
    "questions": "'Суурин газрын төгсгөл' тэмдгээс цааш суудлын автомашины хурдны зөвшөөрөгдөх хязгаар хэд вэ?",
    "images": "/images/b/59be1fe4eab1fe219ef5d6086cd69ef8.jpg",
    "tdate": "2019-03-18 10:55:36",
    "desc": ""
},
{
    "id": "694",
    "topics_id": "5",
    "code": "5.82",
    "questions": "Аль тэмдэг тавигдсан замыг 'Гол зам'-д тооцох вэ?",
    "images": "/images/b/03b96277d25d8c62f20dba0b57e30393.jpg",
    "tdate": "2019-03-18 11:03:43",
    "desc": ""
},
{
    "id": "695",
    "topics_id": "5",
    "code": "5.83",
    "questions": "Аль тээврийн хэрэгслийн жолооч суурин газрын доторх хөдөлгөөний журмыг мөрдөх шаардлагатай вэ?",
    "images": "/images/b/e2d0be25af23f7b3b5c3b2e1a18a548b.jpg",
    "tdate": "2019-03-18 11:05:47",
    "desc": ""
},
{
    "id": "696",
    "topics_id": "5",
    "code": "5.84",
    "questions": "Аль тээврийн хэрэгслийн жолооч суурин газрын доторх хөдөлгөөний журмыг мөрдөх шаардлагагүй вэ?",
    "images": "/images/b/eb94801e09a348390a7cbaa67710c19c.jpg",
    "tdate": "2019-03-18 11:07:54",
    "desc": ""
},
{
    "id": "697",
    "topics_id": "5",
    "code": "5.85",
    "questions": "Энэ тэмдэг нь:",
    "images": "/images/b/a9a878d67ba624c573fc844c954c21c7.jpg",
    "tdate": "2019-03-18 11:10:23",
    "desc": ""
},
{
    "id": "698",
    "topics_id": "5",
    "code": "5.86",
    "questions": "Энэ тэмдэг тавигдсан замаас баруун гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/db39d19dc135d8ef91af6143b7269ef9.jpg",
    "tdate": "2019-03-18 11:11:54",
    "desc": ""
},
{
    "id": "699",
    "topics_id": "5",
    "code": "5.87",
    "questions": "Энэ тэмдэг нь:",
    "images": "/images/b/21b6f407ff0581caee053c76de4a77f4.jpg",
    "tdate": "2019-03-18 11:14:14",
    "desc": ""
},
{
    "id": "700",
    "topics_id": "5",
    "code": "5.88",
    "questions": "Зурагт үзүүлснээр буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/571075ca5a244e42cbb8ef3079445ce9.jpg",
    "tdate": "2019-03-18 11:17:05",
    "desc": ""
},
{
    "id": "701",
    "topics_id": "10",
    "code": "10.61",
    "questions": "Аль суудлын таксийг зурагт үзүүлснээр байрлан явахыг зөвшөөрөх вэ?",
    "images": "/images/b/53dc1b76e9b8f71984981170263a6e80.jpg",
    "tdate": "2019-03-18 11:17:12",
    "desc": ""
},
{
    "id": "702",
    "topics_id": "5",
    "code": "5.89",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/38219a05739761f6ba5b47ba5ecad432.jpg",
    "tdate": "2019-03-18 11:18:16",
    "desc": ""
},
{
    "id": "703",
    "topics_id": "10",
    "code": "10.62",
    "questions": "Хөвөөгөөр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/caab1fe59c01c317beca958106fa6b1c.jpg",
    "tdate": "2019-03-18 11:19:17",
    "desc": ""
},
{
    "id": "704",
    "topics_id": "5",
    "code": "5.90",
    "questions": "Зурагт үзүүлсэн сумны дагуу хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/0f227e5854016f294a10490def4621f9.jpg",
    "tdate": "2019-03-18 11:19:48",
    "desc": ""
},
{
    "id": "705",
    "topics_id": "10",
    "code": "10.63",
    "questions": "Зурагт үзүүлснээр хөвөөнөөс эргэх үйлдэл хийхийг зөвшөөрөх үү?",
    "images": "/images/b/936101159dc53ddbdfb95b0a9449ef87.jpg",
    "tdate": "2019-03-18 11:20:22",
    "desc": ""
},
{
    "id": "706",
    "topics_id": "5",
    "code": "5.91",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/54a7ce3d7d9eb7747d8c3862f03940f5.jpg",
    "tdate": "2019-03-18 11:21:31",
    "desc": ""
},
{
    "id": "707",
    "topics_id": "10",
    "code": "10.64",
    "questions": "Хөвөөн дээр аль үйлдлийг хориглох вэ?",
    "images": "/images/b/a433d01d66941ba084683e0006523107.jpg",
    "tdate": "2019-03-18 11:22:24",
    "desc": ""
},
{
    "id": "708",
    "topics_id": "5",
    "code": "5.92",
    "questions": "Аль тээврийн хэрэгслийн хөдөлгөөнийг хориглох вэ?",
    "images": "/images/b/3461eed712c7739a79f71bf409bef4c5.jpg",
    "tdate": "2019-03-18 11:22:49",
    "desc": ""
},
{
    "id": "709",
    "topics_id": "5",
    "code": "5.93",
    "questions": "Дунд эгнээнээс аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/58e2d82e1878978b69eb468921111019.jpg",
    "tdate": "2019-03-18 11:25:23",
    "desc": "'Эгнээнээс явах хөдөлгөөний чиг' (5.10) тэмдгийн зүүн гар тийш эргэхийг зөвшөөрсөн сум бүхий эгнээнүүдийн зөвхөн хамгийн зүүн гар талын захын эгнээнээс буцаж эргэхийг зөвшөөрнө.Иймд зурагт үзүүлсэн дунд эгнээнээс зөвхөн чигээрээ буюу зүүн гар тийш эргэхийг зөвшөөрнө."
},
{
    "id": "710",
    "topics_id": "5",
    "code": "5.94",
    "questions": "Зүүн гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/15b1713afb5bbff2c06f60acbd82fb60.jpg",
    "tdate": "2019-03-18 11:26:31",
    "desc": "'Эгнээгээр явах хөдөлгөөний чиг' (5.11) тэмдэг нь эгнээ тус бүрийн хөдөлгөөний урсгалын чигийг мэдээлэх бөгөөд харин уулзвар, гарцаар нэвтрэх чигийг заах утга агуулахгүй."
},
{
    "id": "711",
    "topics_id": "10",
    "code": "10.65",
    "questions": "Унадаг дугуйн эгнээгээр мехианикжсан тээврийн хэрэгсэл байрлан явахыг зөвшөөрөх үү?",
    "images": "",
    "tdate": "2019-03-18 11:27:23",
    "desc": ""
},
{
    "id": "712",
    "topics_id": "5",
    "code": "5.95",
    "questions": "Зурагт үзүүлсэн бүх жин нь 3.5 тонноос бага ачааны автомашины жолооч гүйцэх зорилгоор дунд эгнээнд орохыг зөвшөөрөх үү?",
    "images": "/images/b/a33a36d7a4b30831db5034723c10b7d8.jpg",
    "tdate": "2019-03-18 11:28:58",
    "desc": ""
},
{
    "id": "713",
    "topics_id": "10",
    "code": "10.66",
    "questions": "Суудлын автомашин зурагт үзүүлснээр байр эзлэхийг зөвшөөрөх үү?",
    "images": "/images/b/ba0b02057ac8179d4f9f77b5120927c2.jpg",
    "tdate": "2019-03-18 11:29:37",
    "desc": ""
},
{
    "id": "714",
    "topics_id": "10",
    "code": "10.67",
    "questions": "Зурагт үзүүлснээр баруун гар тийш эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/52c52c6de4f22d98aa218de32613ed0b.jpg",
    "tdate": "2019-03-18 11:30:45",
    "desc": ""
},
{
    "id": "715",
    "topics_id": "5",
    "code": "5.96",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/da6155df1f6ecbadd5000bb5616b3359.jpg",
    "tdate": "2019-03-18 11:31:01",
    "desc": ""
},
{
    "id": "716",
    "topics_id": "10",
    "code": "10.68",
    "questions": "Мотоцикл зурагт үзүүлснээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/551fdc7fd4da962cdc6e3d388c919def.jpg",
    "tdate": "2019-03-18 11:32:06",
    "desc": ""
},
{
    "id": "717",
    "topics_id": "10",
    "code": "10.69",
    "questions": "Аль зурагт үзүүлснээр байрлан явахыг хориглох вэ?",
    "images": "/images/b/6403e2a376ff757e7b943f642568c58b.jpg",
    "tdate": "2019-03-18 11:33:03",
    "desc": ""
},
{
    "id": "718",
    "topics_id": "10",
    "code": "10.70",
    "questions": "Аль зурагт үзүүлснээр байрлан явахыг хориглох вэ?",
    "images": "/images/b/c8c3c303cc8130ec4a2a78168d32b712.jpg",
    "tdate": "2019-03-18 11:34:26",
    "desc": ""
},
{
    "id": "719",
    "topics_id": "5",
    "code": "5.97",
    "questions": "Энэ тэмдэг юуг мэдээлэх вэ?",
    "images": "/images/b/36d3b5909d7b0c64e2c4fe9faf44abaa.jpg",
    "tdate": "2019-03-18 11:34:45",
    "desc": ""
},
{
    "id": "720",
    "topics_id": "5",
    "code": "5.98",
    "questions": "Энэ тэмдэг юуг мэдээлэх вэ?",
    "images": "/images/b/e6b5088ca7817536ba4b922a660b7022.jpg",
    "tdate": "2019-03-18 11:36:11",
    "desc": ""
},
{
    "id": "721",
    "topics_id": "5",
    "code": "5.99",
    "questions": "Зүүн гар талын зам руу орохыг зөвшөөрөх үү?",
    "images": "/images/b/1b1d91c0350f4d6b840b6bbcc45d2124.jpg",
    "tdate": "2019-03-18 11:37:26",
    "desc": ""
},
{
    "id": "722",
    "topics_id": "5",
    "code": "5.100",
    "questions": "Аль сумны дагуу хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрөх вэ?",
    "images": "/images/b/94abd9bc2028bd3735ed62bc419065e3.jpg",
    "tdate": "2019-03-18 11:38:47",
    "desc": ""
},
{
    "id": "723",
    "topics_id": "10",
    "code": "10.71",
    "questions": "Техникийн гэмтлээс шалтгаалан цагт 40 км-ээс илүү хурдтай явах боломжгүй суудлын автомашины жолооч суурин газрын доторх замд аль эгнээгээр байрлан явахыг зөвшөөрөх вэ?",
    "images": "",
    "tdate": "2019-03-18 11:39:03",
    "desc": ""
},
{
    "id": "724",
    "topics_id": "5",
    "code": "5.101",
    "questions": "Энэ тэмдэг нь:",
    "images": "/images/b/1e7d62ca991ddd7a9d3ca9a8246c3efc.jpg",
    "tdate": "2019-03-18 11:41:21",
    "desc": ""
},
{
    "id": "725",
    "topics_id": "10",
    "code": "10.72",
    "questions": "Техникийн гэмтлээс шалтгаалан цагт 40 км-ээс илүү хурдтай явах боломжгүй тохиолдолд та аль эгнээгээр байрлан явах вэ?",
    "images": "/images/b/10697b89770cb57a4f02aba7591b08f8.jpg",
    "tdate": "2019-03-18 11:42:30",
    "desc": ""
},
{
    "id": "726",
    "topics_id": "5",
    "code": "5.102",
    "questions": "Энэ тэмдэг ямар утга илэрхийлэх вэ?",
    "images": "/images/b/b96158335f1707b6e13283f8ae512766.jpg",
    "tdate": "2019-03-18 11:44:03",
    "desc": ""
},
{
    "id": "727",
    "topics_id": "10",
    "code": "10.73",
    "questions": "Суудлын автомашин зурагт үзүүлсэн эгнээгээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/b1748c42c0fb674f79ee8bfa905ff97f.jpg",
    "tdate": "2019-03-18 11:44:52",
    "desc": ""
},
{
    "id": "728",
    "topics_id": "10",
    "code": "10.74",
    "questions": "Зурагт үзүүлснээр байрлан явахыг зөвшөөрөх үү?",
    "images": "/images/b/bc3c9a331553b4fe7c00fecd53ea411d.jpg",
    "tdate": "2019-03-18 11:46:25",
    "desc": ""
},
{
    "id": "729",
    "topics_id": "5",
    "code": "5.103",
    "questions": "Хориглох тэмдгийн үйлчлэх хүрээ нь:",
    "images": "/images/b/1b75e670631d56217828c353659061ea.jpg",
    "tdate": "2019-03-18 11:46:33",
    "desc": ""
},
{
    "id": "730",
    "topics_id": "5",
    "code": "5.104",
    "questions": "Аль тээврийн хэрэгслийн түр зогсолтыг хориглох вэ?",
    "images": "/images/b/59252e021e52df27d2c08d6cf33ff9a2.jpg",
    "tdate": "2019-03-18 11:47:55",
    "desc": ""
},
{
    "id": "731",
    "topics_id": "10",
    "code": "10.75",
    "questions": "Ачааны автомашины жолооч ердийн хөсгийг гүйцсэнийхээ дараа баруун гар талын эгнээнд заавал шилжих шаардлагатай юу?",
    "images": "/images/b/3b8c0a993de23e0e4d008d63316353af.jpg",
    "tdate": "2019-03-18 11:48:58",
    "desc": "Цагт 40 км-ээс илүү хурдтай явах боломжгүй, тухайлбал зурагт үзүүлсэн таних тэмдэг бүхий тээврийн хэрэгсэл нь хамгийн баруун гар талын эгнээгээр байрлан явах үүрэгтэй тул гүйцэх үйлдэл хийснийхээ дараа буцаж эгнээндээ шилжих  шаардлагатай (ЗХД-ийн 11.12)."
},
{
    "id": "732",
    "topics_id": "10",
    "code": "10.76",
    "questions": "Суудлын автомашины жолооч уулзвар нэвтрэхдээ эгнээ байраа зөв эзэлсэн үү?",
    "images": "/images/b/bbf52a47c2f9c35f325495b0bbedc94e.jpg",
    "tdate": "2019-03-18 11:50:11",
    "desc": ""
},
{
    "id": "733",
    "topics_id": "5",
    "code": "5.105",
    "questions": "Ачааны автомашины бүх жин нь 3.5 тонноос бага бол зурагт үзүүлсэн зогсоолд аль тээврийн хэрэгсэл зогсохыг зөвшөөрөх вэ?",
    "images": "/images/b/40ba4ff204647b01756b2524759d1e6b.jpg",
    "tdate": "2019-03-18 11:50:39",
    "desc": ""
},
{
    "id": "734",
    "topics_id": "5",
    "code": "5.106",
    "questions": "Заах тэмдэг хэдийд хүчинтэй байх вэ?",
    "images": "/images/b/a2f602680ed6bac3399f56ac7a75c7fe.jpg",
    "tdate": "2019-03-18 11:52:24",
    "desc": ""
},
{
    "id": "735",
    "topics_id": "5",
    "code": "5.107",
    "questions": "Аль тээврийн хэрэгслийн жолооч тэмдгийн заалтыг зөрчиж зогссон бэ?",
    "images": "/images/b/c020f460456ee018e4f9478d386f858d.jpg",
    "tdate": "2019-03-18 11:54:16",
    "desc": ""
},
{
    "id": "736",
    "topics_id": "10",
    "code": "10.77",
    "questions": "Мехианикжсан тээврийн хэрэгсэл чирч яваа суудлын автомашины жолооч зурагт үзүүлсэн замаар байрлан явахдаа аль шаардлагыг биелүүлэх үүрэгтэй вэ?",
    "images": "/images/b/a0e0ddbfac5f69cf9de62d1cb434524d.jpg",
    "tdate": "2019-03-18 11:56:21",
    "desc": "Араасаа яваа тээврийн хэрэгсэлд гүйцэж түрүүлэх боломж олгох үүднээс хоорондын зай барьж явах тухай ЗХД-ийн 11.13 заалт нь зөвхөн хоёр буюу гурван эгнээгээр зорчдог замд мөрдөгдөнө."
},
{
    "id": "737",
    "topics_id": "5",
    "code": "5.108",
    "questions": "Нэмэлт тэмдэг юуг илэрхийлэх вэ?",
    "images": "/images/b/6b3a6be3d86d295e84ddb2800892011b.jpg",
    "tdate": "2019-03-18 11:56:59",
    "desc": ""
},
{
    "id": "738",
    "topics_id": "5",
    "code": "5.109",
    "questions": "Тэмдгээс цааш суудлын автомашинаар цагт 50 км хурдтай явахыг зөвшөөрөх үү?",
    "images": "/images/b/2984ba46021ae3885082d7c6c9d42a32.jpg",
    "tdate": "2019-03-18 11:59:15",
    "desc": ""
},
{
    "id": "739",
    "topics_id": "10",
    "code": "10.78",
    "questions": "Зурагт үзүүлсэн тээврийн хэрэгслүүдийн жолооч нар хоорондын зайгаа хэрхэн сонгож явах үүрэгтэй вэ?",
    "images": "/images/b/b872a5898767affb57f78ae85bd87861.jpg",
    "tdate": "2019-03-18 12:00:56",
    "desc": ""
},
{
    "id": "740",
    "topics_id": "5",
    "code": "5.110",
    "questions": "Хориглох тэмдэг ямар үед хүчинтэй байх вэ?",
    "images": "/images/b/f2403f39021e3f01e30c8978fcf8d13f.jpg",
    "tdate": "2019-03-18 12:02:04",
    "desc": ""
},
{
    "id": "741",
    "topics_id": "5",
    "code": "5.111",
    "questions": "Аль тэмдэг тавигдсан хэсгээс замын халтиргаа эхлэх вэ?",
    "images": "/images/b/402221bfdbeb1cbb36c30a134a815761.jpg",
    "tdate": "2019-03-18 12:04:38",
    "desc": "1 дэх тэмдэг нь суурин газарт 50-100 м, суурин газрын гаднах замд 150-300 м-ийн цаанаас замын халтиргаа эхлэхийг анхааруулна. 2 дахь тэмдэг нь 100м -ийн цаанаас замын халтиргаа эхлэхийг анхааруулна. 3 дахь тэмдэг нь тэмдэг тавигдсан хэсгээс замын халтиргаа 100 м үргэлжлэхийг анхааруулна."
},
{
    "id": "742",
    "topics_id": "10",
    "code": "10.79",
    "questions": "Жолооч хоорондын зайгаа хэрхэн сонгож явах вэ?",
    "images": "",
    "tdate": "2019-03-18 12:04:56",
    "desc": ""
},
{
    "id": "743",
    "topics_id": "5",
    "code": "5.112",
    "questions": "Аль тэмдгийн үйлчлэх хүрээ байрласан газраасаа эхлэх вэ?",
    "images": "/images/b/43901e2d399b23a29d3d0d8886d5200d.jpg",
    "tdate": "2019-03-18 12:06:01",
    "desc": "А тэмдгийн үйлчлэх хүрээ байрласан газраасаа эхэлнэ. Б тэмдгийн үйлчлэх хүрээ мөн байрласан газраасаа эхэлж 10 м үргэлжилнэ.В тэмдгийн үйлчлэл 100 м-ийн цаанаас эхэлнэ."
},
{
    "id": "744",
    "topics_id": "5",
    "code": "5.113",
    "questions": "Аль тэмдэг чиргүүлтэй суудлын автомашинаар баруун гар тийш эргэхийг хориглох вэ?",
    "images": "/images/b/8e5344a950c3fba934f44d5d3f0ae875.jpg",
    "tdate": "2019-03-18 12:07:30",
    "desc": "А тэмдэг нь чиргүүлтэй бүх төрлийн тээврийн хэрэгсэл баруун гар тийш эргэхийг хориглоно.Б тэмдэг нь чиргүүлтэй ачааны автомашин болон тракторын хөдөлгөөнийг хориглох бөгөөд чиргүүлтэй суудлын автомашинд хамаарахгүй."
},
{
    "id": "745",
    "topics_id": "10",
    "code": "10.80",
    "questions": "Жолооч тээврийн хэрэгслийн хажуугийн зайг сонгохдоо хөдөлгөөний хурдаас хэрхэн хамааруулах вэ?",
    "images": "",
    "tdate": "2019-03-18 12:07:49",
    "desc": ""
},
{
    "id": "746",
    "topics_id": "5",
    "code": "5.114",
    "questions": "Аль тэмдэгтэй зогсоолд бүх жин нь 3.5 тонноос  бага ачааны автомашин зогсохыг зөвшөөрөх вэ?",
    "images": "/images/b/4f26bd8aae918efa251e5c4f4451b428.jpg",
    "tdate": "2019-03-18 12:09:29",
    "desc": ""
},
{
    "id": "747",
    "topics_id": "5",
    "code": "5.115",
    "questions": "Аль тэмдэг чигээрээ явахыг хориглох вэ?",
    "images": "/images/b/8c4208ff1c7431d6eab01caaad44ea3f.jpg",
    "tdate": "2019-03-18 12:10:44",
    "desc": ""
},
{
    "id": "748",
    "topics_id": "5",
    "code": "5.116",
    "questions": "Аль тэмдэг тавигдсан уулзвараар зөвхөн баруун гар тийш эргэх шаардлагатай вэ?",
    "images": "/images/b/8b88d84469f440cdfbf630041f66a33a.jpg",
    "tdate": "2019-03-18 12:12:20",
    "desc": ""
},
{
    "id": "749",
    "topics_id": "5",
    "code": "5.117",
    "questions": "Аль тэмдэг зүүн гар тийш эргэхийг хориглох вэ?",
    "images": "/images/b/a00f719521881cc6dca851c2d9ac1115.jpg",
    "tdate": "2019-03-18 12:13:45",
    "desc": ""
},
{
    "id": "752",
    "topics_id": "5",
    "code": "5.120",
    "questions": "Аль тэмдэг цагт 60 км хурдтай явахыг хориглох вэ?",
    "images": "/images/b/2419ffa77090ba920a43bd2b2364a11e.jpg",
    "tdate": "2019-03-18 12:19:25",
    "desc": ""
},
{
    "id": "753",
    "topics_id": "14",
    "code": "14.29",
    "questions": "Зөвшөөрсөн гэрэл дохио асах үёд та:",
    "images": "/images/b/2a24f98b29611d0e56808bb721bfdeab.jpg",
    "tdate": "2019-03-18 13:12:48",
    "desc": ""
},
{
    "id": "754",
    "topics_id": "14",
    "code": "14.30",
    "questions": "Зөвшөөрсөн гэрэл дохио асах үед та аль явган зорчигчид зам тавьж өгөх үүрэг хүлээх вэ?",
    "images": "/images/b/2d9f067702d2f0ae73d7c148e8eda7ab.jpg",
    "tdate": "2019-03-18 13:18:49",
    "desc": "Зөвшөөрсөн гэрэл дохио асах үед та зорчих хэсгийг хөндлөн гарч амжаагүй яваа /зүүн гар талаас яваа/ явган зорчигчид зам тавьж өгөх үүрэгтэй /ЗХД-ийн 15.7/ Харин баруун гар талаас зам хөндлөн гарах гэж байгаа явган зорчигчид зорчих хэсэг рүү орох хориотой тул та зам тавьж өгөх үүрэг хүлээхгүй"
},
{
    "id": "755",
    "topics_id": "14",
    "code": "14.31",
    "questions": "Та баруун гар тийш эргэхдээ мотоциклд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/d793b90490cc424a3514685cfa7aacb8.jpg",
    "tdate": "2019-03-18 13:20:31",
    "desc": ""
},
{
    "id": "756",
    "topics_id": "14",
    "code": "14.32",
    "questions": "Та чигээрээ явахдаа:",
    "images": "/images/b/4ce215a8547b687758df78c4318c65e7.jpg",
    "tdate": "2019-03-18 13:21:44",
    "desc": ""
},
{
    "id": "757",
    "topics_id": "14",
    "code": "14.33",
    "questions": "Та суудлын автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/1377d567b84602df21678bfa244f0fdb.jpg",
    "tdate": "2019-03-18 13:22:43",
    "desc": ""
},
{
    "id": "758",
    "topics_id": "14",
    "code": "14.34",
    "questions": "Та буцаж эргэхдээ:",
    "images": "/images/b/1ad33b816e47fef5a1552d274ac4ce94.jpg",
    "tdate": "2019-03-18 13:24:02",
    "desc": ""
},
{
    "id": "759",
    "topics_id": "14",
    "code": "14.35",
    "questions": "Зурагт үзүүлсэн адил замын уулзвараар та зүүн гар тийш эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/4e8a2bf8aaa07dc3679658cf4f497b2a.jpg",
    "tdate": "2019-03-18 13:26:33",
    "desc": ""
},
{
    "id": "760",
    "topics_id": "14",
    "code": "14.36",
    "questions": "Та зүүн гар тийш эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх вэ?",
    "images": "/images/b/75d68a4c2ec3256cee048db5d15ed6c4.jpg",
    "tdate": "2019-03-18 13:30:02",
    "desc": ""
},
{
    "id": "761",
    "topics_id": "14",
    "code": "14.37",
    "questions": "Та чигээрээ явахдаа аль тээврийн хэрэгсэлд зам тавьж өгөх вэ?",
    "images": "/images/b/cb6c53c6fe1e89673175a8c064ac419c.jpg",
    "tdate": "2019-03-18 13:31:48",
    "desc": ""
},
{
    "id": "762",
    "topics_id": "14",
    "code": "14.38",
    "questions": "Та зүүн гар тийш эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх вэ?",
    "images": "/images/b/e04ea1618a50b4b3d85cc8eb2a5affde.jpg",
    "tdate": "2019-03-18 13:33:26",
    "desc": ""
},
{
    "id": "763",
    "topics_id": "14",
    "code": "14.39",
    "questions": "Та зүүн гар тийш эргэхдээ:",
    "images": "/images/b/b34646e34d5ada18cdb937c659defd90.jpg",
    "tdate": "2019-03-18 13:35:52",
    "desc": ""
},
{
    "id": "764",
    "topics_id": "14",
    "code": "14.40",
    "questions": "Та чигээрээ явахдаа уулзварт хэдийд нэвтрэх вэ?",
    "images": "/images/b/fbbf4fea554e360c9b86f1e44b44ec96.jpg",
    "tdate": "2019-03-18 13:41:02",
    "desc": "Мотоцикл баруун гар талдаа саадгүй учир уулзварт түрүүлж орох боловч зүүн гар тийш эргэхдээ ачааны автомашинд зам тавьж өгөхийн тулд уулзварт зогсож хүлээнэ. Ингэснээр таны баруун гар талаас саадгүй болох учир та уулзварыг түрүүлж нэвтэрнэ ЗХД-ийн 15.8, 15.10/"
},
{
    "id": "765",
    "topics_id": "14",
    "code": "14.41",
    "questions": "Адил замын уулзварыг ямар дарааллаар нэвтрэх вэ?",
    "images": "/images/b/1fdf1570966b39f164d99f995a577f82.jpg",
    "tdate": "2019-03-18 13:42:46",
    "desc": ""
},
{
    "id": "766",
    "topics_id": "14",
    "code": "14.42",
    "questions": "Та уулзварыг чигээрээ нэвтрэхдээ аль унадаг дугуйнд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/2dfa644bab5f3772050e02d35391a036.jpg",
    "tdate": "2019-03-18 13:45:44",
    "desc": "Адил замын урсгалд баруун гар талаас яваа тээврийн хэрэгсэлд зам тавьж өгнө /ЗХД-ийн 15.8/"
},
{
    "id": "767",
    "topics_id": "14",
    "code": "14.43",
    "questions": "Та чигээрээ явахдаа суудлын автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/4041f800503e58902aad5a8f5f42a328.jpg",
    "tdate": "2019-03-18 13:47:16",
    "desc": ""
},
{
    "id": "768",
    "topics_id": "14",
    "code": "14.44",
    "questions": "Та шороон замаас уулзвараар зүүн гар тийш эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх вэ?",
    "images": "/images/b/fffbb51834a0ac7103c9c23dfc830ff9.jpg",
    "tdate": "2019-03-18 13:49:14",
    "desc": ""
},
{
    "id": "769",
    "topics_id": "14",
    "code": "14.45",
    "questions": "Та зүүн гар тийш эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх шаардлагатай вэ?",
    "images": "/images/b/9fb2be46f5fd6fcac6f844c7af27e864.jpg",
    "tdate": "2019-03-18 13:52:27",
    "desc": ""
},
{
    "id": "770",
    "topics_id": "14",
    "code": "14.46",
    "questions": "Та баруун гар тийш эргэхдээ аль автомашинд зам тавьж өгөх шаардлагатай вэ?",
    "images": "/images/b/0e6bac5191f954c49d289438796c1e24.jpg",
    "tdate": "2019-03-18 13:54:27",
    "desc": ""
},
{
    "id": "771",
    "topics_id": "14",
    "code": "14.47",
    "questions": "Та зүүн гар тийш эргэхдээ аль автомашинд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/9303487c844d3b325c28492531d4e1ab.jpg",
    "tdate": "2019-03-18 14:01:02",
    "desc": ""
},
{
    "id": "772",
    "topics_id": "14",
    "code": "14.48",
    "questions": "Та зүүн гар тийш эргэхдээ аль автомашиныг өнгөрүүлэх вэ?",
    "images": "/images/b/50d8767d0961dac781425c51c9e75785.jpg",
    "tdate": "2019-03-18 14:03:32",
    "desc": ""
},
{
    "id": "773",
    "topics_id": "14",
    "code": "14.49",
    "questions": "Та тойрох хөдөлгөөнтэй уулзварт нийлэхдээ суудлын автомашинд зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/770b862c35a435502d3fbebea3756728.jpg",
    "tdate": "2019-03-18 14:08:01",
    "desc": ""
},
{
    "id": "774",
    "topics_id": "14",
    "code": "14.50",
    "questions": "Шар гэрэл дохио анивчиж байгаа энэ тохиолдолд та зүүн гар тийш эргэхдээ аль автомашинд зам тавьж өгөх шаардлагатай вэ?",
    "images": "/images/b/707c39714b39ab73bc57cbee5656d225.jpg",
    "tdate": "2019-03-18 14:10:24",
    "desc": ""
},
{
    "id": "775",
    "topics_id": "14",
    "code": "14.51",
    "questions": "Та зүүн гар тийш шороон зам руу эргэхдээ аль автомашинд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/d00bb96e1f249780a432bf9a012f4b9d.jpg",
    "tdate": "2019-03-18 15:02:55",
    "desc": ""
},
{
    "id": "776",
    "topics_id": "14",
    "code": "14.52",
    "questions": "Аль суудлын автомашины жолооч уулзварыг түрүүлж нэвтрэх вэ?",
    "images": "/images/b/6f5099ccf0f42c218055f8189d82223d.jpg",
    "tdate": "2019-03-18 15:06:00",
    "desc": ""
},
{
    "id": "777",
    "topics_id": "14",
    "code": "14.53",
    "questions": "Та чигээрээ явахдаа аль тээврийн хэрэгслээс түрүүлж нэвтрэх эрхтэй вэ?",
    "images": "/images/b/f6841a20e715c70cd071a10ede12dd6b.jpg",
    "tdate": "2019-03-18 15:09:24",
    "desc": ""
},
{
    "id": "778",
    "topics_id": "14",
    "code": "14.54",
    "questions": "Автобусны жолооч уулзварыг хэдийд нэвтрэх вэ?",
    "images": "/images/b/b0aef50be01841ce5a5f9114115efbf0.jpg",
    "tdate": "2019-03-18 15:12:57",
    "desc": ""
},
{
    "id": "779",
    "topics_id": "14",
    "code": "14.55",
    "questions": "Та зүүн гар тийш эргэхдээ өөдөөс яваа ердийн хөсөгт зам тавьж өгөх үүрэгтэй юу?",
    "images": "/images/b/90146bfbf9f1ff35505833f832aff3f2.jpg",
    "tdate": "2019-03-18 15:15:32",
    "desc": ""
},
{
    "id": "780",
    "topics_id": "14",
    "code": "14.56",
    "questions": "Та чигээрээ явахдаа суудлын автомашинд зам тавьж өгөх шаардлагатай юу?",
    "images": "/images/b/47d9e772f004ea3bd6b7e534e9d68524.jpg",
    "tdate": "2019-03-18 15:17:09",
    "desc": ""
},
{
    "id": "781",
    "topics_id": "14",
    "code": "14.57",
    "questions": "Та чигээрээ явахдаа аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/0070da68db19e55c51ca398d15bc319e.jpg",
    "tdate": "2019-03-18 15:18:50",
    "desc": ""
},
{
    "id": "784",
    "topics_id": "14",
    "code": "14.58",
    "questions": "Та зүүн гар тийш эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх вэ?",
    "images": "/images/b/a1494aeb1f0ae430b23b8a34bdf37bc2.jpg",
    "tdate": "2019-03-18 15:25:08",
    "desc": ""
},
{
    "id": "785",
    "topics_id": "14",
    "code": "14.59",
    "questions": "Та чигээрээ явахдаа:",
    "images": "/images/b/b49c969a9dce26f06e0b76a18d2304a0.jpg",
    "tdate": "2019-03-18 15:29:47",
    "desc": ""
},
{
    "id": "786",
    "topics_id": "14",
    "code": "14.60",
    "questions": "Та чигээрээ явахдаа:",
    "images": "/images/b/490af842a781d222db37f4d08f1829a8.jpg",
    "tdate": "2019-03-18 15:32:31",
    "desc": ""
},
{
    "id": "787",
    "topics_id": "14",
    "code": "14.61",
    "questions": "Та буцаж эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх вэ?",
    "images": "/images/b/8d48f315a1e46d1eebbf96c7dc7d586e.jpg",
    "tdate": "2019-03-18 15:34:57",
    "desc": ""
},
{
    "id": "788",
    "topics_id": "14",
    "code": "14.62",
    "questions": "Та чигээрээ явахдаа аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй  вэ?",
    "images": "/images/b/9d66c999eb52924d702aacb4fd9ec4aa.jpg",
    "tdate": "2019-03-18 15:37:30",
    "desc": ""
},
{
    "id": "789",
    "topics_id": "14",
    "code": "14.63",
    "questions": "Та чигээрээ явахдаа:",
    "images": "/images/b/5c4ae7a32a8075c1bfe93e12a43064de.jpg",
    "tdate": "2019-03-18 15:40:45",
    "desc": ""
},
{
    "id": "790",
    "topics_id": "14",
    "code": "14.64",
    "questions": "Та чигээрээ явахдаа:",
    "images": "/images/b/0cf77ebb7aa77ee1c2384a5798924a07.jpg",
    "tdate": "2019-03-18 15:44:48",
    "desc": ""
},
{
    "id": "791",
    "topics_id": "14",
    "code": "14.65",
    "questions": "Та зүүн гар тийш эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/8bbc3502eec0fde00691124d8c068880.jpg",
    "tdate": "2019-03-18 15:47:41",
    "desc": ""
},
{
    "id": "792",
    "topics_id": "14",
    "code": "14.66",
    "questions": "Та зүүн гар тийш эргэхдээ:",
    "images": "/images/b/c4f841600ecedeb6d13a05888f81cb47.jpg",
    "tdate": "2019-03-18 15:49:53",
    "desc": ""
},
{
    "id": "793",
    "topics_id": "6",
    "code": "6.1",
    "questions": "Гүйцэж түрүүлэх зорилгоор үргэлжилсэн шугаман тэмдэглэл давахыг зөвшөөрөх үү?",
    "images": "/images/b/5b6f6f3e35eaa0a51f8e9fd36ba31cc9.jpg",
    "tdate": "2019-03-18 16:09:15",
    "desc": ""
},
{
    "id": "794",
    "topics_id": "14",
    "code": "14.67",
    "questions": "Та уулзвар дээр буцаж эргэхдээ аль тээврийн хэрэгсэлд зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/b62ebf4e96f446276fc6090c147b67ae.jpg",
    "tdate": "2019-03-18 16:15:54",
    "desc": ""
},
{
    "id": "795",
    "topics_id": "6",
    "code": "6.2",
    "questions": "Уулзварын өмнө байр эзлэхдээ зурагт үзүүлсэн тэмдэглэлийг давахыг зөвшөөрөх үү?",
    "images": "/images/b/a324e42f1fa892e43a4ea96c75ec28ac.jpg",
    "tdate": "2019-03-18 16:16:52",
    "desc": ""
},
{
    "id": "796",
    "topics_id": "14",
    "code": "14.68",
    "questions": "Шар гэрэл дохио анивчиж байгаа энэ үед та зүүн гар тийш эргэхдээ:",
    "images": "/images/b/e2b4220e9fee60c49dff688fb86086c9.jpg",
    "tdate": "2019-03-18 16:18:28",
    "desc": ""
},
{
    "id": "797",
    "topics_id": "6",
    "code": "6.3",
    "questions": "Суудлын автомашины жолооч зурагт үзүүлснээр буцаж эргэсэн бол ямар зөрчил гаргасан бэ?",
    "images": "/images/b/63cde0554648386a088136f184700d65.jpg",
    "tdate": "2019-03-18 16:19:46",
    "desc": ""
},
{
    "id": "798",
    "topics_id": "14",
    "code": "14.69",
    "questions": "Тээврийн хэрэгслүүдийн уулзвар нэвтрэх дарааллыг заана уу?",
    "images": "/images/b/db36e4229263fa1c63ade409d4b2dc29.jpg",
    "tdate": "2019-03-18 16:20:13",
    "desc": ""
},
{
    "id": "803",
    "topics_id": "6",
    "code": "6.5",
    "questions": "Зурагт үзүүлснээр үргэлжилсэн шугаман тэмдэглэлийг давахаар бол гүйцэж түрүүлэх үйлдэл хийхийг зөвшөөрөх үү?",
    "images": "/images/b/0baf06efa87ce49873c997024382433c.jpg",
    "tdate": "2019-03-18 16:25:29",
    "desc": ""
},
{
    "id": "801",
    "topics_id": "14",
    "code": "14.70",
    "questions": "Тээврийн хэрэгслүүдийн уулзвар нэвтрэх дарааллыг заана уу?",
    "images": "/images/b/c67e847b3bf24bb4fb7d863391a08d17.jpg",
    "tdate": "2019-03-18 16:21:22",
    "desc": ""
},
{
    "id": "802",
    "topics_id": "6",
    "code": "6.4",
    "questions": "Зурагт үзүүлснээр чиглэлийн тээврийн хэрэгслийн эгнээ рүү орохыг зөвшөөрөх үү?",
    "images": "/images/b/c6365fee5a9906cd55e74b745a6f458e.jpg",
    "tdate": "2019-03-18 16:21:55",
    "desc": "Чиглэлийн тээврийн хэрэгслийн эгнээгээр суудлын такси явахыг зөвшөөрөх (ЗХД-ийн 11.10) боловч зурагт үзүүлснээр үргэлжилсэн шугаман тэмдэглэл (1.1) давж орохыг хориглоно."
},
{
    "id": "804",
    "topics_id": "6",
    "code": "6.6",
    "questions": "Аль тохиолдолд үргэлжилсэн шугаман тэмдэглэл давахыг зөвшөөрөх вэ?",
    "images": "/images/b/1ac2019e5c8aa3a67531df747d4b6a3e.jpg",
    "tdate": "2019-03-18 16:27:32",
    "desc": "Замын тухайн хэсэгт байрлуулсан тэмдэг, тэмдэглэлийн утга хоорондоо зөрж байвал тэмдгийн заалтыг  баримтална (ЗХД-ийн 7.5). Зурагт үзүүлснээр заах тэмдгийн заалтыг биелүүлэх (саадыг тойрон гарах)-ийн тулд үргэлжилсэн шугаман тэмдэглэлийг давахыг зөвшөөрөх бөгөөд харин буцаж эргэх нь тэмдгийн заалтыг биелүүлж байгаа үйлдэл биш тул хориглоно."
},
{
    "id": "805",
    "topics_id": "6",
    "code": "6.7",
    "questions": "Зогсохын тулд үргэлжилсэн шугаман тэмдэглэл давахыг зөвшөөрөх үү?",
    "images": "/images/b/cad022132939619e77b65b1024fd365c.jpg",
    "tdate": "2019-03-18 16:29:30",
    "desc": ""
},
{
    "id": "806",
    "topics_id": "6",
    "code": "6.8",
    "questions": "Зорчих хэсгийн захын үргэлжилсэн шугамыг давж буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/e6be1cafc6abfb1e25525c4c229e95ed.jpg",
    "tdate": "2019-03-18 16:31:04",
    "desc": ""
},
{
    "id": "807",
    "topics_id": "6",
    "code": "6.9",
    "questions": "Зурагт үзүүлсэн тасархай шугаман тэмдэглэлийн зураасууд уртсаж эхлэх нь юуг анхааруулах вэ?",
    "images": "/images/b/0102e449e642e9b0749b34864e8b30a2.jpg",
    "tdate": "2019-03-18 16:36:12",
    "desc": ""
},
{
    "id": "808",
    "topics_id": "6",
    "code": "6.10",
    "questions": "Уулзвар дээрх тэмдэглэл юуг илэрхийлэх вэ?",
    "images": "/images/b/98bcede4ec7abd82cfbc048ccf61449b.jpg",
    "tdate": "2019-03-18 16:41:59",
    "desc": ""
},
{
    "id": "809",
    "topics_id": "6",
    "code": "6.11",
    "questions": "Уулзвар дахь хөдөлгөөний эгнээний тэмдэглэлийг давж чигээрээ явахыг зөвшөөрөх үү?",
    "images": "/images/b/1c959ac5b27ecd600173b3ad0f170f1e.jpg",
    "tdate": "2019-03-18 16:43:35",
    "desc": ""
},
{
    "id": "810",
    "topics_id": "6",
    "code": "6.12",
    "questions": "Аль тээврийн хэрэгслийн жолооч зөрчил гаргаж байна вэ?",
    "images": "/images/b/b52ff03c4e1c3d077212333544cde8d9.jpg",
    "tdate": "2019-03-18 16:44:47",
    "desc": ""
},
{
    "id": "811",
    "topics_id": "6",
    "code": "6.13",
    "questions": "Зурагт үзүүлсэн тэмдэглэлийг давж гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/6bebd894a5c11354c39d607430df8a0e.jpg",
    "tdate": "2019-03-18 16:46:36",
    "desc": ""
},
{
    "id": "812",
    "topics_id": "6",
    "code": "6.14",
    "questions": "Зурагт үзүүлсэн тэмдэглэлийг давж гүйцэж түрүүлэхийг зөвшөөрөх үү?",
    "images": "/images/b/174abb8697a2f7d973c59d8d2b98ad6d.jpg",
    "tdate": "2019-03-18 16:48:14",
    "desc": ""
},
{
    "id": "813",
    "topics_id": "6",
    "code": "6.15",
    "questions": "Зурагт үзүүлсэн тэмдэглэлтэй хэсэгт зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/27c2562cda156ee135fe489692d8ae89.jpg",
    "tdate": "2019-03-18 16:50:39",
    "desc": ""
},
{
    "id": "814",
    "topics_id": "6",
    "code": "6.16",
    "questions": "Аль тээврийн хэрэгслийн түр зогсолтыг хориглох вэ?",
    "images": "/images/b/7305fbbbf616e20445feff61fd800aab.jpg",
    "tdate": "2019-03-18 16:52:04",
    "desc": ""
},
{
    "id": "815",
    "topics_id": "6",
    "code": "6.17",
    "questions": "Зурагт үзүүлсэн тэмдэглэлтэй хэсэгт түр зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/b365f153708846eaa94140caf2b363f8.jpg",
    "tdate": "2019-03-18 16:54:12",
    "desc": ""
},
{
    "id": "816",
    "topics_id": "6",
    "code": "6.18",
    "questions": "Хашлага дээрх тэмдэглэлтэй хэсэгт удаан зогсохыг зөвшөөрөх үү?",
    "images": "/images/b/ccbc150ce447fc1083787bec5e7694d0.jpg",
    "tdate": "2019-03-18 16:56:34",
    "desc": ""
},
{
    "id": "817",
    "topics_id": "6",
    "code": "6.19",
    "questions": "Энэ тэмдэг юуг илэрхийлэх вэ?",
    "images": "/images/b/7ebebd0357a27fb2f1fdfbf7370bf94f.jpg",
    "tdate": "2019-03-18 16:58:32",
    "desc": ""
},
{
    "id": "818",
    "topics_id": "6",
    "code": "6.20",
    "questions": "Зурагт үзүүлсэн тэмдэглэл дээгүүр явахыг зөвшөөрөх үү?",
    "images": "/images/b/7a0f8353f1fe3f96f22173ba882f2b46.jpg",
    "tdate": "2019-03-18 17:00:05",
    "desc": ""
},
{
    "id": "819",
    "topics_id": "6",
    "code": "6.21",
    "questions": "Зорчих хэсэг дээрх 'Зогс' гэсэн бичлэг ямар утга илэрхийлэх вэ?",
    "images": "/images/b/7bca47e594583ac7a3ca35d39caedab2.jpg",
    "tdate": "2019-03-18 17:45:02",
    "desc": ""
},
{
    "id": "820",
    "topics_id": "6",
    "code": "6.22",
    "questions": "Зорчих хэсэг дээрх 'Зогс-бичлэг' тэмдэглэл нь:",
    "images": "/images/b/c3126b335aa30d2aa105cf1727c619fb.jpg",
    "tdate": "2019-03-18 17:47:43",
    "desc": ""
},
{
    "id": "821",
    "topics_id": "6",
    "code": "6.23",
    "questions": "Энэ тэмдэглэл юуг анхааруулах вэ?",
    "images": "/images/b/cb95306fd527f40b45e1569b1bf94bfb.jpg",
    "tdate": "2019-03-18 17:49:42",
    "desc": ""
},
{
    "id": "822",
    "topics_id": "6",
    "code": "6.24",
    "questions": "Зорчих хэсэг дээрх хөдөлгөөний урсгалын өөдөөс чиглэсэн гурвалжин тэмдэглэл нь аль тэмдэглэлд ойртож байгааг анхааруулах вэ?",
    "images": "/images/b/ab949dfc262bcd03f314bbaa9d10f0c5.jpg",
    "tdate": "2019-03-18 17:54:16",
    "desc": ""
},
{
    "id": "823",
    "topics_id": "6",
    "code": "6.25",
    "questions": "Аль тээврийн хэрэгслийн жолооч зам тавьж өгөх үүрэгтэй вэ?",
    "images": "/images/b/fa192a67c536d754e28b154b5a249d62.jpg",
    "tdate": "2019-03-19 10:09:09",
    "desc": ""
},
{
    "id": "824",
    "topics_id": "6",
    "code": "6.26",
    "questions": "Мотоциклын жолооч зам тавьж өгөхийн тулд зогсох үйлдлийг зөв гүйцэтгэсэн үү?",
    "images": "/images/b/3884f3224f2b3be96aa9f85e7fccc416.jpg",
    "tdate": "2019-03-19 10:11:35",
    "desc": "Зэрэгцээ хэд хэдэн гурвалжингаас бүрдэх 1.12 хөндлөн тэмдэглэлийг жолоочийн зам тавьж өгөх газрыг нарийвчлан заах зорилгоор хэрэглэдэг. Энэ тохиолдолд жолооч зам тавьж өгөх үйлдлийг зөвхөн уг тэмдэглэлийн өмнө гүйцэтгэх шаардлагатай бөгөөд энэ нь хөндлөн замаар яваа тээврийн хэрэгслүүдэд саад учруулахгүй байх нөхцөлийг хангахаас гадна зэрэгцээ эгнээний тээврийн хэрэгслийн жолоочийн харах орчныг хязгаарлахгүй байх шаардлагатай холбоотой юм."
},
{
    "id": "825",
    "topics_id": "6",
    "code": "6.27",
    "questions": "Аль нь явган хүний гарцын тэмдэглэл вэ?",
    "images": "/images/b/6b7c3099a8fcf57b41c2865e2ac4d432.jpg",
    "tdate": "2019-03-19 10:12:35",
    "desc": ""
},
{
    "id": "826",
    "topics_id": "6",
    "code": "6.28",
    "questions": "Аль тээврийн хэрэгслийн хөдөлгөөнийг хориглох вэ?",
    "images": "/images/b/d4a1532447bd2a2c511dda62e171a5c1.jpg",
    "tdate": "2019-03-19 10:13:54",
    "desc": "'Чиг заагч сум' (1.17) тэмдэглэлээр зүүн гар тийш эргэхийг зөвшөөрсөн эгнээнүүдийн зөвхөн хамгийн зүүн гар талын захын эгнээнээс буцаж эргэхийг зөвшөөрнө. Иймд зурагт үзүүлсэн дунд эгнээнээс суудлын автомашин буцаж эргэхийг хориглоно.Ачааны автомашин тухайн эгнээнээс зөвхөн баруун гар тийш эргэх шаардлагатай бөгөөд чигээрээ явахыг хориглоно."
},
{
    "id": "827",
    "topics_id": "6",
    "code": "6.29",
    "questions": "Зурагт үзүүлсэн суман тэмдэглэл ямар утга илэрхийлэх вэ?",
    "images": "/images/b/1a16fe386b8f9365d0a413d626e9a9a4.jpg",
    "tdate": "2019-03-19 10:16:25",
    "desc": ""
},
{
    "id": "828",
    "topics_id": "6",
    "code": "6.30",
    "questions": "'Чиглүүлэгч сум' тэмдэглэл юуг анхааруулж байна вэ?",
    "images": "/images/b/18da2e3348278f53c90a0c7bdedc6f16.jpg",
    "tdate": "2019-03-19 10:19:05",
    "desc": ""
},
{
    "id": "829",
    "topics_id": "6",
    "code": "6.31",
    "questions": "Зурагт үзүүлсэн чиглүүлэгч арлын тэмдэглэл ямар утга илэрхийлэх вэ?",
    "images": "/images/b/5a6d3614b0f43e4dee9723e844ac77bc.jpg",
    "tdate": "2019-03-19 10:21:36",
    "desc": ""
},
{
    "id": "830",
    "topics_id": "6",
    "code": "6.32",
    "questions": "Зурагт үзүүлснээр буцаж эргэхийг зөвшөөрөх үү?",
    "images": "/images/b/3c2406a383ba72f5783563e9eeb2b02d.jpg",
    "tdate": "2019-03-19 10:22:30",
    "desc": ""
},
{
    "id": "831",
    "topics_id": "6",
    "code": "6.33",
    "questions": "Зорчих хэсэг дээрх энэ бичлэг юуг мэдээлэх вэ?",
    "images": "/images/b/71e62146f583a5784cd1a6bc35b539d2.jpg",
    "tdate": "2019-03-19 10:24:40",
    "desc": ""
},
{
    "id": "832",
    "topics_id": "6",
    "code": "6.34",
    "questions": "Тэмдэглэл ямар утга илэрхийлэх вэ?",
    "images": "/images/b/ba9f1a1c320d383979e8c707b6a68ff9.jpg",
    "tdate": "2019-03-19 10:26:59",
    "desc": "Зурагт 'Хурдны дээд хязгаарлал' (2.24) тэмдгийн хуулбар дүрсэн тэмдэглэлийг үзүүлжээ. Ийм тэмдэглэлийг цагаан өнгөөр хийсэн буюу тэмдгийн өнгөтэй нь ижилсүүлсэн байж болно."
},
{
    "id": "833",
    "topics_id": "6",
    "code": "6.35",
    "questions": "Аль чигт явахыг зөвшөөрөх вэ?",
    "images": "/images/b/445ffee771a95b1e00efdd05075a10fd.jpg",
    "tdate": "2019-03-19 10:28:45",
    "desc": "Замын тэмдэг, тэмдэглэлийн утга хоорондоо зөрж байвал тэмдгийн заалтыг баримтална (ЗХД-ийн 7.5)."
},
{
    "id": "834",
    "topics_id": "6",
    "code": "6.36",
    "questions": "Зорчих хэсэг дээрх цагаан ба улбар шар тэмдэглэлийн утга хоорондоо зөрж байвал жолооч алийг нь баримтлах вэ?",
    "images": "",
    "tdate": "2019-03-19 10:31:02",
    "desc": "Түр тэмдэглэл улбар шар өнгөтэй байх бөгөөд байнгын тэмдэглэлээс зөрүү утгатай байвал жолооч түр тэмдэглэлийн заалтыг баримтална.(ЗХД-ийн 7.5)."
},
{
    "id": "835",
    "topics_id": "6",
    "code": "6.37",
    "questions": "Гүүрний хашилтын нүүрэн талд тэмдэглэгдсэн босоо тэмдэглэл ямар утга илэрхийлэх вэ?",
    "images": "/images/b/64e34f2191f5168841c3375e6ee03e22.jpg",
    "tdate": "2019-03-19 10:34:29",
    "desc": ""
},
{
    "id": "836",
    "topics_id": "6",
    "code": "6.38",
    "questions": "Зурагт үзүүлсэн босоо тэмдэглэл юуг илэрхийлэх вэ?",
    "images": "/images/b/de0e714d42702cf88d6ddb7cf3e0c8e2.jpg",
    "tdate": "2019-03-19 10:37:37",
    "desc": ""
},
{
    "id": "837",
    "topics_id": "6",
    "code": "6.39",
    "questions": "Замын хашилтын хажуу гадаргуу дахь аль тэмдэглэл жолоочид замын аюул бүхий хэсгийг анхааруулах вэ?",
    "images": "/images/b/6a26fc29ef6de6b61e6b394cc3ed6ce2.jpg",
    "tdate": "2019-03-19 10:39:28",
    "desc": ""
},
{
    "id": "838",
    "topics_id": "6",
    "code": "6.40",
    "questions": "Замын хашлага дээрх босоо тэмдэглэл юуг илэрхийлэх вэ?",
    "images": "/images/b/b23f928e9729adb9ca3403ecdbf43a6e.jpg",
    "tdate": "2019-03-19 10:41:54",
    "desc": ""
}
]

export default tests
